// -- (function(scope){
// -- 'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.dK.cL === region.fQ.cL)
	{
		return 'on line ' + region.dK.cL;
	}
	return 'on lines ' + region.dK.cL + ' through ' + region.fQ.cL;
}



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.im,
		impl.jl,
		impl.ja,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


/*
function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}

*/

/*
function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}
*/


/*
function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}

*/

/*
function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}
*/




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS
//
// For some reason, tabs can appear in href protocols and it still works.
// So '\tjava\tSCRIPT:alert("!!!")' and 'javascript:alert("!!!")' are the same
// in practice. That is why _VirtualDom_RE_js and _VirtualDom_RE_js_html look
// so freaky.
//
// Pulling the regular expressions out to the top level gives a slight speed
// boost in small benchmarks (4-10%) but hoisting values to reduce allocation
// can be unpredictable in large programs where JIT may have a harder time with
// functions are not fully self-contained. The benefit is more that the js and
// js_html ones are so weird that I prefer to see them near each other.


var _VirtualDom_RE_script = /^script$/i;
var _VirtualDom_RE_on_formAction = /^(on|formAction$)/i;
var _VirtualDom_RE_js = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i;
var _VirtualDom_RE_js_html = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;


function _VirtualDom_noScript(tag)
{
	return _VirtualDom_RE_script.test(tag) ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return _VirtualDom_RE_on_formAction.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'outerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return _VirtualDom_RE_js.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return _VirtualDom_RE_js_html.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlJson(value)
{
	return (typeof _Json_unwrap(value) === 'string' && _VirtualDom_RE_js_html.test(_Json_unwrap(value)))
		? _Json_wrap(
			/**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		) : value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		bh: func(record.bh),
		fd: record.fd,
		e_: record.e_
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.bh;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.fd;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.e_) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.im,
		impl.jl,
		impl.ja,
		function(sendToApp, initialModel) {
			var view = impl.jn;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.im,
		impl.jl,
		impl.ja,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.e6 && impl.e6(sendToApp)
			var view = impl.jn;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.fC);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.cl) && (_VirtualDom_doc.title = title = doc.cl);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.iN;
	var onUrlRequest = impl.iO;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		e6: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.gR === next.gR
							&& curr.f1 === next.f1
							&& curr.gM.a === next.gM.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		im: function(flags)
		{
			return A3(impl.im, flags, _Browser_getUrl(), key);
		},
		jn: impl.jn,
		jl: impl.jl,
		ja: impl.ja
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { ik: 'hidden', hU: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { ik: 'mozHidden', hU: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { ik: 'msHidden', hU: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { ik: 'webkitHidden', hU: 'webkitvisibilitychange' }
		: { ik: 'hidden', hU: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		g2: _Browser_getScene(),
		ht: {
			hz: _Browser_window.pageXOffset,
			hA: _Browser_window.pageYOffset,
			fr: _Browser_doc.documentElement.clientWidth,
			eb: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		fr: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		eb: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			g2: {
				fr: node.scrollWidth,
				eb: node.scrollHeight
			},
			ht: {
				hz: node.scrollLeft,
				hA: node.scrollTop,
				fr: node.clientWidth,
				eb: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			g2: _Browser_getScene(),
			ht: {
				hz: x,
				hA: y,
				fr: _Browser_doc.documentElement.clientWidth,
				eb: _Browser_doc.documentElement.clientHeight
			},
			fP: {
				hz: x + rect.left,
				hA: y + rect.top,
				fr: rect.width,
				eb: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}




// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});


// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.iA) { flags += 'm'; }
	if (options.hS) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.fU.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.fU.b, xhr)); });
		$elm$core$Maybe$isJust(request.hm) && _Http_track(router, xhr, request.hm.a);

		try {
			xhr.open(request.go, request.hr, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.hr));
		}

		_Http_configureRequest(xhr, request);

		request.fC.a && xhr.setRequestHeader('Content-Type', request.fC.a);
		xhr.send(request.fC.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.f0; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.hj.a || 0;
	xhr.responseType = request.fU.d;
	xhr.withCredentials = request.hG;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		hr: xhr.responseURL,
		hb: xhr.status,
		i7: xhr.statusText,
		f0: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			i4: event.loaded,
			g7: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			iT: event.loaded,
			g7: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}


var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});
var $author$project$PriceListForm$ValidModel = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$List$cons = _List_cons;
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.D) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.G),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.G);
		} else {
			var treeLen = builder.D * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.L) : builder.L;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.D);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.G) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.G);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{L: nodeList, D: (len / $elm$core$Array$branchFactor) | 0, G: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {fY: fragment, f1: host, gH: path, gM: port_, gR: protocol, gS: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$element = _Browser_element;
var $author$project$PriceListForm$AdvancedClosed = {$: 0};
var $author$project$PriceListForm$ErrorModel = function (a) {
	return {$: 1, a: a};
};
var $author$project$PriceListForm$NoneForm = {$: 0};
var $krisajenkins$remotedata$RemoteData$NotAsked = {$: 0};
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $author$project$PriceListForm$Flags = function (csrfToken) {
	return function (locale) {
		return function (currency) {
			return function (id) {
				return function (name) {
					return function (supplier) {
						return function (energy) {
							return function (unit) {
								return function (regularCosts) {
									return function (exceptionalCosts) {
										return function (translations) {
											return function (distributors) {
												return {cx: csrfToken, bC: currency, bV: distributors, bY: energy, v: exceptionalCosts, f5: id, gl: locale, gu: name, n: regularCosts, ch: supplier, Z: translations, da: unit};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$PriceListForm$None = {$: 0};
var $author$project$PriceListForm$DK = $elm$core$Basics$identity;
var $author$project$PriceListForm$Distributor = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $elm$json$Json$Decode$field = _Json_decodeField;
var $pzp1997$assoc_list$AssocList$D = $elm$core$Basics$identity;
var $pzp1997$assoc_list$AssocList$empty = _List_Nil;
var $author$project$PriceListForm$noSelections = $pzp1997$assoc_list$AssocList$empty;
var $author$project$PriceListForm$noValues = $pzp1997$assoc_list$AssocList$empty;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (path, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2(
				$elm$json$Json$Decode$decodeValue,
				A2($elm$json$Json$Decode$at, path, $elm$json$Json$Decode$value),
				input);
			if (!_v0.$) {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_v1.$) {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					return A2(
						$elm$json$Json$Decode$at,
						path,
						nullOr(valDecoder));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				_List_fromArray(
					[key]),
				valDecoder,
				fallback),
			decoder);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $author$project$PriceListForm$Selection = $elm$core$Basics$identity;
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $elm$core$Basics$neq = _Utils_notEqual;
var $pzp1997$assoc_list$AssocList$remove = F2(
	function (targetKey, _v0) {
		var alist = _v0;
		return A2(
			$elm$core$List$filter,
			function (_v1) {
				var key = _v1.a;
				return !_Utils_eq(key, targetKey);
			},
			alist);
	});
var $pzp1997$assoc_list$AssocList$insert = F3(
	function (key, value, dict) {
		var _v0 = A2($pzp1997$assoc_list$AssocList$remove, key, dict);
		var alteredAlist = _v0;
		return A2(
			$elm$core$List$cons,
			_Utils_Tuple2(key, value),
			alteredAlist);
	});
var $pzp1997$assoc_list$AssocList$fromList = function (alist) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, result) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($pzp1997$assoc_list$AssocList$insert, key, value, result);
			}),
		_List_Nil,
		alist);
};
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$PriceListForm$selectionsDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$map(
			$elm$core$Tuple$mapFirst($elm$core$Basics$identity)),
		$pzp1997$assoc_list$AssocList$fromList),
	$elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$string));
var $author$project$PriceListForm$ElBreakerPhases = 7;
var $author$project$PriceListForm$ElCircuitBreaker = 3;
var $author$project$PriceListForm$ElConsumption = 2;
var $author$project$PriceListForm$ElDistributionRate = 4;
var $author$project$PriceListForm$ElReservedCapacity = 5;
var $author$project$PriceListForm$ElReservedWattage = 6;
var $author$project$PriceListForm$ManualMonthlyValue = 1;
var $author$project$PriceListForm$Month = 0;
var $author$project$PriceListForm$dependencyFromString = function (str) {
	switch (str) {
		case 'mesic':
			return $elm$core$Result$Ok(0);
		case 'manual_month':
			return $elm$core$Result$Ok(1);
		case 'spotreba_el':
			return $elm$core$Result$Ok(2);
		case 'hlavni_jistic':
			return $elm$core$Result$Ok(3);
		case 'distr_sazba':
			return $elm$core$Result$Ok(4);
		case 'rezervovana_kap_ele':
			return $elm$core$Result$Ok(5);
		case 'reserved_el_wattage':
			return $elm$core$Result$Ok(6);
		case 'faze_jistice':
			return $elm$core$Result$Ok(7);
		default:
			return $elm$core$Result$Err('unrecognized dep ' + str);
	}
};
var $elm$json$Json$Decode$fail = _Json_fail;
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $author$project$PriceListForm$valuesDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (list) {
		return function (resultDict) {
			if (resultDict.$ === 1) {
				var err = resultDict.a;
				return $elm$json$Json$Decode$fail(err);
			} else {
				var dict = resultDict.a;
				return $elm$json$Json$Decode$succeed(dict);
			}
		}(
			A3(
				$elm$core$List$foldl,
				F2(
					function (_v0, resultDict) {
						var dep = _v0.a;
						var value = _v0.b;
						var _v1 = _Utils_Tuple2(
							resultDict,
							$author$project$PriceListForm$dependencyFromString(dep));
						if (_v1.a.$ === 1) {
							if (_v1.b.$ === 1) {
								var err1 = _v1.a.a;
								var err2 = _v1.b.a;
								return $elm$core$Result$Err(err1 + (' ' + err2));
							} else {
								var err = _v1.a.a;
								return $elm$core$Result$Err(err);
							}
						} else {
							if (_v1.b.$ === 1) {
								var err = _v1.b.a;
								return $elm$core$Result$Err(err);
							} else {
								var dict = _v1.a.a;
								var d = _v1.b.a;
								return $elm$core$Result$Ok(
									A3($pzp1997$assoc_list$AssocList$insert, d, value, dict));
							}
						}
					}),
				$elm$core$Result$Ok($author$project$PriceListForm$noValues),
				list));
	},
	$elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$float));
var $author$project$PriceListForm$distributorComponentDecoder = A2(
	$elm$json$Json$Decode$field,
	'advanced_component',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'line_item_values',
		$author$project$PriceListForm$valuesDecoder,
		$author$project$PriceListForm$noValues,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'selections',
			$author$project$PriceListForm$selectionsDecoder,
			$author$project$PriceListForm$noSelections,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'distributor',
				A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string),
				$elm$json$Json$Decode$succeed($author$project$PriceListForm$Distributor)))));
var $author$project$PriceListForm$FixedMonthly = function (a) {
	return {$: 1, a: a};
};
var $author$project$PriceListForm$fixedMonthlyDecoder = A2(
	$elm$json$Json$Decode$field,
	'fixed_payment',
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'amount',
		$elm$json$Json$Decode$float,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'period',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed(
				F2(
					function (p, a) {
						if (p === 'month') {
							return $author$project$PriceListForm$FixedMonthly(a);
						} else {
							return $author$project$PriceListForm$None;
						}
					})))));
var $author$project$PriceListForm$advancedComponentDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			$author$project$PriceListForm$distributorComponentDecoder,
			$author$project$PriceListForm$fixedMonthlyDecoder,
			$elm$json$Json$Decode$succeed($author$project$PriceListForm$None)
		]));
var $author$project$PriceListForm$costDataFromServer = F4(
	function (from, to, advanced, tariffs) {
		return {z: advanced, f: tariffs, S: from, I: to};
	});
var $justinmimbs$date$Date$RD = $elm$core$Basics$identity;
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $elm$core$Basics$modBy = _Basics_modBy;
var $justinmimbs$date$Date$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $justinmimbs$date$Date$daysBeforeMonth = F2(
	function (y, m) {
		var leapDays = $justinmimbs$date$Date$isLeapYear(y) ? 1 : 0;
		switch (m) {
			case 0:
				return 0;
			case 1:
				return 31;
			case 2:
				return 59 + leapDays;
			case 3:
				return 90 + leapDays;
			case 4:
				return 120 + leapDays;
			case 5:
				return 151 + leapDays;
			case 6:
				return 181 + leapDays;
			case 7:
				return 212 + leapDays;
			case 8:
				return 243 + leapDays;
			case 9:
				return 273 + leapDays;
			case 10:
				return 304 + leapDays;
			default:
				return 334 + leapDays;
		}
	});
var $justinmimbs$date$Date$floorDiv = F2(
	function (a, b) {
		return $elm$core$Basics$floor(a / b);
	});
var $justinmimbs$date$Date$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = (A2($justinmimbs$date$Date$floorDiv, y, 4) - A2($justinmimbs$date$Date$floorDiv, y, 100)) + A2($justinmimbs$date$Date$floorDiv, y, 400);
	return (365 * y) + leapYears;
};
var $justinmimbs$date$Date$daysInMonth = F2(
	function (y, m) {
		switch (m) {
			case 0:
				return 31;
			case 1:
				return $justinmimbs$date$Date$isLeapYear(y) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $justinmimbs$date$Date$fromCalendarDate = F3(
	function (y, m, d) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A3(
			$elm$core$Basics$clamp,
			1,
			A2($justinmimbs$date$Date$daysInMonth, y, m),
			d);
	});
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.dK, posixMinutes) < 0) {
					return posixMinutes + era.iM;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$core$Basics$ge = _Utils_ge;
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		fJ: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		gr: month,
		hB: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).fJ;
	});
var $elm$time$Time$Apr = 3;
var $elm$time$Time$Aug = 7;
var $elm$time$Time$Dec = 11;
var $elm$time$Time$Feb = 1;
var $elm$time$Time$Jan = 0;
var $elm$time$Time$Jul = 6;
var $elm$time$Time$Jun = 5;
var $elm$time$Time$Mar = 2;
var $elm$time$Time$May = 4;
var $elm$time$Time$Nov = 10;
var $elm$time$Time$Oct = 9;
var $elm$time$Time$Sep = 8;
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).gr;
		switch (_v0) {
			case 1:
				return 0;
			case 2:
				return 1;
			case 3:
				return 2;
			case 4:
				return 3;
			case 5:
				return 4;
			case 6:
				return 5;
			case 7:
				return 6;
			case 8:
				return 7;
			case 9:
				return 8;
			case 10:
				return 9;
			case 11:
				return 10;
			default:
				return 11;
		}
	});
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).hB;
	});
var $justinmimbs$date$Date$fromPosix = F2(
	function (zone, posix) {
		return A3(
			$justinmimbs$date$Date$fromCalendarDate,
			A2($elm$time$Time$toYear, zone, posix),
			A2($elm$time$Time$toMonth, zone, posix),
			A2($elm$time$Time$toDay, zone, posix));
	});
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0;
		return function (s0) {
			var _v1 = parseA(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				var _v2 = callback(a);
				var parseB = _v2;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$parser$Parser$UnexpectedChar = {$: 11};
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {fG: col, h_: contextStack, gO: problem, g_: row};
	});
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.g_, s.fG, x, s.i));
	});
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.iM, s.d);
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{fG: 1, i: s.i, m: s.m, iM: s.iM + 1, g_: s.g_ + 1, d: s.d}) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{fG: s.fG + 1, i: s.i, m: s.m, iM: newOffset, g_: s.g_, d: s.d}));
		};
	});
var $elm$parser$Parser$chompIf = function (isGood) {
	return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
};
var $justinmimbs$date$Date$deadEndToString = function (_v0) {
	var problem = _v0.gO;
	if (problem.$ === 12) {
		var message = problem.a;
		return message;
	} else {
		return 'Expected a date in ISO 8601 format';
	}
};
var $elm$parser$Parser$ExpectingEnd = {$: 10};
var $elm$parser$Parser$Advanced$end = function (x) {
	return function (s) {
		return _Utils_eq(
			$elm$core$String$length(s.d),
			s.iM) ? A3($elm$parser$Parser$Advanced$Good, false, 0, s) : A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0;
		var parseB = _v1;
		return function (s0) {
			var _v2 = parseA(s0);
			if (_v2.$ === 1) {
				var p = _v2.a;
				var x = _v2.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v2.a;
				var a = _v2.b;
				var s1 = _v2.c;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (!_v1.$) {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $justinmimbs$date$Date$MonthAndDay = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $justinmimbs$date$Date$OrdinalDay = function (a) {
	return {$: 2, a: a};
};
var $justinmimbs$date$Date$WeekAndWeekday = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
	var parse = _v0;
	return function (s0) {
		var _v1 = parse(s0);
		if (_v1.$ === 1) {
			var x = _v1.b;
			return A2($elm$parser$Parser$Advanced$Bad, false, x);
		} else {
			var a = _v1.b;
			var s1 = _v1.c;
			return A3($elm$parser$Parser$Advanced$Good, false, a, s1);
		}
	};
};
var $elm$parser$Parser$backtrackable = $elm$parser$Parser$Advanced$backtrackable;
var $elm$parser$Parser$Advanced$commit = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, true, a, s);
	};
};
var $elm$parser$Parser$commit = $elm$parser$Parser$Advanced$commit;
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3($elm$core$String$slice, s0.iM, s1.iM, s0.d),
						a),
					s1);
			}
		};
	});
var $elm$parser$Parser$mapChompedString = $elm$parser$Parser$Advanced$mapChompedString;
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $justinmimbs$date$Date$int1 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	$elm$parser$Parser$chompIf($elm$core$Char$isDigit));
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $justinmimbs$date$Date$int2 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed(0),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$int3 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$core$Basics$not = _Basics_not;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.iM, s.g_, s.fG, s.d);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{fG: newCol, i: s.i, m: s.m, iM: newOffset, g_: newRow, d: s.d});
	};
};
var $elm$parser$Parser$token = function (str) {
	return $elm$parser$Parser$Advanced$token(
		$elm$parser$Parser$toToken(str));
};
var $justinmimbs$date$Date$dayOfYear = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed($elm$core$Basics$identity),
				$elm$parser$Parser$token('-')),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$backtrackable(
						A2(
							$elm$parser$Parser$andThen,
							$elm$parser$Parser$commit,
							A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int2),
									$elm$parser$Parser$succeed(1)
								]))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$ignorer,
								$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
								$elm$parser$Parser$token('W')),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int1),
									$elm$parser$Parser$succeed(1)
								])))
					]))),
			$elm$parser$Parser$backtrackable(
			A2(
				$elm$parser$Parser$andThen,
				$elm$parser$Parser$commit,
				A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
						$justinmimbs$date$Date$int2),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$justinmimbs$date$Date$int2,
								$elm$parser$Parser$succeed(1)
							]))))),
			A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3),
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
					$elm$parser$Parser$token('W')),
				$justinmimbs$date$Date$int2),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$justinmimbs$date$Date$int1,
						$elm$parser$Parser$succeed(1)
					]))),
			$elm$parser$Parser$succeed(
			$justinmimbs$date$Date$OrdinalDay(1))
		]));
var $justinmimbs$date$Date$isBetweenInt = F3(
	function (a, b, x) {
		return (_Utils_cmp(a, x) < 1) && (_Utils_cmp(x, b) < 1);
	});
var $justinmimbs$date$Date$monthToName = function (m) {
	switch (m) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $justinmimbs$date$Date$numberToMonth = function (mn) {
	var _v0 = A2($elm$core$Basics$max, 1, mn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		case 7:
			return 6;
		case 8:
			return 7;
		case 9:
			return 8;
		case 10:
			return 9;
		case 11:
			return 10;
		default:
			return 11;
	}
};
var $justinmimbs$date$Date$fromCalendarParts = F3(
	function (y, mn, d) {
		return (!A3($justinmimbs$date$Date$isBetweenInt, 1, 12, mn)) ? $elm$core$Result$Err(
			'Invalid date: ' + (('month ' + ($elm$core$String$fromInt(mn) + ' is out of range')) + (' (1 to 12)' + ('; received (year ' + ($elm$core$String$fromInt(y) + (', month ' + ($elm$core$String$fromInt(mn) + (', day ' + ($elm$core$String$fromInt(d) + ')'))))))))) : ((!A3(
			$justinmimbs$date$Date$isBetweenInt,
			1,
			A2(
				$justinmimbs$date$Date$daysInMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn)),
			d)) ? $elm$core$Result$Err(
			'Invalid date: ' + (('day ' + ($elm$core$String$fromInt(d) + ' is out of range')) + ((' (1 to ' + ($elm$core$String$fromInt(
				A2(
					$justinmimbs$date$Date$daysInMonth,
					y,
					$justinmimbs$date$Date$numberToMonth(mn))) + ')')) + ((' for ' + $justinmimbs$date$Date$monthToName(
				$justinmimbs$date$Date$numberToMonth(mn))) + ((((mn === 2) && (d === 29)) ? (' (' + ($elm$core$String$fromInt(y) + ' is not a leap year)')) : '') + ('; received (year ' + ($elm$core$String$fromInt(y) + (', month ' + ($elm$core$String$fromInt(mn) + (', day ' + ($elm$core$String$fromInt(d) + ')'))))))))))) : $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeYear(y) + A2(
				$justinmimbs$date$Date$daysBeforeMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn))) + d));
	});
var $justinmimbs$date$Date$fromOrdinalParts = F2(
	function (y, od) {
		var daysInYear = $justinmimbs$date$Date$isLeapYear(y) ? 366 : 365;
		return (!A3($justinmimbs$date$Date$isBetweenInt, 1, daysInYear, od)) ? $elm$core$Result$Err(
			'Invalid ordinal date: ' + (('ordinal-day ' + ($elm$core$String$fromInt(od) + ' is out of range')) + ((' (1 to ' + ($elm$core$String$fromInt(daysInYear) + ')')) + ((' for ' + $elm$core$String$fromInt(y)) + ('; received (year ' + ($elm$core$String$fromInt(y) + (', ordinal-day ' + ($elm$core$String$fromInt(od) + ')')))))))) : $elm$core$Result$Ok(
			$justinmimbs$date$Date$daysBeforeYear(y) + od);
	});
var $justinmimbs$date$Date$weekdayNumber = function (_v0) {
	var rd = _v0;
	var _v1 = A2($elm$core$Basics$modBy, 7, rd);
	if (!_v1) {
		return 7;
	} else {
		var n = _v1;
		return n;
	}
};
var $justinmimbs$date$Date$daysBeforeWeekYear = function (y) {
	var jan4 = $justinmimbs$date$Date$daysBeforeYear(y) + 4;
	return jan4 - $justinmimbs$date$Date$weekdayNumber(jan4);
};
var $justinmimbs$date$Date$firstOfYear = function (y) {
	return $justinmimbs$date$Date$daysBeforeYear(y) + 1;
};
var $justinmimbs$date$Date$is53WeekYear = function (y) {
	var wdnJan1 = $justinmimbs$date$Date$weekdayNumber(
		$justinmimbs$date$Date$firstOfYear(y));
	return (wdnJan1 === 4) || ((wdnJan1 === 3) && $justinmimbs$date$Date$isLeapYear(y));
};
var $justinmimbs$date$Date$fromWeekParts = F3(
	function (wy, wn, wdn) {
		var weeksInYear = $justinmimbs$date$Date$is53WeekYear(wy) ? 53 : 52;
		return (!A3($justinmimbs$date$Date$isBetweenInt, 1, weeksInYear, wn)) ? $elm$core$Result$Err(
			'Invalid week date: ' + (('week ' + ($elm$core$String$fromInt(wn) + ' is out of range')) + ((' (1 to ' + ($elm$core$String$fromInt(weeksInYear) + ')')) + ((' for ' + $elm$core$String$fromInt(wy)) + ('; received (year ' + ($elm$core$String$fromInt(wy) + (', week ' + ($elm$core$String$fromInt(wn) + (', weekday ' + ($elm$core$String$fromInt(wdn) + ')')))))))))) : ((!A3($justinmimbs$date$Date$isBetweenInt, 1, 7, wdn)) ? $elm$core$Result$Err(
			'Invalid week date: ' + (('weekday ' + ($elm$core$String$fromInt(wdn) + ' is out of range')) + (' (1 to 7)' + ('; received (year ' + ($elm$core$String$fromInt(wy) + (', week ' + ($elm$core$String$fromInt(wn) + (', weekday ' + ($elm$core$String$fromInt(wdn) + ')'))))))))) : $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeWeekYear(wy) + ((wn - 1) * 7)) + wdn));
	});
var $justinmimbs$date$Date$fromYearAndDayOfYear = function (_v0) {
	var y = _v0.a;
	var doy = _v0.b;
	switch (doy.$) {
		case 0:
			var mn = doy.a;
			var d = doy.b;
			return A3($justinmimbs$date$Date$fromCalendarParts, y, mn, d);
		case 1:
			var wn = doy.a;
			var wdn = doy.b;
			return A3($justinmimbs$date$Date$fromWeekParts, y, wn, wdn);
		default:
			var od = doy.a;
			return A2($justinmimbs$date$Date$fromOrdinalParts, y, od);
	}
};
var $justinmimbs$date$Date$int4 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed(0),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									$elm$parser$Parser$chompIf(
									function (c) {
										return c === '-';
									}),
									$elm$parser$Parser$succeed(0)
								]))),
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $justinmimbs$date$Date$resultToParser = function (result) {
	if (!result.$) {
		var x = result.a;
		return $elm$parser$Parser$succeed(x);
	} else {
		var message = result.a;
		return $elm$parser$Parser$problem(message);
	}
};
var $justinmimbs$date$Date$parser = A2(
	$elm$parser$Parser$andThen,
	A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromYearAndDayOfYear, $justinmimbs$date$Date$resultToParser),
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Tuple$pair),
			$justinmimbs$date$Date$int4),
		$justinmimbs$date$Date$dayOfYear));
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {fG: col, gO: problem, g_: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.g_, p.fG, p.gO);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0;
		var _v1 = parse(
			{fG: 1, i: _List_Nil, m: 1, iM: 0, g_: 1, d: src});
		if (!_v1.$) {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (!_v0.$) {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $justinmimbs$date$Date$fromIsoString = A2(
	$elm$core$Basics$composeR,
	$elm$parser$Parser$run(
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			A2(
				$elm$parser$Parser$ignorer,
				$justinmimbs$date$Date$parser,
				A2(
					$elm$parser$Parser$andThen,
					$justinmimbs$date$Date$resultToParser,
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2($elm$parser$Parser$map, $elm$core$Result$Ok, $elm$parser$Parser$end),
								A2(
								$elm$parser$Parser$map,
								$elm$core$Basics$always(
									$elm$core$Result$Err('Expected a date only, not a date and time')),
								$elm$parser$Parser$chompIf(
									$elm$core$Basics$eq('T'))),
								$elm$parser$Parser$succeed(
								$elm$core$Result$Err('Expected a date only'))
							])))))),
	$elm$core$Result$mapError(
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$head,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map($justinmimbs$date$Date$deadEndToString),
				$elm$core$Maybe$withDefault('')))));
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {ek: index, it: match, dz: number, he: submatches};
	});
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{hS: false, iA: false},
		string);
};
var $elm$regex$Regex$replace = _Regex_replaceAtMost(_Regex_infinity);
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $author$project$Enectiva$Conversion$parseStdDateWithFallback = F2(
	function (fallback, str) {
		return A2(
			$elm$core$Result$withDefault,
			fallback,
			$justinmimbs$date$Date$fromIsoString(
				function () {
					var _v0 = $elm$regex$Regex$fromString('T.+$');
					if (_v0.$ === 1) {
						return str;
					} else {
						var regex = _v0.a;
						return A3(
							$elm$regex$Regex$replace,
							regex,
							$elm$core$Basics$always(''),
							str);
					}
				}()));
	});
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
var $author$project$Enectiva$Conversion$parseStdDate = $author$project$Enectiva$Conversion$parseStdDateWithFallback(
	A2(
		$justinmimbs$date$Date$fromPosix,
		$elm$time$Time$utc,
		$elm$time$Time$millisToPosix(0)));
var $author$project$Enectiva$Conversion$dateDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		return $elm$json$Json$Decode$succeed(
			$author$project$Enectiva$Conversion$parseStdDate(s));
	},
	$elm$json$Json$Decode$string);
var $turboMaCk$non_empty_list_alias$List$NonEmpty$fromList = function (xs) {
	if (xs.b) {
		var h = xs.a;
		var t = xs.b;
		return $elm$core$Maybe$Just(
			_Utils_Tuple2(h, t));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $turboMaCk$non_empty_list_alias$List$NonEmpty$decodeListHelper = function (xs) {
	var _v0 = $turboMaCk$non_empty_list_alias$List$NonEmpty$fromList(xs);
	if (!_v0.$) {
		var res = _v0.a;
		return $elm$json$Json$Decode$succeed(res);
	} else {
		return $elm$json$Json$Decode$fail('Expecting at least ONE ELEMENT array');
	}
};
var $elm$json$Json$Decode$list = _Json_decodeList;
var $turboMaCk$non_empty_list_alias$List$NonEmpty$decodeList = function (decoder) {
	return A2(
		$elm$json$Json$Decode$andThen,
		$turboMaCk$non_empty_list_alias$List$NonEmpty$decodeListHelper,
		$elm$json$Json$Decode$list(decoder));
};
var $author$project$PriceListForm$Tariff = F3(
	function (name, unitPrice, periods) {
		return {gu: name, s: periods, _: unitPrice};
	});
var $author$project$PriceListForm$Period = function (from) {
	return {q: from};
};
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $author$project$PriceListForm$periodDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'valid_from',
	$elm$json$Json$Decode$int,
	$elm$json$Json$Decode$succeed($author$project$PriceListForm$Period));
var $author$project$PriceListForm$tariffDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'periods',
	$turboMaCk$non_empty_list_alias$List$NonEmpty$decodeList($author$project$PriceListForm$periodDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'price_per_unit',
		$elm$json$Json$Decode$float,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$PriceListForm$Tariff))));
var $author$project$PriceListForm$costDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'tariffs',
	$turboMaCk$non_empty_list_alias$List$NonEmpty$decodeList($author$project$PriceListForm$tariffDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'component',
		$author$project$PriceListForm$advancedComponentDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'valid_to',
			$author$project$Enectiva$Conversion$dateDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'valid_from',
				$author$project$Enectiva$Conversion$dateDecoder,
				$elm$json$Json$Decode$succeed($author$project$PriceListForm$costDataFromServer)))));
var $author$project$PriceListForm$distributorsDecoder = A2(
	$elm$json$Json$Decode$map,
	$pzp1997$assoc_list$AssocList$fromList,
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$List$map(
			$elm$core$Tuple$mapFirst($elm$core$Basics$identity)),
		$elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$string)));
var $author$project$Enectiva$Conversion$decodeResult = function (result) {
	if (!result.$) {
		var a = result.a;
		return $elm$json$Json$Decode$succeed(a);
	} else {
		var err = result.a;
		return $elm$json$Json$Decode$fail(err);
	}
};
var $author$project$Types$Co = 5;
var $author$project$Types$El = 1;
var $author$project$Types$Ga = 2;
var $author$project$Types$Hca = 6;
var $author$project$Types$He = 4;
var $author$project$Types$Lf = 7;
var $author$project$Types$Wa = 3;
var $author$project$Types$energyFromString = function (str) {
	switch (str) {
		case 'el':
			return $elm$core$Result$Ok(1);
		case 'ga':
			return $elm$core$Result$Ok(2);
		case 'wa':
			return $elm$core$Result$Ok(3);
		case 'he':
			return $elm$core$Result$Ok(4);
		case 'co':
			return $elm$core$Result$Ok(5);
		case 'hca':
			return $elm$core$Result$Ok(6);
		case 'lf':
			return $elm$core$Result$Ok(7);
		default:
			return $elm$core$Result$Err('unknown energy ' + str);
	}
};
var $author$project$Types$energyDecoder = A3(
	$elm$core$Basics$composeR,
	$elm$json$Json$Decode$map($author$project$Types$energyFromString),
	$elm$json$Json$Decode$andThen($author$project$Enectiva$Conversion$decodeResult),
	$elm$json$Json$Decode$string);
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $author$project$PriceListForm$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'distributors',
	$author$project$PriceListForm$distributorsDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'translations',
		$elm$json$Json$Decode$value,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'exceptional_costs',
			$elm$json$Json$Decode$maybe(
				$turboMaCk$non_empty_list_alias$List$NonEmpty$decodeList($author$project$PriceListForm$costDecoder)),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'regular_costs',
				$turboMaCk$non_empty_list_alias$List$NonEmpty$decodeList($author$project$PriceListForm$costDecoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'unit',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'energy',
						$author$project$Types$energyDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'supplier',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'name',
								$elm$json$Json$Decode$string,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'id',
									$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
									$elm$core$Maybe$Nothing,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'currency',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'locale',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'csrfToken',
												$elm$json$Json$Decode$string,
												$elm$json$Json$Decode$succeed($author$project$PriceListForm$Flags)))))))))))));
var $author$project$Enectiva$I18n$Translations = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Enectiva$I18n$newTranslations = $author$project$Enectiva$I18n$Translations;
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $author$project$Enectiva$Util$noCmd = function (model) {
	return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
};
var $author$project$PriceListForm$init = function (json) {
	return $author$project$Enectiva$Util$noCmd(
		function () {
			var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$PriceListForm$flagsDecoder, json);
			if (!_v0.$) {
				var flags = _v0.a;
				return $author$project$PriceListForm$ValidModel(
					{
						z: {aY: $author$project$PriceListForm$AdvancedClosed, B: $author$project$PriceListForm$NoneForm},
						cx: flags.cx,
						bC: flags.bC,
						bV: flags.bV,
						ah: $elm$core$Maybe$Nothing,
						bY: flags.bY,
						v: flags.v,
						f5: flags.f5,
						gu: flags.gu,
						n: flags.n,
						cX: $krisajenkins$remotedata$RemoteData$NotAsked,
						ch: flags.ch,
						Z: A2($author$project$Enectiva$I18n$newTranslations, flags.gl, flags.Z),
						da: flags.da
					});
			} else {
				var err = _v0.a;
				return $author$project$PriceListForm$ErrorModel(
					$elm$json$Json$Decode$errorToString(err));
			}
		}());
};
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $author$project$PriceListForm$IrrelevantPortMessaged = {$: 0};
var $author$project$PriceListForm$appName = 'plf';
var $author$project$PriceListForm$EscapePressed = function (a) {
	return {$: 14, a: a};
};
var $author$project$Ports$escapePressed = _Platform_incomingPort('escapePressed', $elm$json$Json$Decode$value);
var $author$project$PriceListForm$AdvancedComponentDialog = 1;
var $author$project$PriceListForm$CostEditingDialog = 0;
var $author$project$PriceListForm$ELPowerBreakdownDialog = 2;
var $author$project$PriceListForm$mostImportantOpenDialog = function (model) {
	var _v0 = model.ah;
	if (!_v0.$) {
		return $elm$core$Maybe$Just(0);
	} else {
		var advanced = model.z;
		var _v1 = _Utils_Tuple2(advanced.B, advanced.aY);
		if (((_v1.a.$ === 2) && (_v1.a.b.$ === 3)) && (!_v1.a.b.a.c)) {
			var _v2 = _v1.a;
			var _v3 = _v2.b.a;
			var _v4 = _v3.c;
			return $elm$core$Maybe$Just(2);
		} else {
			if (_v1.b.$ === 1) {
				var _v5 = _v1.b;
				return $elm$core$Maybe$Just(1);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}
	}
};
var $author$project$PriceListForm$escapePressedToCloseDialog = function (model) {
	var _v0 = $author$project$PriceListForm$mostImportantOpenDialog(model);
	if (_v0.$ === 1) {
		return $elm$core$Platform$Sub$none;
	} else {
		var dialog = _v0.a;
		return $author$project$Ports$escapePressed(
			$elm$core$Basics$always(
				$author$project$PriceListForm$EscapePressed(dialog)));
	}
};
var $author$project$Enectiva$I18n$matchNumber = F2(
	function (m, ms) {
		return _Utils_update(
			ms,
			{dz: m});
	});
var $author$project$Enectiva$I18n$emptyParsingMatcher = F2(
	function (_v0, _v1) {
		return $elm$core$Maybe$Nothing;
	});
var $author$project$Enectiva$I18n$matchers = {di: $author$project$Enectiva$I18n$emptyParsingMatcher, dj: $author$project$Enectiva$I18n$emptyParsingMatcher, dk: $author$project$Enectiva$I18n$emptyParsingMatcher, dz: $author$project$Enectiva$I18n$emptyParsingMatcher};
var $author$project$Enectiva$I18n$ParsedDate = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Enectiva$I18n$ParsedDateRange = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Enectiva$I18n$ParsedDateTime = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Enectiva$I18n$ParsedNumber = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Enectiva$I18n$ParsingError = function (a) {
	return {$: 4, a: a};
};
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $rtfeldman$elm_iso8601_date_strings$DeadEnds$problemToString = function (p) {
	switch (p.$) {
		case 0:
			var s = p.a;
			return 'expecting \'' + (s + '\'');
		case 1:
			return 'expecting int';
		case 2:
			return 'expecting hex';
		case 3:
			return 'expecting octal';
		case 4:
			return 'expecting binary';
		case 5:
			return 'expecting float';
		case 6:
			return 'expecting number';
		case 7:
			return 'expecting variable';
		case 8:
			var s = p.a;
			return 'expecting symbol \'' + (s + '\'');
		case 9:
			var s = p.a;
			return 'expecting keyword \'' + (s + '\'');
		case 10:
			return 'expecting end';
		case 11:
			return 'unexpected char';
		case 12:
			var s = p.a;
			return 'problem ' + s;
		default:
			return 'bad repeat';
	}
};
var $rtfeldman$elm_iso8601_date_strings$DeadEnds$deadEndToString = function (deadend) {
	return $rtfeldman$elm_iso8601_date_strings$DeadEnds$problemToString(deadend.gO) + (' at row ' + ($elm$core$String$fromInt(deadend.g_) + (', col ' + $elm$core$String$fromInt(deadend.fG))));
};
var $elm$core$List$intersperse = F2(
	function (sep, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			var hd = xs.a;
			var tl = xs.b;
			var step = F2(
				function (x, rest) {
					return A2(
						$elm$core$List$cons,
						sep,
						A2($elm$core$List$cons, x, rest));
				});
			var spersed = A3($elm$core$List$foldr, step, _List_Nil, tl);
			return A2($elm$core$List$cons, hd, spersed);
		}
	});
var $rtfeldman$elm_iso8601_date_strings$DeadEnds$deadEndsToString = function (deadEnds) {
	return $elm$core$String$concat(
		A2(
			$elm$core$List$intersperse,
			'; ',
			A2($elm$core$List$map, $rtfeldman$elm_iso8601_date_strings$DeadEnds$deadEndToString, deadEnds)));
};
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.d);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.iM, offset) < 0,
					0,
					{fG: col, i: s0.i, m: s0.m, iM: offset, g_: row, d: s0.d});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.iM, s.g_, s.fG, s);
	};
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $elm$core$Basics$round = _Basics_round;
var $elm$core$String$toFloat = _String_toFloat;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs = A2(
	$elm$parser$Parser$andThen,
	function (str) {
		if ($elm$core$String$length(str) <= 9) {
			var _v0 = $elm$core$String$toFloat('0.' + str);
			if (!_v0.$) {
				var floatVal = _v0.a;
				return $elm$parser$Parser$succeed(
					$elm$core$Basics$round(floatVal * 1000));
			} else {
				return $elm$parser$Parser$problem('Invalid float: \"' + (str + '\"'));
			}
		} else {
			return $elm$parser$Parser$problem(
				'Expected at most 9 digits, but got ' + $elm$core$String$fromInt(
					$elm$core$String$length(str)));
		}
	},
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompWhile($elm$core$Char$isDigit)));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts = F6(
	function (monthYearDayMs, hour, minute, second, ms, utcOffsetMinutes) {
		return $elm$time$Time$millisToPosix((((monthYearDayMs + (((hour * 60) * 60) * 1000)) + (((minute - utcOffsetMinutes) * 60) * 1000)) + (second * 1000)) + ms);
	});
var $elm$parser$Parser$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$core$String$append = _String_append;
var $elm$parser$Parser$Advanced$loopHelp = F4(
	function (p, state, callback, s0) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var parse = _v0;
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p1 = _v1.a;
				var step = _v1.b;
				var s1 = _v1.c;
				if (!step.$) {
					var newState = step.a;
					var $temp$p = p || p1,
						$temp$state = newState,
						$temp$callback = callback,
						$temp$s0 = s1;
					p = $temp$p;
					state = $temp$state;
					callback = $temp$callback;
					s0 = $temp$s0;
					continue loopHelp;
				} else {
					var result = step.a;
					return A3($elm$parser$Parser$Advanced$Good, p || p1, result, s1);
				}
			} else {
				var p1 = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p || p1, x);
			}
		}
	});
var $elm$parser$Parser$Advanced$loop = F2(
	function (state, callback) {
		return function (s) {
			return A4($elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
		};
	});
var $elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$toAdvancedStep = function (step) {
	if (!step.$) {
		var s = step.a;
		return $elm$parser$Parser$Advanced$Loop(s);
	} else {
		var a = step.a;
		return $elm$parser$Parser$Advanced$Done(a);
	}
};
var $elm$parser$Parser$loop = F2(
	function (state, callback) {
		return A2(
			$elm$parser$Parser$Advanced$loop,
			state,
			function (s) {
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$toAdvancedStep,
					callback(s));
			});
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt = function (quantity) {
	var helper = function (str) {
		if (_Utils_eq(
			$elm$core$String$length(str),
			quantity)) {
			var _v0 = $elm$core$String$toInt(str);
			if (!_v0.$) {
				var intVal = _v0.a;
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$Done,
					$elm$parser$Parser$succeed(intVal));
			} else {
				return $elm$parser$Parser$problem('Invalid integer: \"' + (str + '\"'));
			}
		} else {
			return A2(
				$elm$parser$Parser$map,
				function (nextChar) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$String$append, str, nextChar));
				},
				$elm$parser$Parser$getChompedString(
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
		}
	};
	return A2($elm$parser$Parser$loop, '', helper);
};
var $elm$parser$Parser$ExpectingSymbol = function (a) {
	return {$: 8, a: a};
};
var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;
var $elm$parser$Parser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear = 1970;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay = function (day) {
	return $elm$parser$Parser$problem(
		'Invalid day: ' + $elm$core$String$fromInt(day));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear = function (year) {
	return (!A2($elm$core$Basics$modBy, 4, year)) && ((!(!A2($elm$core$Basics$modBy, 100, year))) || (!A2($elm$core$Basics$modBy, 400, year)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore = function (y1) {
	var y = y1 - 1;
	return (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay = 86400000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear = 31536000000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay = function (_v0) {
	var year = _v0.a;
	var month = _v0.b;
	var dayInMonth = _v0.c;
	if (dayInMonth < 0) {
		return $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth);
	} else {
		var succeedWith = function (extraMs) {
			var yearMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear * (year - $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear);
			var days = ((month < 3) || (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year))) ? (dayInMonth - 1) : dayInMonth;
			var dayMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay * (days + ($rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore(year) - $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore($rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear)));
			return $elm$parser$Parser$succeed((extraMs + yearMs) + dayMs);
		};
		switch (month) {
			case 1:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(0);
			case 2:
				return ((dayInMonth > 29) || ((dayInMonth === 29) && (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year)))) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(2678400000);
			case 3:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(5097600000);
			case 4:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(7776000000);
			case 5:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(10368000000);
			case 6:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(13046400000);
			case 7:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(15638400000);
			case 8:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(18316800000);
			case 9:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(20995200000);
			case 10:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(23587200000);
			case 11:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(26265600000);
			case 12:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(28857600000);
			default:
				return $elm$parser$Parser$problem(
					'Invalid month: \"' + ($elm$core$String$fromInt(month) + '\"'));
		}
	}
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs = A2(
	$elm$parser$Parser$andThen,
	$rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F3(
						function (year, month, day) {
							return _Utils_Tuple3(year, month, day);
						})),
				$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(4)),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed($elm$core$Basics$identity),
							$elm$parser$Parser$symbol('-')),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
					]))),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed($elm$core$Basics$identity),
						$elm$parser$Parser$symbol('-')),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
				]))));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes = function () {
	var utcOffsetMinutesFromParts = F3(
		function (multiplier, hours, minutes) {
			return (multiplier * (hours * 60)) + minutes;
		});
	return A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$map,
					function (_v0) {
						return 0;
					},
					$elm$parser$Parser$symbol('Z')),
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed(utcOffsetMinutesFromParts),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$map,
										function (_v1) {
											return 1;
										},
										$elm$parser$Parser$symbol('+')),
										A2(
										$elm$parser$Parser$map,
										function (_v2) {
											return -1;
										},
										$elm$parser$Parser$symbol('-'))
									]))),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$ignorer,
									$elm$parser$Parser$succeed($elm$core$Basics$identity),
									$elm$parser$Parser$symbol(':')),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
								$elm$parser$Parser$succeed(0)
							]))),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(0),
					$elm$parser$Parser$end)
				])));
}();
var $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601 = A2(
	$elm$parser$Parser$andThen,
	function (datePart) {
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed(
											$rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts(datePart)),
										$elm$parser$Parser$symbol('T')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$elm$parser$Parser$oneOf(
									_List_fromArray(
										[
											A2(
											$elm$parser$Parser$keeper,
											A2(
												$elm$parser$Parser$ignorer,
												$elm$parser$Parser$succeed($elm$core$Basics$identity),
												$elm$parser$Parser$symbol(':')),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
										]))),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$keeper,
										A2(
											$elm$parser$Parser$ignorer,
											$elm$parser$Parser$succeed($elm$core$Basics$identity),
											$elm$parser$Parser$symbol(':')),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
										$elm$parser$Parser$succeed(0)
									]))),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$symbol('.')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs),
									$elm$parser$Parser$succeed(0)
								]))),
					A2($elm$parser$Parser$ignorer, $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes, $elm$parser$Parser$end)),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A6($rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts, datePart, 0, 0, 0, 0, 0)),
					$elm$parser$Parser$end)
				]));
	},
	$rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs);
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime = function (str) {
	return A2($elm$parser$Parser$run, $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601, str);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		var _v0 = $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(str);
		if (_v0.$ === 1) {
			var deadEnds = _v0.a;
			return $elm$json$Json$Decode$fail(
				$rtfeldman$elm_iso8601_date_strings$DeadEnds$deadEndsToString(deadEnds));
		} else {
			var time = _v0.a;
			return $elm$json$Json$Decode$succeed(time);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Enectiva$DateRange$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'to',
	$author$project$Enectiva$Conversion$dateDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'from',
		$author$project$Enectiva$Conversion$dateDecoder,
		$elm$json$Json$Decode$succeed($elm$core$Tuple$pair)));
var $author$project$Enectiva$I18n$resultDateRangeDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$andThen,
			function (err) {
				return $elm$json$Json$Decode$succeed(
					$elm$core$Result$Err(err));
			},
			A2($elm$json$Json$Decode$field, 'err', $elm$json$Json$Decode$string)),
			A2(
			$elm$json$Json$Decode$andThen,
			function (range) {
				return $elm$json$Json$Decode$succeed(
					$elm$core$Result$Ok(range));
			},
			$author$project$Enectiva$DateRange$decoder)
		]));
var $author$project$Enectiva$I18n$parseDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (tp) {
		switch (tp) {
			case 'number':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'value',
					$elm$json$Json$Decode$float,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$value,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'appName',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed(
								F3(
									function (appName, id, value) {
										return A2(
											$author$project$Enectiva$I18n$ParsedNumber,
											_Utils_Tuple2(appName, id),
											value);
									})))));
			case 'date':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'value',
					$author$project$Enectiva$Conversion$dateDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$value,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'appName',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed(
								F3(
									function (appName, id, value) {
										return A2(
											$author$project$Enectiva$I18n$ParsedDate,
											_Utils_Tuple2(appName, id),
											value);
									})))));
			case 'dateTime':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'value',
					$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$value,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'appName',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed(
								F3(
									function (appName, id, value) {
										return A2(
											$author$project$Enectiva$I18n$ParsedDateTime,
											_Utils_Tuple2(appName, id),
											value);
									})))));
			case 'dateRange':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'value',
					$author$project$Enectiva$I18n$resultDateRangeDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$value,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'appName',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed(
								F3(
									function (appName, id, value) {
										return A2(
											$author$project$Enectiva$I18n$ParsedDateRange,
											_Utils_Tuple2(appName, id),
											value);
									})))));
			default:
				var anotherType = tp;
				return $elm$json$Json$Decode$succeed(
					$author$project$Enectiva$I18n$ParsingError('unrecognized type ' + anotherType));
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$Enectiva$I18n$parseResult = _Platform_incomingPort('parseResult', $elm$json$Json$Decode$value);
var $author$project$Enectiva$I18n$parsed = F3(
	function (noop, appName, _v0) {
		var number = _v0.dz;
		var date = _v0.di;
		var dateTime = _v0.dk;
		var dateRange = _v0.dj;
		return $author$project$Enectiva$I18n$parseResult(
			function (pr) {
				var _v1 = A2($elm$json$Json$Decode$decodeValue, $author$project$Enectiva$I18n$parseDecoder, pr);
				if (!_v1.$) {
					switch (_v1.a.$) {
						case 0:
							var _v2 = _v1.a;
							var _v3 = _v2.a;
							var an = _v3.a;
							var id = _v3.b;
							var n = _v2.b;
							return _Utils_eq(appName, an) ? A2(
								$elm$core$Maybe$withDefault,
								noop,
								A2(number, id, n)) : noop;
						case 1:
							var _v4 = _v1.a;
							var _v5 = _v4.a;
							var an = _v5.a;
							var id = _v5.b;
							var d = _v4.b;
							return _Utils_eq(appName, an) ? A2(
								$elm$core$Maybe$withDefault,
								noop,
								A2(date, id, d)) : noop;
						case 2:
							var _v6 = _v1.a;
							var _v7 = _v6.a;
							var an = _v7.a;
							var id = _v7.b;
							var dt = _v6.b;
							return _Utils_eq(appName, an) ? A2(
								$elm$core$Maybe$withDefault,
								noop,
								A2(dateTime, id, dt)) : noop;
						case 3:
							var _v8 = _v1.a;
							var _v9 = _v8.a;
							var an = _v9.a;
							var id = _v9.b;
							var resultRange = _v8.b;
							return _Utils_eq(appName, an) ? A2(
								$elm$core$Maybe$withDefault,
								noop,
								A2(dateRange, id, resultRange)) : noop;
						default:
							return noop;
					}
				} else {
					return noop;
				}
			});
	});
var $author$project$PriceListForm$NumberParsed = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$PriceListForm$LineItemValue = function (a) {
	return {$: 2, a: a};
};
var $author$project$PriceListForm$MonthlyFixedPrice = {$: 0};
var $author$project$PriceListForm$TI = $elm$core$Basics$identity;
var $author$project$PriceListForm$TariffPrice = function (a) {
	return {$: 1, a: a};
};
var $author$project$PriceListForm$dependencyDecoder = A3(
	$elm$core$Basics$composeR,
	$elm$json$Json$Decode$map($author$project$PriceListForm$dependencyFromString),
	$elm$json$Json$Decode$andThen($author$project$Enectiva$Conversion$decodeResult),
	$elm$json$Json$Decode$string);
var $author$project$PriceListForm$numericFieldDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'ti',
			A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$int),
			$elm$json$Json$Decode$succeed($author$project$PriceListForm$TariffPrice)),
			A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'dep',
			$author$project$PriceListForm$dependencyDecoder,
			$elm$json$Json$Decode$succeed($author$project$PriceListForm$LineItemValue)),
			A2(
			$elm$json$Json$Decode$andThen,
			function (s) {
				if (s === 'mfp') {
					return $elm$json$Json$Decode$succeed($author$project$PriceListForm$MonthlyFixedPrice);
				} else {
					return $elm$json$Json$Decode$fail('unknown numeric field ' + s);
				}
			},
			$elm$json$Json$Decode$string)
		]));
var $author$project$PriceListForm$parsedNumberMatcher = F2(
	function (id, val) {
		var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$PriceListForm$numericFieldDecoder, id);
		if (!_v0.$) {
			var field = _v0.a;
			return $elm$core$Maybe$Just(
				A2($author$project$PriceListForm$NumberParsed, field, val));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$PriceListForm$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A3(
				$author$project$Enectiva$I18n$parsed,
				$author$project$PriceListForm$IrrelevantPortMessaged,
				$author$project$PriceListForm$appName,
				A2($author$project$Enectiva$I18n$matchNumber, $author$project$PriceListForm$parsedNumberMatcher, $author$project$Enectiva$I18n$matchers)),
				$author$project$PriceListForm$escapePressedToCloseDialog(model)
			]));
};
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $elm$json$Json$Encode$bool = _Json_wrap;
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$Ports$toggleNativeDialog = _Platform_outgoingPort('toggleNativeDialog', $elm$core$Basics$identity);
var $author$project$Ports$closeNativeDialog = function (id) {
	return $author$project$Ports$toggleNativeDialog(
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string(id)),
					_Utils_Tuple2(
					'show',
					$elm$json$Json$Encode$bool(false))
				])));
};
var $author$project$PriceListForm$AdvancedComponentMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$PriceListForm$ServerRespondedToAdvancedComponentRequest = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$PriceListForm$Closed = 1;
var $turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$Zipper = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$next = function (_v0) {
	var p = _v0.a;
	var f = _v0.b;
	var n = _v0.c;
	if (!n.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var h = n.a;
		var t = n.b;
		return $elm$core$Maybe$Just(
			A3(
				$turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$Zipper,
				A2($elm$core$List$cons, f, p),
				h,
				t));
	}
};
var $turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$toEndHelper = F2(
	function (f, acc) {
		toEndHelper:
		while (true) {
			var _v0 = f(acc);
			if (!_v0.$) {
				var val = _v0.a;
				var $temp$f = f,
					$temp$acc = val;
				f = $temp$f;
				acc = $temp$acc;
				continue toEndHelper;
			} else {
				return acc;
			}
		}
	});
var $turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$end = $turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$toEndHelper($turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$next);
var $turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$current = function (_v0) {
	var f = _v0.b;
	return f;
};
var $turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$prev = function (_v0) {
	var p = _v0.a;
	var f = _v0.b;
	var n = _v0.c;
	if (!p.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var h = p.a;
		var t = p.b;
		return $elm$core$Maybe$Just(
			A3(
				$turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$Zipper,
				t,
				h,
				A2($elm$core$List$cons, f, n)));
	}
};
var $turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$focusl = F2(
	function (fc, zipper) {
		focusl:
		while (true) {
			if (fc(
				$turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$current(zipper))) {
				return $elm$core$Maybe$Just(zipper);
			} else {
				var _v0 = $turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$prev(zipper);
				if (!_v0.$) {
					var z = _v0.a;
					var $temp$fc = fc,
						$temp$zipper = z;
					fc = $temp$fc;
					zipper = $temp$zipper;
					continue focusl;
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$focusr = F2(
	function (fc, zipper) {
		focusr:
		while (true) {
			if (fc(
				$turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$current(zipper))) {
				return $elm$core$Maybe$Just(zipper);
			} else {
				var _v0 = $turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$next(zipper);
				if (!_v0.$) {
					var z = _v0.a;
					var $temp$fc = fc,
						$temp$zipper = z;
					fc = $temp$fc;
					zipper = $temp$zipper;
					continue focusr;
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$focus = F2(
	function (fc, zipper) {
		var _v0 = A2($turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$focusr, fc, zipper);
		if (_v0.$ === 1) {
			return A2($turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$focusl, fc, zipper);
		} else {
			var res = _v0;
			return res;
		}
	});
var $turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$fromNonEmpty = function (_v0) {
	var h = _v0.a;
	var t = _v0.b;
	return A3($turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$Zipper, _List_Nil, h, t);
};
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded = A2($elm$core$Basics$composeR, $elm$json$Json$Decode$succeed, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom);
var $TSFoster$elm_tuple_extra$Tuple3$join = F3(
	function (a, b, c) {
		return _Utils_Tuple3(a, b, c);
	});
var $author$project$PriceListForm$LIWC = function (a) {
	return {$: 1, a: a};
};
var $author$project$PriceListForm$LIWI = function (a) {
	return {$: 2, a: a};
};
var $author$project$PriceListForm$LIWOC = function (a) {
	return {$: 0, a: a};
};
var $author$project$PriceListForm$LineItem = F2(
	function (name, component) {
		return {aV: component, gu: name};
	});
var $author$project$PriceListForm$LineItemWithChoice = F2(
	function (selection, options) {
		return {bl: options, cZ: selection};
	});
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $turboMaCk$non_empty_list_alias$List$NonEmpty$fromCons = $elm$core$Tuple$pair;
var $turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$fromCons = function (a) {
	return A2(
		$elm$core$Basics$composeL,
		$turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$fromNonEmpty,
		$turboMaCk$non_empty_list_alias$List$NonEmpty$fromCons(a));
};
var $pzp1997$assoc_list$AssocList$get = F2(
	function (targetKey, _v0) {
		get:
		while (true) {
			var alist = _v0;
			if (!alist.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var _v2 = alist.a;
				var key = _v2.a;
				var value = _v2.b;
				var rest = alist.b;
				if (_Utils_eq(key, targetKey)) {
					return $elm$core$Maybe$Just(value);
				} else {
					var $temp$targetKey = targetKey,
						$temp$_v0 = rest;
					targetKey = $temp$targetKey;
					_v0 = $temp$_v0;
					continue get;
				}
			}
		}
	});
var $author$project$PriceListForm$LineItemWithoutChoice = F2(
	function (deps, price) {
		return {aH: deps, aA: price};
	});
var $author$project$PriceListForm$BasicPrice = function (a) {
	return {$: 0, a: a};
};
var $author$project$PriceListForm$DistributionRatePrice = function (a) {
	return {$: 1, a: a};
};
var $author$project$PriceListForm$BreakerPrice = function (a) {
	return {$: 2, a: a};
};
var $author$project$PriceListForm$Phase = F2(
	function (phase1, phase3) {
		return {gJ: phase1, gK: phase3};
	});
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $author$project$PriceListForm$PhaseData = F3(
	function (cost, to, everyAfter) {
		return {d0: cost, d7: everyAfter, fi: to};
	});
var $author$project$PriceListForm$phaseDataDecoder = $elm$json$Json$Decode$list(
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'every_after',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$float),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'to',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$float),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'cost',
				$elm$json$Json$Decode$float,
				$elm$json$Json$Decode$succeed($author$project$PriceListForm$PhaseData)))));
var $author$project$PriceListForm$breakerPriceDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$PriceListForm$BreakerPrice,
	$elm$json$Json$Decode$dict(
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'faze3',
			$author$project$PriceListForm$phaseDataDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'faze1',
				$author$project$PriceListForm$phaseDataDecoder,
				$elm$json$Json$Decode$succeed($author$project$PriceListForm$Phase)))));
var $author$project$PriceListForm$lineItemPrice = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2($elm$json$Json$Decode$map, $author$project$PriceListForm$BasicPrice, $elm$json$Json$Decode$float),
			A2(
			$elm$json$Json$Decode$map,
			$author$project$PriceListForm$DistributionRatePrice,
			$elm$json$Json$Decode$dict($elm$json$Json$Decode$float)),
			$author$project$PriceListForm$breakerPriceDecoder
		]));
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $author$project$PriceListForm$lineItemWithoutChoiceDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (deps) {
		return A2($elm$core$List$member, 1, deps) ? $elm$json$Json$Decode$fail('not LIWOC') : A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'price',
			$author$project$PriceListForm$lineItemPrice,
			$elm$json$Json$Decode$succeed(
				$author$project$PriceListForm$LineItemWithoutChoice(deps)));
	},
	A2(
		$elm$json$Json$Decode$field,
		'deps',
		$elm$json$Json$Decode$list($author$project$PriceListForm$dependencyDecoder)));
var $author$project$PriceListForm$lineItemWithChoiceDecoder = function (selections) {
	return A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'options',
		A2(
			$elm$json$Json$Decode$andThen,
			function (list) {
				if (!list.b) {
					return $elm$json$Json$Decode$fail('no options provided');
				} else {
					var head = list.a;
					var tail = list.b;
					return $elm$json$Json$Decode$succeed(
						A2($turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$fromCons, head, tail));
				}
			},
			$elm$json$Json$Decode$keyValuePairs($author$project$PriceListForm$lineItemWithoutChoiceDecoder)),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'selection_name',
			A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string),
			$elm$json$Json$Decode$succeed(
				F2(
					function (id, options) {
						var _v0 = A2($pzp1997$assoc_list$AssocList$get, id, selections);
						if (_v0.$ === 1) {
							return A2($author$project$PriceListForm$LineItemWithChoice, id, options);
						} else {
							var selectedValue = _v0.a;
							return A2(
								$author$project$PriceListForm$LineItemWithChoice,
								id,
								A2(
									$elm$core$Maybe$withDefault,
									options,
									A2(
										$turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$focus,
										A2(
											$elm$core$Basics$composeR,
											$elm$core$Tuple$first,
											$elm$core$Basics$eq(selectedValue)),
										options)));
						}
					}))));
};
var $author$project$PriceListForm$LineItemWithInput = F3(
	function (deps, id, price) {
		return {aH: deps, f5: id, aA: price};
	});
var $author$project$PriceListForm$lineItemWithInputDecoder = function (values) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (deps) {
			return A2($elm$core$List$member, 1, deps) ? A2(
				$elm$json$Json$Decode$map,
				function (defaultPrice) {
					var _v0 = A2($pzp1997$assoc_list$AssocList$get, 1, values);
					if (_v0.$ === 1) {
						return A3($author$project$PriceListForm$LineItemWithInput, deps, 1, defaultPrice);
					} else {
						var price = _v0.a;
						return A3($author$project$PriceListForm$LineItemWithInput, deps, 1, price);
					}
				},
				A2($elm$json$Json$Decode$field, 'price', $elm$json$Json$Decode$float)) : $elm$json$Json$Decode$fail('not LIWI');
		},
		A2(
			$elm$json$Json$Decode$field,
			'deps',
			$elm$json$Json$Decode$list($author$project$PriceListForm$dependencyDecoder)));
};
var $author$project$PriceListForm$lineItemDecoder = F2(
	function (selections, values) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$json$Json$Decode$andThen,
						A2($elm$core$Basics$composeR, $author$project$PriceListForm$LIWI, $elm$json$Json$Decode$succeed),
						$author$project$PriceListForm$lineItemWithInputDecoder(values)),
						A2(
						$elm$json$Json$Decode$andThen,
						A2($elm$core$Basics$composeR, $author$project$PriceListForm$LIWOC, $elm$json$Json$Decode$succeed),
						$author$project$PriceListForm$lineItemWithoutChoiceDecoder),
						A2(
						$elm$json$Json$Decode$andThen,
						A2($elm$core$Basics$composeR, $author$project$PriceListForm$LIWC, $elm$json$Json$Decode$succeed),
						$author$project$PriceListForm$lineItemWithChoiceDecoder(selections))
					])),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$PriceListForm$LineItem)));
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt = F3(
	function (path, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$at, path, valDecoder),
			decoder);
	});
var $author$project$PriceListForm$decodeAdvancedParams = F3(
	function (maybeYear, selections, values) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
			1,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
				_List_fromArray(
					['line_items', 'data']),
				$elm$json$Json$Decode$list(
					A2($author$project$PriceListForm$lineItemDecoder, selections, values)),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'years',
					A2(
						$elm$json$Json$Decode$map,
						function (years) {
							if (!maybeYear.$) {
								var year = maybeYear.a;
								return A2(
									$elm$core$Maybe$withDefault,
									years,
									A2(
										$turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$focus,
										$elm$core$Basics$eq(year),
										years));
							} else {
								return $turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$end(years);
							}
						},
						A2(
							$elm$json$Json$Decode$map,
							$turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$fromNonEmpty,
							$turboMaCk$non_empty_list_alias$List$NonEmpty$decodeList($elm$json$Json$Decode$int))),
					$elm$json$Json$Decode$succeed($TSFoster$elm_tuple_extra$Tuple3$join))));
	});
var $author$project$PriceListForm$distributorKeyAsString = function (dk) {
	var k = dk;
	return k;
};
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $krisajenkins$remotedata$RemoteData$Failure = function (a) {
	return {$: 2, a: a};
};
var $krisajenkins$remotedata$RemoteData$Success = function (a) {
	return {$: 3, a: a};
};
var $krisajenkins$remotedata$RemoteData$fromResult = function (result) {
	if (result.$ === 1) {
		var e = result.a;
		return $krisajenkins$remotedata$RemoteData$Failure(e);
	} else {
		var x = result.a;
		return $krisajenkins$remotedata$RemoteData$Success(x);
	}
};
var $author$project$Enectiva$I18n$locale = function (_v0) {
	var l = _v0.a;
	return l;
};
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$http$Http$BadBody = function (a) {
	return {$: 4, a: a};
};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $elm$http$Http$Timeout = {$: 1};
var $elm$http$Http$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 2:
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 3:
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.hb));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$http$Http$BadBody,
					toResult(body));
		}
	});
var $elm$http$Http$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			$elm$http$Http$resolve(
				function (string) {
					return A2(
						$elm$core$Result$mapError,
						$elm$json$Json$Decode$errorToString,
						A2($elm$json$Json$Decode$decodeString, decoder, string));
				}));
	});
var $elm$http$Http$Header = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$header = $elm$http$Http$Header;
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {gW: reqs, hf: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.hm;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.gW));
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.hf)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					hG: r.hG,
					fC: r.fC,
					fU: A2(_Http_mapExpect, func, r.fU),
					f0: r.f0,
					go: r.go,
					hj: r.hj,
					hm: r.hm,
					hr: r.hr
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{hG: false, fC: r.fC, fU: r.fU, f0: r.f0, go: r.go, hj: r.hj, hm: r.hm, hr: r.hr}));
};
var $author$project$Enectiva$HttpExtra$request = F6(
	function (token, verb, decoder, url, body, tagger) {
		return $elm$http$Http$request(
			{
				fC: body,
				fU: A2($elm$http$Http$expectJson, tagger, decoder),
				f0: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CSRF-Token', token),
						A2($elm$http$Http$header, 'X-Requested-With', 'XMLHttpRequest')
					]),
				go: verb,
				hj: $elm$core$Maybe$Nothing,
				hm: $elm$core$Maybe$Nothing,
				hr: url
			});
	});
var $author$project$PriceListForm$loadDistributorData = F5(
	function (model, distributorKey, maybeYear, selections, values) {
		var url = '/' + ($author$project$Enectiva$I18n$locale(model.Z) + ('/price_lists/line_items?distributor=' + ($author$project$PriceListForm$distributorKeyAsString(distributorKey) + A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (y) {
					return '&year=' + $elm$core$String$fromInt(y);
				},
				maybeYear)))));
		return A6(
			$author$project$Enectiva$HttpExtra$request,
			model.cx,
			'GET',
			A3($author$project$PriceListForm$decodeAdvancedParams, maybeYear, selections, values),
			url,
			$elm$http$Http$emptyBody,
			A2(
				$elm$core$Basics$composeR,
				$krisajenkins$remotedata$RemoteData$fromResult,
				A2(
					$elm$core$Basics$composeR,
					$author$project$PriceListForm$ServerRespondedToAdvancedComponentRequest(distributorKey),
					$author$project$PriceListForm$AdvancedComponentMsg)));
	});
var $turboMaCk$non_empty_list_alias$List$NonEmpty$indexedMap = F2(
	function (f, _v0) {
		var h = _v0.a;
		var t = _v0.b;
		return _Utils_Tuple2(
			A2(f, 0, h),
			A2(
				$elm$core$List$indexedMap,
				function (i) {
					return f(i + 1);
				},
				t));
	});
var $author$project$PriceListForm$mapCostByIndex = F3(
	function (fn, _v0, costs) {
		var index = _v0;
		return A2(
			$turboMaCk$non_empty_list_alias$List$NonEmpty$indexedMap,
			F2(
				function (i, c) {
					return _Utils_eq(i, index) ? fn(c) : c;
				}),
			costs);
	});
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $author$project$Ports$openNativeDialog = function (id) {
	return $author$project$Ports$toggleNativeDialog(
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string(id)),
					_Utils_Tuple2(
					'show',
					$elm$json$Json$Encode$bool(true))
				])));
};
var $author$project$PriceListForm$dependencyToString = function (dep) {
	if (dep === 1) {
		return 'manual_month';
	} else {
		return 'not_used';
	}
};
var $elm$json$Json$Encode$int = _Json_wrap;
var $author$project$PriceListForm$encodeNumericField = function (field) {
	switch (field.$) {
		case 2:
			var dep = field.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'dep',
						$elm$json$Json$Encode$string(
							$author$project$PriceListForm$dependencyToString(dep)))
					]));
		case 0:
			return $elm$json$Json$Encode$string('mfp');
		default:
			var tariffId = field.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'ti',
						$elm$json$Json$Encode$int(tariffId))
					]));
	}
};
var $author$project$Enectiva$I18n$ParseNumberArgs = function (a) {
	return {$: 1, a: a};
};
var $author$project$Enectiva$I18n$parse = _Platform_outgoingPort('parse', $elm$core$Basics$identity);
var $author$project$Enectiva$I18n$parseEncoder = F2(
	function (_v0, args) {
		var appName = _v0.a;
		var id = _v0.b;
		var _v1 = function () {
			if (args.$ === 1) {
				var str = args.a;
				return _Utils_Tuple2(
					'number',
					_List_fromArray(
						[
							_Utils_Tuple2(
							'value',
							$elm$json$Json$Encode$string(str))
						]));
			} else {
				var format = args.a;
				var str = args.b;
				return _Utils_Tuple2(
					'dateTime',
					_List_fromArray(
						[
							_Utils_Tuple2(
							'format',
							$elm$json$Json$Encode$string(format)),
							_Utils_Tuple2(
							'value',
							$elm$json$Json$Encode$string(str))
						]));
			}
		}();
		var tp = _v1.a;
		var kvPairs = _v1.b;
		return $elm$json$Json$Encode$object(
			_Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string(tp)),
						_Utils_Tuple2(
						'appName',
						$elm$json$Json$Encode$string(appName)),
						_Utils_Tuple2('id', id)
					]),
				kvPairs));
	});
var $author$project$Enectiva$I18n$parseNumber = F3(
	function (appName, id, str) {
		return $author$project$Enectiva$I18n$parse(
			A2(
				$author$project$Enectiva$I18n$parseEncoder,
				_Utils_Tuple2(appName, id),
				$author$project$Enectiva$I18n$ParseNumberArgs(str)));
	});
var $author$project$PriceListForm$parseNumber = function (field) {
	return A2(
		$author$project$Enectiva$I18n$parseNumber,
		$author$project$PriceListForm$appName,
		$author$project$PriceListForm$encodeNumericField(field));
};
var $author$project$Ports$redirectTo = _Platform_outgoingPort('redirectTo', $elm$json$Json$Encode$string);
var $author$project$ServerErrors$NoContent = function (a) {
	return {$: 1, a: a};
};
var $author$project$PriceListForm$ServerRepliedToPriceListSubmission = function (a) {
	return {$: 4, a: a};
};
var $justinmimbs$date$Date$monthToNumber = function (m) {
	switch (m) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $justinmimbs$date$Date$toCalendarDateHelp = F3(
	function (y, m, d) {
		toCalendarDateHelp:
		while (true) {
			var monthDays = A2($justinmimbs$date$Date$daysInMonth, y, m);
			var mn = $justinmimbs$date$Date$monthToNumber(m);
			if ((mn < 12) && (_Utils_cmp(d, monthDays) > 0)) {
				var $temp$y = y,
					$temp$m = $justinmimbs$date$Date$numberToMonth(mn + 1),
					$temp$d = d - monthDays;
				y = $temp$y;
				m = $temp$m;
				d = $temp$d;
				continue toCalendarDateHelp;
			} else {
				return {fJ: d, gr: m, hB: y};
			}
		}
	});
var $justinmimbs$date$Date$divWithRemainder = F2(
	function (a, b) {
		return _Utils_Tuple2(
			A2($justinmimbs$date$Date$floorDiv, a, b),
			A2($elm$core$Basics$modBy, b, a));
	});
var $justinmimbs$date$Date$year = function (_v0) {
	var rd = _v0;
	var _v1 = A2($justinmimbs$date$Date$divWithRemainder, rd, 146097);
	var n400 = _v1.a;
	var r400 = _v1.b;
	var _v2 = A2($justinmimbs$date$Date$divWithRemainder, r400, 36524);
	var n100 = _v2.a;
	var r100 = _v2.b;
	var _v3 = A2($justinmimbs$date$Date$divWithRemainder, r100, 1461);
	var n4 = _v3.a;
	var r4 = _v3.b;
	var _v4 = A2($justinmimbs$date$Date$divWithRemainder, r4, 365);
	var n1 = _v4.a;
	var r1 = _v4.b;
	var n = (!r1) ? 0 : 1;
	return ((((n400 * 400) + (n100 * 100)) + (n4 * 4)) + n1) + n;
};
var $justinmimbs$date$Date$toOrdinalDate = function (_v0) {
	var rd = _v0;
	var y = $justinmimbs$date$Date$year(rd);
	return {
		eH: rd - $justinmimbs$date$Date$daysBeforeYear(y),
		hB: y
	};
};
var $justinmimbs$date$Date$toCalendarDate = function (_v0) {
	var rd = _v0;
	var date = $justinmimbs$date$Date$toOrdinalDate(rd);
	return A3($justinmimbs$date$Date$toCalendarDateHelp, date.hB, 0, date.eH);
};
var $justinmimbs$date$Date$day = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.fJ;
	});
var $justinmimbs$date$Date$month = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.gr;
	});
var $justinmimbs$date$Date$monthNumber = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToNumber);
var $justinmimbs$date$Date$ordinalDay = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toOrdinalDate,
	function ($) {
		return $.eH;
	});
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $justinmimbs$date$Date$padSignedInt = F2(
	function (length, _int) {
		return _Utils_ap(
			(_int < 0) ? '-' : '',
			A3(
				$elm$core$String$padLeft,
				length,
				'0',
				$elm$core$String$fromInt(
					$elm$core$Basics$abs(_int))));
	});
var $justinmimbs$date$Date$monthToQuarter = function (m) {
	return (($justinmimbs$date$Date$monthToNumber(m) + 2) / 3) | 0;
};
var $justinmimbs$date$Date$quarter = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToQuarter);
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $elm$time$Time$Fri = 4;
var $elm$time$Time$Mon = 0;
var $elm$time$Time$Sat = 5;
var $elm$time$Time$Sun = 6;
var $elm$time$Time$Thu = 3;
var $elm$time$Time$Tue = 1;
var $elm$time$Time$Wed = 2;
var $justinmimbs$date$Date$numberToWeekday = function (wdn) {
	var _v0 = A2($elm$core$Basics$max, 1, wdn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		default:
			return 6;
	}
};
var $justinmimbs$date$Date$toWeekDate = function (_v0) {
	var rd = _v0;
	var wdn = $justinmimbs$date$Date$weekdayNumber(rd);
	var wy = $justinmimbs$date$Date$year(rd + (4 - wdn));
	var week1Day1 = $justinmimbs$date$Date$daysBeforeWeekYear(wy) + 1;
	return {
		hv: 1 + (((rd - week1Day1) / 7) | 0),
		hw: wy,
		jo: $justinmimbs$date$Date$numberToWeekday(wdn)
	};
};
var $justinmimbs$date$Date$weekNumber = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.hv;
	});
var $justinmimbs$date$Date$weekYear = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.hw;
	});
var $justinmimbs$date$Date$weekday = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$weekdayNumber, $justinmimbs$date$Date$numberToWeekday);
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $justinmimbs$date$Date$ordinalSuffix = function (n) {
	var nn = A2($elm$core$Basics$modBy, 100, n);
	var _v0 = A2(
		$elm$core$Basics$min,
		(nn < 20) ? nn : A2($elm$core$Basics$modBy, 10, nn),
		4);
	switch (_v0) {
		case 1:
			return 'st';
		case 2:
			return 'nd';
		case 3:
			return 'rd';
		default:
			return 'th';
	}
};
var $justinmimbs$date$Date$withOrdinalSuffix = function (n) {
	return _Utils_ap(
		$elm$core$String$fromInt(n),
		$justinmimbs$date$Date$ordinalSuffix(n));
};
var $justinmimbs$date$Date$formatField = F4(
	function (language, _char, length, date) {
		switch (_char) {
			case 'y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$year(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$year(date));
				}
			case 'Y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekYear(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$weekYear(date));
				}
			case 'Q':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 3:
						return 'Q' + $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 4:
						return $justinmimbs$date$Date$withOrdinalSuffix(
							$justinmimbs$date$Date$quarter(date));
					case 5:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					default:
						return '';
				}
			case 'M':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$monthNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$monthNumber(date)));
					case 3:
						return language.dy(
							$justinmimbs$date$Date$month(date));
					case 4:
						return language.eC(
							$justinmimbs$date$Date$month(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.dy(
								$justinmimbs$date$Date$month(date)));
					default:
						return '';
				}
			case 'w':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekNumber(date)));
					default:
						return '';
				}
			case 'd':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$day(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$day(date)));
					case 3:
						return language.d1(
							$justinmimbs$date$Date$day(date));
					default:
						return '';
				}
			case 'D':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$ordinalDay(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					case 3:
						return A3(
							$elm$core$String$padLeft,
							3,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					default:
						return '';
				}
			case 'E':
				switch (length) {
					case 1:
						return language.bQ(
							$justinmimbs$date$Date$weekday(date));
					case 2:
						return language.bQ(
							$justinmimbs$date$Date$weekday(date));
					case 3:
						return language.bQ(
							$justinmimbs$date$Date$weekday(date));
					case 4:
						return language.fq(
							$justinmimbs$date$Date$weekday(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.bQ(
								$justinmimbs$date$Date$weekday(date)));
					case 6:
						return A2(
							$elm$core$String$left,
							2,
							language.bQ(
								$justinmimbs$date$Date$weekday(date)));
					default:
						return '';
				}
			case 'e':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					default:
						return A4($justinmimbs$date$Date$formatField, language, 'E', length, date);
				}
			default:
				return '';
		}
	});
var $justinmimbs$date$Date$formatWithTokens = F3(
	function (language, tokens, date) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (token, formatted) {
					if (!token.$) {
						var _char = token.a;
						var length = token.b;
						return _Utils_ap(
							A4($justinmimbs$date$Date$formatField, language, _char, length, date),
							formatted);
					} else {
						var str = token.a;
						return _Utils_ap(str, formatted);
					}
				}),
			'',
			tokens);
	});
var $justinmimbs$date$Pattern$Literal = function (a) {
	return {$: 1, a: a};
};
var $justinmimbs$date$Pattern$escapedQuote = A2(
	$elm$parser$Parser$ignorer,
	$elm$parser$Parser$succeed(
		$justinmimbs$date$Pattern$Literal('\'')),
	$elm$parser$Parser$token('\'\''));
var $justinmimbs$date$Pattern$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$getOffset = function (s) {
	return A3($elm$parser$Parser$Advanced$Good, false, s.iM, s);
};
var $elm$parser$Parser$getOffset = $elm$parser$Parser$Advanced$getOffset;
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $justinmimbs$date$Pattern$fieldRepeats = function (str) {
	var _v0 = $elm$core$String$toList(str);
	if (_v0.b && (!_v0.b.b)) {
		var _char = _v0.a;
		return A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F2(
						function (x, y) {
							return A2($justinmimbs$date$Pattern$Field, _char, 1 + (y - x));
						})),
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$getOffset,
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq(_char)))),
			$elm$parser$Parser$getOffset);
	} else {
		return $elm$parser$Parser$problem('expected exactly one char');
	}
};
var $justinmimbs$date$Pattern$field = A2(
	$elm$parser$Parser$andThen,
	$justinmimbs$date$Pattern$fieldRepeats,
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompIf($elm$core$Char$isAlpha)));
var $justinmimbs$date$Pattern$finalize = A2(
	$elm$core$List$foldl,
	F2(
		function (token, tokens) {
			var _v0 = _Utils_Tuple2(token, tokens);
			if (((_v0.a.$ === 1) && _v0.b.b) && (_v0.b.a.$ === 1)) {
				var x = _v0.a.a;
				var _v1 = _v0.b;
				var y = _v1.a.a;
				var rest = _v1.b;
				return A2(
					$elm$core$List$cons,
					$justinmimbs$date$Pattern$Literal(
						_Utils_ap(x, y)),
					rest);
			} else {
				return A2($elm$core$List$cons, token, tokens);
			}
		}),
	_List_Nil);
var $elm$parser$Parser$Advanced$lazy = function (thunk) {
	return function (s) {
		var _v0 = thunk(0);
		var parse = _v0;
		return parse(s);
	};
};
var $elm$parser$Parser$lazy = $elm$parser$Parser$Advanced$lazy;
var $justinmimbs$date$Pattern$isLiteralChar = function (_char) {
	return (_char !== '\'') && (!$elm$core$Char$isAlpha(_char));
};
var $justinmimbs$date$Pattern$literal = A2(
	$elm$parser$Parser$map,
	$justinmimbs$date$Pattern$Literal,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($justinmimbs$date$Pattern$isLiteralChar)),
			$elm$parser$Parser$chompWhile($justinmimbs$date$Pattern$isLiteralChar))));
var $justinmimbs$date$Pattern$quotedHelp = function (result) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (str) {
					return $justinmimbs$date$Pattern$quotedHelp(
						_Utils_ap(result, str));
				},
				$elm$parser$Parser$getChompedString(
					A2(
						$elm$parser$Parser$ignorer,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed(0),
							$elm$parser$Parser$chompIf(
								$elm$core$Basics$neq('\''))),
						$elm$parser$Parser$chompWhile(
							$elm$core$Basics$neq('\''))))),
				A2(
				$elm$parser$Parser$andThen,
				function (_v0) {
					return $justinmimbs$date$Pattern$quotedHelp(result + '\'');
				},
				$elm$parser$Parser$token('\'\'')),
				$elm$parser$Parser$succeed(result)
			]));
};
var $justinmimbs$date$Pattern$quoted = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($justinmimbs$date$Pattern$Literal),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('\''))),
	A2(
		$elm$parser$Parser$ignorer,
		$justinmimbs$date$Pattern$quotedHelp(''),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq('\'')),
					$elm$parser$Parser$end
				]))));
var $justinmimbs$date$Pattern$patternHelp = function (tokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (token) {
					return $justinmimbs$date$Pattern$patternHelp(
						A2($elm$core$List$cons, token, tokens));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[$justinmimbs$date$Pattern$field, $justinmimbs$date$Pattern$literal, $justinmimbs$date$Pattern$escapedQuote, $justinmimbs$date$Pattern$quoted]))),
				$elm$parser$Parser$lazy(
				function (_v0) {
					return $elm$parser$Parser$succeed(
						$justinmimbs$date$Pattern$finalize(tokens));
				})
			]));
};
var $justinmimbs$date$Pattern$fromString = function (str) {
	return A2(
		$elm$core$Result$withDefault,
		_List_fromArray(
			[
				$justinmimbs$date$Pattern$Literal(str)
			]),
		A2(
			$elm$parser$Parser$run,
			$justinmimbs$date$Pattern$patternHelp(_List_Nil),
			str));
};
var $justinmimbs$date$Date$formatWithLanguage = F2(
	function (language, pattern) {
		var tokens = $elm$core$List$reverse(
			$justinmimbs$date$Pattern$fromString(pattern));
		return A2($justinmimbs$date$Date$formatWithTokens, language, tokens);
	});
var $justinmimbs$date$Date$weekdayToName = function (wd) {
	switch (wd) {
		case 0:
			return 'Monday';
		case 1:
			return 'Tuesday';
		case 2:
			return 'Wednesday';
		case 3:
			return 'Thursday';
		case 4:
			return 'Friday';
		case 5:
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $justinmimbs$date$Date$language_en = {
	d1: $justinmimbs$date$Date$withOrdinalSuffix,
	eC: $justinmimbs$date$Date$monthToName,
	dy: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$monthToName,
		$elm$core$String$left(3)),
	fq: $justinmimbs$date$Date$weekdayToName,
	bQ: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$weekdayToName,
		$elm$core$String$left(3))
};
var $justinmimbs$date$Date$format = function (pattern) {
	return A2($justinmimbs$date$Date$formatWithLanguage, $justinmimbs$date$Date$language_en, pattern);
};
var $justinmimbs$date$Date$toIsoString = $justinmimbs$date$Date$format('yyyy-MM-dd');
var $author$project$Enectiva$Conversion$stdFormatDate = $justinmimbs$date$Date$toIsoString;
var $author$project$Enectiva$DateRange$dateEncoder = A2($elm$core$Basics$composeR, $author$project$Enectiva$Conversion$stdFormatDate, $elm$json$Json$Encode$string);
var $author$project$PriceListForm$encodeDistributorKey = function (_v0) {
	var key = _v0;
	return $elm$json$Json$Encode$string(key);
};
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $turboMaCk$non_empty_list_alias$List$NonEmpty$toList = function (_v0) {
	var h = _v0.a;
	var t = _v0.b;
	return A2($elm$core$List$cons, h, t);
};
var $turboMaCk$non_empty_list_alias$List$NonEmpty$encodeList = function (f) {
	return A2(
		$elm$core$Basics$composeL,
		$elm$json$Json$Encode$list(f),
		$turboMaCk$non_empty_list_alias$List$NonEmpty$toList);
};
var $pzp1997$assoc_list$AssocList$toList = function (_v0) {
	var alist = _v0;
	return alist;
};
var $author$project$PriceListForm$encodeSelections = function (selections) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$map,
			function (_v0) {
				var id = _v0.a;
				var s = _v0.b;
				return _Utils_Tuple2(
					id,
					$elm$json$Json$Encode$string(s));
			},
			$pzp1997$assoc_list$AssocList$toList(selections)));
};
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $author$project$PriceListForm$encodePeriodTo = function (to) {
	if (!to.$) {
		var t = to.a;
		var _v1 = A2($elm$core$Basics$modBy, 100, t);
		if (!_v1) {
			return $elm$json$Json$Encode$int(t - 41);
		} else {
			return $elm$json$Json$Encode$int(t - 1);
		}
	} else {
		return $elm$json$Json$Encode$null;
	}
};
var $author$project$PriceListForm$encodePeriodData = function (p) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'valid_from',
				$elm$json$Json$Encode$int(p.q)),
				_Utils_Tuple2(
				'valid_to',
				$author$project$PriceListForm$encodePeriodTo(
					$elm$core$Maybe$Just(999)))
			]));
};
var $elm$json$Json$Encode$float = _Json_wrap;
var $author$project$PriceListForm$encodeTariffData = function (t) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(t.gu)),
				_Utils_Tuple2(
				'price_per_unit',
				$elm$json$Json$Encode$float(t._)),
				_Utils_Tuple2(
				'periods',
				A2($turboMaCk$non_empty_list_alias$List$NonEmpty$encodeList, $author$project$PriceListForm$encodePeriodData, t.s))
			]));
};
var $author$project$PriceListForm$encodeValues = function (values) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$map,
			function (_v0) {
				var dep = _v0.a;
				var s = _v0.b;
				return _Utils_Tuple2(
					$author$project$PriceListForm$dependencyToString(dep),
					$elm$json$Json$Encode$float(s));
			},
			$pzp1997$assoc_list$AssocList$toList(values)));
};
var $author$project$PriceListForm$encodeCostData = function (c) {
	var component = function () {
		var _v0 = c.z;
		switch (_v0.$) {
			case 0:
				return _List_Nil;
			case 1:
				var rate = _v0.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'fixed_payment',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'period',
									$elm$json$Json$Encode$string('month')),
									_Utils_Tuple2(
									'amount',
									$elm$json$Json$Encode$float(rate))
								])))
					]);
			default:
				var dk = _v0.a;
				var selections = _v0.b;
				var values = _v0.c;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'advanced_component',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'distributor',
									$author$project$PriceListForm$encodeDistributorKey(dk)),
									_Utils_Tuple2(
									'selections',
									$author$project$PriceListForm$encodeSelections(selections)),
									_Utils_Tuple2(
									'line_item_values',
									$author$project$PriceListForm$encodeValues(values))
								])))
					]);
		}
	}();
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'tariffs',
				A2($turboMaCk$non_empty_list_alias$List$NonEmpty$encodeList, $author$project$PriceListForm$encodeTariffData, c.f)),
				_Utils_Tuple2(
				'range',
				A2(
					$elm$json$Json$Encode$list,
					$author$project$Enectiva$DateRange$dateEncoder,
					_List_fromArray(
						[c.S, c.I]))),
				_Utils_Tuple2(
				'component',
				$elm$json$Json$Encode$object(component))
			]));
};
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $author$project$PriceListForm$encodeExceptionalCosts = function (maybeCosts) {
	if (maybeCosts.$ === 1) {
		return _List_fromArray(
			[
				_Utils_Tuple2('exceptional_costs', $elm$json$Json$Encode$null)
			]);
	} else {
		var costs = maybeCosts.a;
		return $elm$core$List$singleton(
			A2(
				$elm$core$Tuple$pair,
				'exceptional_costs',
				A2($turboMaCk$non_empty_list_alias$List$NonEmpty$encodeList, $author$project$PriceListForm$encodeCostData, costs)));
	}
};
var $author$project$Types$energyToString = function (energy) {
	switch (energy) {
		case 1:
			return 'el';
		case 2:
			return 'ga';
		case 3:
			return 'wa';
		case 4:
			return 'he';
		case 5:
			return 'co';
		case 6:
			return 'hca';
		case 7:
			return 'lf';
		default:
			return '';
	}
};
var $author$project$PriceListForm$encodePriceData = function (p) {
	return $elm$json$Json$Encode$object(
		_Utils_ap(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(p.gu)),
					_Utils_Tuple2(
					'supplier',
					$elm$json$Json$Encode$string(p.ch)),
					_Utils_Tuple2(
					'energy',
					$elm$json$Json$Encode$string(
						$author$project$Types$energyToString(p.bY))),
					_Utils_Tuple2(
					'regular_costs',
					A2($turboMaCk$non_empty_list_alias$List$NonEmpty$encodeList, $author$project$PriceListForm$encodeCostData, p.n))
				]),
			$author$project$PriceListForm$encodeExceptionalCosts(p.v)));
};
var $author$project$ServerErrors$General = function (a) {
	return {$: 0, a: a};
};
var $author$project$ServerErrors$PerField = function (a) {
	return {$: 1, a: a};
};
var $author$project$ServerErrors$errorsDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['errors', 'validation']),
	$elm$json$Json$Decode$dict(
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string)));
var $author$project$Enectiva$HttpExtra$errorToString = function (err) {
	switch (err.$) {
		case 0:
			var str = err.a;
			return 'Bad URL ' + str;
		case 1:
			return 'Timeout';
		case 2:
			return 'Network error';
		case 3:
			return 'Bad status';
		default:
			var str = err.a;
			return 'Bad body ' + str;
	}
};
var $author$project$ServerErrors$generalError = A2(
	$elm$core$Basics$composeR,
	$author$project$Enectiva$HttpExtra$errorToString,
	A2($elm$core$Basics$composeR, $author$project$ServerErrors$General, $elm$core$Result$Err));
var $author$project$ServerErrors$httpClientSideError = function (code) {
	return (400 <= code) && (code < 500);
};
var $author$project$ServerErrors$expectResponse = F2(
	function (tagger, expectation) {
		return A2(
			$elm$http$Http$expectStringResponse,
			tagger,
			function (response) {
				switch (response.$) {
					case 0:
						var u = response.a;
						return $author$project$ServerErrors$generalError(
							$elm$http$Http$BadUrl(u));
					case 1:
						return $author$project$ServerErrors$generalError($elm$http$Http$Timeout);
					case 2:
						return $author$project$ServerErrors$generalError($elm$http$Http$NetworkError);
					case 3:
						var metadata = response.a;
						var body = response.b;
						if ($author$project$ServerErrors$httpClientSideError(metadata.hb)) {
							var _v1 = A2($elm$json$Json$Decode$decodeString, $author$project$ServerErrors$errorsDecoder, body);
							if (!_v1.$) {
								var se = _v1.a;
								return $elm$core$Result$Err(
									$author$project$ServerErrors$PerField(se));
							} else {
								var de = _v1.a;
								return $elm$core$Result$Err(
									$author$project$ServerErrors$General(
										$elm$json$Json$Decode$errorToString(de)));
							}
						} else {
							return $author$project$ServerErrors$generalError(
								$elm$http$Http$BadStatus(metadata.hb));
						}
					default:
						var body = response.b;
						if (expectation.$ === 1) {
							var v = expectation.a;
							return $elm$core$Result$Ok(v);
						} else {
							var decoder = expectation.a;
							var _v3 = A2($elm$json$Json$Decode$decodeString, decoder, body);
							if (!_v3.$) {
								var value = _v3.a;
								return $elm$core$Result$Ok(value);
							} else {
								var err = _v3.a;
								return $author$project$ServerErrors$generalError(
									$elm$http$Http$BadBody(
										$elm$json$Json$Decode$errorToString(err)));
							}
						}
				}
			});
	});
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $author$project$PriceListForm$submitPriceListForm = F3(
	function (csrfToken, locale, priceList) {
		var _v0 = function () {
			var _v1 = priceList.f5;
			if (!_v1.$) {
				var id = _v1.a;
				return _Utils_Tuple2(
					'/' + (locale + ('/price_lists/' + $elm$core$String$fromInt(id))),
					'PATCH');
			} else {
				return _Utils_Tuple2('/' + (locale + '/price_lists'), 'POST');
			}
		}();
		var url = _v0.a;
		var verb = _v0.b;
		return $elm$http$Http$request(
			{
				fC: $elm$http$Http$jsonBody(
					$author$project$PriceListForm$encodePriceData(priceList)),
				fU: A2(
					$author$project$ServerErrors$expectResponse,
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$PriceListForm$ServerRepliedToPriceListSubmission),
					$author$project$ServerErrors$NoContent(0)),
				f0: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CSRF-Token', csrfToken),
						A2($elm$http$Http$header, 'X-Requested-With', 'XMLHttpRequest')
					]),
				go: verb,
				hj: $elm$core$Maybe$Nothing,
				hm: $elm$core$Maybe$Nothing,
				hr: url
			});
	});
var $author$project$PriceListForm$applyEffect = function (_v0) {
	var model = _v0.a;
	var effect = _v0.b;
	switch (effect.$) {
		case 0:
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		case 1:
			var dk = effect.a;
			var maybeYear = effect.b;
			var selections = effect.c;
			var values = effect.d;
			return _Utils_Tuple2(
				model,
				A5($author$project$PriceListForm$loadDistributorData, model, dk, maybeYear, selections, values));
		case 2:
			var field = effect.a;
			var str = effect.b;
			return _Utils_Tuple2(
				model,
				A2($author$project$PriceListForm$parseNumber, field, str));
		case 3:
			return _Utils_Tuple2(
				model,
				A3(
					$author$project$PriceListForm$submitPriceListForm,
					model.cx,
					$author$project$Enectiva$I18n$locale(model.Z),
					model));
		case 4:
			var url = effect.a;
			return _Utils_Tuple2(
				model,
				$author$project$Ports$redirectTo(url));
		case 5:
			if (!effect.a) {
				var _v2 = effect.a;
				var costIndex = effect.b;
				var component = effect.c;
				return $author$project$Enectiva$Util$noCmd(
					_Utils_update(
						model,
						{
							n: A3(
								$author$project$PriceListForm$mapCostByIndex,
								function (c) {
									return _Utils_update(
										c,
										{z: component});
								},
								costIndex,
								model.n)
						}));
			} else {
				var _v3 = effect.a;
				var costIndex = effect.b;
				var component = effect.c;
				var _v4 = model.v;
				if (_v4.$ === 1) {
					return $author$project$Enectiva$Util$noCmd(model);
				} else {
					var costs = _v4.a;
					return $author$project$Enectiva$Util$noCmd(
						_Utils_update(
							model,
							{
								v: $elm$core$Maybe$Just(
									A3(
										$author$project$PriceListForm$mapCostByIndex,
										function (c) {
											return _Utils_update(
												c,
												{z: component});
										},
										costIndex,
										costs))
							}));
				}
			}
		case 7:
			var htmlId = effect.a;
			return _Utils_Tuple2(
				model,
				$author$project$Ports$openNativeDialog(htmlId));
		case 6:
			var htmlId = effect.a;
			return _Utils_Tuple2(
				model,
				$author$project$Ports$closeNativeDialog(htmlId));
		default:
			var effects = effect.a;
			return A3(
				$elm$core$List$foldl,
				F2(
					function (e, _v5) {
						var m = _v5.a;
						var cmd = _v5.b;
						return A2(
							$elm$core$Tuple$mapSecond,
							function (c) {
								return $elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[c, cmd]));
							},
							$author$project$PriceListForm$applyEffect(
								_Utils_Tuple2(m, e)));
					}),
				_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
				effects);
	}
};
var $justinmimbs$date$Date$Days = 3;
var $author$project$PriceListForm$Exceptional = 1;
var $author$project$PriceListForm$LineItemValueChanged = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $krisajenkins$remotedata$RemoteData$Loading = {$: 1};
var $author$project$PriceListForm$MonthlyFixedPriceChanged = function (a) {
	return {$: 10, a: a};
};
var $author$project$PriceListForm$RedirectTo = function (a) {
	return {$: 4, a: a};
};
var $author$project$PriceListForm$Regular = 0;
var $author$project$PriceListForm$Save = {$: 3};
var $justinmimbs$date$Date$Months = 1;
var $justinmimbs$date$Date$add = F3(
	function (unit, n, _v0) {
		var rd = _v0;
		switch (unit) {
			case 0:
				return A3($justinmimbs$date$Date$add, 1, 12 * n, rd);
			case 1:
				var date = $justinmimbs$date$Date$toCalendarDate(rd);
				var wholeMonths = ((12 * (date.hB - 1)) + ($justinmimbs$date$Date$monthToNumber(date.gr) - 1)) + n;
				var m = $justinmimbs$date$Date$numberToMonth(
					A2($elm$core$Basics$modBy, 12, wholeMonths) + 1);
				var y = A2($justinmimbs$date$Date$floorDiv, wholeMonths, 12) + 1;
				return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A2(
					$elm$core$Basics$min,
					date.fJ,
					A2($justinmimbs$date$Date$daysInMonth, y, m));
			case 2:
				return rd + (7 * n);
			default:
				return rd + n;
		}
	});
var $turboMaCk$non_empty_list_alias$List$NonEmpty$cons = F2(
	function (a, _v0) {
		var h = _v0.a;
		var t = _v0.b;
		return _Utils_Tuple2(
			a,
			A2($elm$core$List$cons, h, t));
	});
var $turboMaCk$non_empty_list_alias$List$NonEmpty$foldr = F2(
	function (f, acc) {
		return A2(
			$elm$core$Basics$composeL,
			A2($elm$core$List$foldr, f, acc),
			$turboMaCk$non_empty_list_alias$List$NonEmpty$toList);
	});
var $turboMaCk$non_empty_list_alias$List$NonEmpty$append = F2(
	function (ne1, ne2) {
		var _v0 = $turboMaCk$non_empty_list_alias$List$NonEmpty$toList(ne2);
		if (!_v0.b) {
			return ne1;
		} else {
			return A3($turboMaCk$non_empty_list_alias$List$NonEmpty$foldr, $turboMaCk$non_empty_list_alias$List$NonEmpty$cons, ne2, ne1);
		}
	});
var $author$project$PriceListForm$CloseDialog = function (a) {
	return {$: 6, a: a};
};
var $author$project$PriceListForm$closeDialog = F2(
	function (htmlId, model) {
		return _Utils_Tuple2(
			model,
			$author$project$PriceListForm$CloseDialog(htmlId));
	});
var $author$project$PriceListForm$costDialogId = 'cost-dialog';
var $author$project$PriceListForm$cancelCostEdit = function (model) {
	return A2(
		$author$project$PriceListForm$closeDialog,
		$author$project$PriceListForm$costDialogId,
		_Utils_update(
			model,
			{ah: $elm$core$Maybe$Nothing}));
};
var $author$project$PriceListForm$DistributorForm = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$PriceListForm$mapSuccessfulDistributorForm = F2(
	function (fn, advanced) {
		var _v0 = advanced.B;
		if ((_v0.$ === 2) && (_v0.b.$ === 3)) {
			var dk = _v0.a;
			var data = _v0.b.a;
			return _Utils_update(
				advanced,
				{
					B: A2(
						$author$project$PriceListForm$DistributorForm,
						dk,
						$krisajenkins$remotedata$RemoteData$Success(
							fn(data)))
				});
		} else {
			return advanced;
		}
	});
var $author$project$PriceListForm$closeElPowerBreakdownDialog = $author$project$PriceListForm$mapSuccessfulDistributorForm(
	function (_v0) {
		var years = _v0.a;
		var lineItems = _v0.b;
		return _Utils_Tuple3(years, lineItems, 1);
	});
var $turboMaCk$non_empty_list_alias$List$NonEmpty$map = F2(
	function (f, _v0) {
		var h = _v0.a;
		var t = _v0.b;
		return _Utils_Tuple2(
			f(h),
			A2($elm$core$List$map, f, t));
	});
var $author$project$PriceListForm$periodToEditable = function (period) {
	return {
		Q: $elm$core$Maybe$Nothing,
		q: $elm$core$Maybe$Just(period.q)
	};
};
var $author$project$PriceListForm$tariffToEditable = function (tariff) {
	return {
		gu: tariff.gu,
		s: A2($turboMaCk$non_empty_list_alias$List$NonEmpty$map, $author$project$PriceListForm$periodToEditable, tariff.s),
		_: tariff._
	};
};
var $author$project$PriceListForm$costToEditable = F3(
	function (tp, index, _v0) {
		var tariffs = _v0.f;
		return {
			Q: $elm$core$Maybe$Nothing,
			ek: index,
			f: A2($turboMaCk$non_empty_list_alias$List$NonEmpty$map, $author$project$PriceListForm$tariffToEditable, tariffs),
			fn: tp
		};
	});
var $justinmimbs$date$Date$toMonths = function (rd) {
	var date = $justinmimbs$date$Date$toCalendarDate(rd);
	var wholeMonths = (12 * (date.hB - 1)) + ($justinmimbs$date$Date$monthToNumber(date.gr) - 1);
	return wholeMonths + (date.fJ / 100);
};
var $elm$core$Basics$truncate = _Basics_truncate;
var $justinmimbs$date$Date$diff = F3(
	function (unit, _v0, _v1) {
		var rd1 = _v0;
		var rd2 = _v1;
		switch (unit) {
			case 0:
				return ((($justinmimbs$date$Date$toMonths(rd2) - $justinmimbs$date$Date$toMonths(rd1)) | 0) / 12) | 0;
			case 1:
				return ($justinmimbs$date$Date$toMonths(rd2) - $justinmimbs$date$Date$toMonths(rd1)) | 0;
			case 2:
				return ((rd2 - rd1) / 7) | 0;
			default:
				return rd2 - rd1;
		}
	});
var $turboMaCk$non_empty_list_alias$List$NonEmpty$dropHead = function (_v0) {
	var t = _v0.b;
	return $turboMaCk$non_empty_list_alias$List$NonEmpty$fromList(t);
};
var $turboMaCk$non_empty_list_alias$List$NonEmpty$drop = F2(
	function (n, ne) {
		drop:
		while (true) {
			if (n > 0) {
				var _v0 = $turboMaCk$non_empty_list_alias$List$NonEmpty$dropHead(ne);
				if (!_v0.$) {
					var _new = _v0.a;
					var $temp$n = n - 1,
						$temp$ne = _new;
					n = $temp$n;
					ne = $temp$ne;
					continue drop;
				} else {
					return $elm$core$Maybe$Nothing;
				}
			} else {
				return $elm$core$Maybe$Just(ne);
			}
		}
	});
var $turboMaCk$non_empty_list_alias$List$NonEmpty$head = function (_v0) {
	var h = _v0.a;
	return h;
};
var $author$project$PriceListForm$findCost = F2(
	function (costs, _v0) {
		var index = _v0;
		return (index < 0) ? $elm$core$Maybe$Nothing : A2(
			$elm$core$Maybe$map,
			$turboMaCk$non_empty_list_alias$List$NonEmpty$head,
			A2($turboMaCk$non_empty_list_alias$List$NonEmpty$drop, index, costs));
	});
var $author$project$PriceListForm$currentCostEndsBefore = F3(
	function (costIndex, date, costs) {
		var _v0 = A2($author$project$PriceListForm$findCost, costs, costIndex);
		if (!_v0.$) {
			var validTo = _v0.a.I;
			return (A3($justinmimbs$date$Date$diff, 3, date, validTo) < 0) ? true : false;
		} else {
			return true;
		}
	});
var $author$project$PriceListForm$currentCostStartsAfter = F3(
	function (costIndex, date, costs) {
		var _v0 = A2($author$project$PriceListForm$findCost, costs, costIndex);
		if (!_v0.$) {
			var validFrom = _v0.a.S;
			return (A3($justinmimbs$date$Date$diff, 3, date, validFrom) > 0) ? true : false;
		} else {
			return true;
		}
	});
var $author$project$PriceListForm$GeneralError = {$: 4};
var $author$project$PriceListForm$editableToPeriod = function (_v0) {
	var from = _v0.q;
	var error = _v0.Q;
	if (!error.$) {
		var err = error.a;
		return $elm$core$Result$Err(err);
	} else {
		if (!from.$) {
			var f = from.a;
			return $elm$core$Result$Ok(
				$elm$core$Maybe$Just(
					{q: f}));
		} else {
			return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
		}
	}
};
var $turboMaCk$non_empty_list_alias$List$NonEmpty$filterMap = function (f) {
	return A2(
		$elm$core$Basics$composeL,
		A2(
			$elm$core$Basics$composeL,
			$turboMaCk$non_empty_list_alias$List$NonEmpty$fromList,
			$elm$core$List$filterMap(f)),
		$turboMaCk$non_empty_list_alias$List$NonEmpty$toList);
};
var $elm_community$maybe_extra$Maybe$Extra$join = function (mx) {
	if (!mx.$) {
		var x = mx.a;
		return x;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$Result$toMaybe = function (result) {
	if (!result.$) {
		var v = result.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$PriceListForm$editableToTariff = function (_v0) {
	var name = _v0.gu;
	var unitPrice = _v0._;
	var periods = _v0.s;
	var converted = A2($turboMaCk$non_empty_list_alias$List$NonEmpty$map, $author$project$PriceListForm$editableToPeriod, periods);
	var errs = A2(
		$elm$core$List$filterMap,
		function (r) {
			if (!r.$) {
				return $elm$core$Maybe$Nothing;
			} else {
				var err = r.a;
				return $elm$core$Maybe$Just(err);
			}
		},
		$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(converted));
	if (!errs.b) {
		var _v2 = A2(
			$turboMaCk$non_empty_list_alias$List$NonEmpty$filterMap,
			A2($elm$core$Basics$composeR, $elm$core$Result$toMaybe, $elm_community$maybe_extra$Maybe$Extra$join),
			converted);
		if (_v2.$ === 1) {
			return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
		} else {
			var ps = _v2.a;
			return $elm$core$Result$Ok(
				$elm$core$Maybe$Just(
					{gu: name, s: ps, _: unitPrice}));
		}
	} else {
		var err = errs.a;
		return $elm$core$Result$Err(err);
	}
};
var $author$project$PriceListForm$editableToTariffs = function (_v0) {
	var index = _v0.ek;
	var type_ = _v0.fn;
	var tariffs = _v0.f;
	var error = _v0.Q;
	if (!error.$) {
		var err = error.a;
		return $elm$core$Result$Err(err);
	} else {
		var converted = A2($turboMaCk$non_empty_list_alias$List$NonEmpty$map, $author$project$PriceListForm$editableToTariff, tariffs);
		var errs = A2(
			$elm$core$List$filterMap,
			function (r) {
				if (!r.$) {
					return $elm$core$Maybe$Nothing;
				} else {
					var err = r.a;
					return $elm$core$Maybe$Just(err);
				}
			},
			$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(converted));
		if (!errs.b) {
			var _v3 = A2(
				$turboMaCk$non_empty_list_alias$List$NonEmpty$filterMap,
				A2($elm$core$Basics$composeR, $elm$core$Result$toMaybe, $elm_community$maybe_extra$Maybe$Extra$join),
				converted);
			if (_v3.$ === 1) {
				return $elm$core$Result$Err($author$project$PriceListForm$GeneralError);
			} else {
				var ts = _v3.a;
				return $elm$core$Result$Ok(
					_Utils_Tuple3(type_, index, ts));
			}
		} else {
			var err = errs.a;
			return $elm$core$Result$Err(err);
		}
	}
};
var $turboMaCk$non_empty_list_alias$List$NonEmpty$lastHelper = function (xs) {
	lastHelper:
	while (true) {
		if (!xs.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!xs.b.b) {
				var h = xs.a;
				return $elm$core$Maybe$Just(h);
			} else {
				var t = xs.b;
				var $temp$xs = t;
				xs = $temp$xs;
				continue lastHelper;
			}
		}
	}
};
var $turboMaCk$non_empty_list_alias$List$NonEmpty$last = function (_v0) {
	var h = _v0.a;
	var t = _v0.b;
	return A2(
		$elm$core$Maybe$withDefault,
		h,
		$turboMaCk$non_empty_list_alias$List$NonEmpty$lastHelper(t));
};
var $turboMaCk$non_empty_list_alias$List$NonEmpty$map2 = F3(
	function (f, _v0, _v1) {
		var h1 = _v0.a;
		var t1 = _v0.b;
		var h2 = _v1.a;
		var t2 = _v1.b;
		return _Utils_Tuple2(
			A2(f, h1, h2),
			A3($elm$core$List$map2, f, t1, t2));
	});
var $turboMaCk$non_empty_list_alias$List$NonEmpty$singleton = function (h) {
	return _Utils_Tuple2(h, _List_Nil);
};
var $author$project$PriceListForm$fillInCostGaps = function (costs) {
	var _v0 = $turboMaCk$non_empty_list_alias$List$NonEmpty$dropHead(costs);
	if (_v0.$ === 1) {
		return costs;
	} else {
		var following = _v0.a;
		return function (filledIn) {
			return A2(
				$turboMaCk$non_empty_list_alias$List$NonEmpty$append,
				filledIn,
				$turboMaCk$non_empty_list_alias$List$NonEmpty$singleton(
					$turboMaCk$non_empty_list_alias$List$NonEmpty$last(costs)));
		}(
			A3(
				$turboMaCk$non_empty_list_alias$List$NonEmpty$map2,
				F2(
					function (cost, f) {
						return (A3($justinmimbs$date$Date$diff, 3, cost.I, f.S) > 1) ? _Utils_update(
							cost,
							{
								I: A3($justinmimbs$date$Date$add, 3, -1, f.S)
							}) : cost;
					}),
				costs,
				following));
	}
};
var $author$project$PriceListForm$CI = $elm$core$Basics$identity;
var $author$project$PriceListForm$nextCost = function (_v0) {
	var i = _v0;
	return i + 1;
};
var $author$project$PriceListForm$followingCostEndsBeforeOrAt = F3(
	function (costIndex, date, costs) {
		var _v0 = A2(
			$author$project$PriceListForm$findCost,
			costs,
			$author$project$PriceListForm$nextCost(costIndex));
		if (!_v0.$) {
			var validTo = _v0.a.I;
			return A3($justinmimbs$date$Date$diff, 3, date, validTo) <= 0;
		} else {
			return false;
		}
	});
var $author$project$PriceListForm$initExceptionalCosts = function (regular) {
	return A2(
		$turboMaCk$non_empty_list_alias$List$NonEmpty$map,
		function (c) {
			return _Utils_update(
				c,
				{
					f: A2(
						$turboMaCk$non_empty_list_alias$List$NonEmpty$map,
						function (t) {
							return _Utils_update(
								t,
								{
									s: $turboMaCk$non_empty_list_alias$List$NonEmpty$singleton(
										{q: 0})
								});
						},
						$turboMaCk$non_empty_list_alias$List$NonEmpty$singleton(
							$turboMaCk$non_empty_list_alias$List$NonEmpty$head(c.f)))
				});
		},
		regular);
};
var $author$project$PriceListForm$lastDayOfValidityHelp = F2(
	function (lastDay, costs) {
		lastDayOfValidityHelp:
		while (true) {
			if (!costs.b) {
				return lastDay;
			} else {
				var first = costs.a;
				var rest = costs.b;
				var $temp$lastDay = first.I,
					$temp$costs = rest;
				lastDay = $temp$lastDay;
				costs = $temp$costs;
				continue lastDayOfValidityHelp;
			}
		}
	});
var $turboMaCk$non_empty_list_alias$List$NonEmpty$tail = function (_v0) {
	var t = _v0.b;
	return t;
};
var $author$project$PriceListForm$lastDayOfValidity = function (costs) {
	return A2(
		$author$project$PriceListForm$lastDayOfValidityHelp,
		$turboMaCk$non_empty_list_alias$List$NonEmpty$head(costs).I,
		$turboMaCk$non_empty_list_alias$List$NonEmpty$tail(costs));
};
var $author$project$PriceListForm$mapEditableTariffByIndex = F2(
	function (fn, _v0) {
		var index = _v0;
		return $turboMaCk$non_empty_list_alias$List$NonEmpty$indexedMap(
			F2(
				function (i, t) {
					return _Utils_eq(i, index) ? fn(t) : t;
				}));
	});
var $justinmimbs$date$Date$Years = 0;
var $author$project$PriceListForm$newPeriod = {q: 0};
var $author$project$PriceListForm$newTariffData = function (name) {
	return {
		gu: name,
		s: $turboMaCk$non_empty_list_alias$List$NonEmpty$singleton($author$project$PriceListForm$newPeriod),
		_: 1
	};
};
var $author$project$PriceListForm$newCostData = function (validFrom) {
	return {
		z: $author$project$PriceListForm$None,
		f: $turboMaCk$non_empty_list_alias$List$NonEmpty$singleton(
			$author$project$PriceListForm$newTariffData('T1')),
		S: A3($justinmimbs$date$Date$add, 3, 1, validFrom),
		I: A3($justinmimbs$date$Date$add, 0, 1, validFrom)
	};
};
var $author$project$PriceListForm$NoEffect = {$: 0};
var $author$project$PriceListForm$noEffect = function (model) {
	return _Utils_Tuple2(model, $author$project$PriceListForm$NoEffect);
};
var $author$project$PriceListForm$AdvancedOpened = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$PriceListForm$FixedMonthlyForm = function (a) {
	return {$: 1, a: a};
};
var $author$project$PriceListForm$LoadDistributorData = F4(
	function (a, b, c, d) {
		return {$: 1, a: a, b: b, c: c, d: d};
	});
var $author$project$PriceListForm$OpenDialog = function (a) {
	return {$: 7, a: a};
};
var $author$project$PriceListForm$advancedComponentDialogId = 'adv-dialog';
var $author$project$PriceListForm$MultipleEffects = function (a) {
	return {$: 8, a: a};
};
var $author$project$PriceListForm$multipleEffects = function (effects) {
	return $author$project$PriceListForm$MultipleEffects(effects);
};
var $author$project$PriceListForm$openAdvancedComponentDialog = F4(
	function (tp, costIndex, cost, model) {
		var advanced = model.z;
		var _v0 = function () {
			var _v1 = cost.z;
			switch (_v1.$) {
				case 0:
					return _Utils_Tuple2(
						$author$project$PriceListForm$NoneForm,
						$author$project$PriceListForm$OpenDialog($author$project$PriceListForm$advancedComponentDialogId));
				case 1:
					var p = _v1.a;
					return _Utils_Tuple2(
						$author$project$PriceListForm$FixedMonthlyForm(p),
						$author$project$PriceListForm$OpenDialog($author$project$PriceListForm$advancedComponentDialogId));
				default:
					var key = _v1.a;
					var selections = _v1.b;
					var values = _v1.c;
					return _Utils_Tuple2(
						A2($author$project$PriceListForm$DistributorForm, key, $krisajenkins$remotedata$RemoteData$Loading),
						$author$project$PriceListForm$multipleEffects(
							_List_fromArray(
								[
									A4($author$project$PriceListForm$LoadDistributorData, key, $elm$core$Maybe$Nothing, selections, values),
									$author$project$PriceListForm$OpenDialog($author$project$PriceListForm$advancedComponentDialogId)
								])));
			}
		}();
		var form = _v0.a;
		var effect = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					z: _Utils_update(
						advanced,
						{
							aY: A2($author$project$PriceListForm$AdvancedOpened, tp, costIndex),
							B: form
						})
				}),
			effect);
	});
var $author$project$PriceListForm$openDialog = F2(
	function (htmlId, model) {
		return _Utils_Tuple2(
			model,
			$author$project$PriceListForm$OpenDialog(htmlId));
	});
var $author$project$PriceListForm$previousCost = function (_v0) {
	var i = _v0;
	return i - 1;
};
var $author$project$PriceListForm$previousCostStartsAfterOrAt = F3(
	function (costIndex, date, costs) {
		var _v0 = A2(
			$author$project$PriceListForm$findCost,
			costs,
			$author$project$PriceListForm$previousCost(costIndex));
		if (!_v0.$) {
			var validFrom = _v0.a.S;
			return A3($justinmimbs$date$Date$diff, 3, date, validFrom) >= 0;
		} else {
			return false;
		}
	});
var $turboMaCk$non_empty_list_alias$List$NonEmpty$length = function (_v0) {
	var t = _v0.b;
	return $elm$core$List$length(t) + 1;
};
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $turboMaCk$non_empty_list_alias$List$NonEmpty$take = F2(
	function (n, _v0) {
		var h = _v0.a;
		var t = _v0.b;
		return _Utils_Tuple2(
			h,
			A2($elm$core$List$take, n - 1, t));
	});
var $turboMaCk$non_empty_list_alias$List$NonEmpty$uncons = function (_v0) {
	var h = _v0.a;
	var t = _v0.b;
	return _Utils_Tuple2(
		h,
		$turboMaCk$non_empty_list_alias$List$NonEmpty$fromList(t));
};
var $author$project$PriceListForm$removeFromNonEmpty = F2(
	function (index, list) {
		if (_Utils_cmp(
			index,
			$turboMaCk$non_empty_list_alias$List$NonEmpty$length(list)) > -1) {
			return list;
		} else {
			if (!index) {
				var _v0 = $turboMaCk$non_empty_list_alias$List$NonEmpty$uncons(list);
				if (!_v0.b.$) {
					var remainder = _v0.b.a;
					return remainder;
				} else {
					return list;
				}
			} else {
				var before = A2($turboMaCk$non_empty_list_alias$List$NonEmpty$take, index, list);
				var after = A2($turboMaCk$non_empty_list_alias$List$NonEmpty$drop, index + 1, list);
				if (after.$ === 1) {
					return before;
				} else {
					var a = after.a;
					return A2($turboMaCk$non_empty_list_alias$List$NonEmpty$append, before, a);
				}
			}
		}
	});
var $author$project$PriceListForm$Opened = 0;
var $author$project$PriceListForm$ParseNumber = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$PriceListForm$SaveAdvancedComponent = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $author$project$PriceListForm$currentSelections = function (lineItems) {
	return $pzp1997$assoc_list$AssocList$fromList(
		A2(
			$elm$core$List$filterMap,
			function (li) {
				var _v0 = li.aV;
				if (_v0.$ === 1) {
					var selection = _v0.a.cZ;
					var options = _v0.a.bl;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(
							selection,
							$turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$current(options).a));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			lineItems));
};
var $author$project$PriceListForm$currentValues = function (lineItems) {
	return $pzp1997$assoc_list$AssocList$fromList(
		A2(
			$elm$core$List$filterMap,
			function (li) {
				var _v0 = li.aV;
				if (_v0.$ === 2) {
					var id = _v0.a.f5;
					var price = _v0.a.aA;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(id, price));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			lineItems));
};
var $author$project$PriceListForm$elPowerDialogId = 'el-power-dialog';
var $author$project$PriceListForm$updateAdvancedForm = F2(
	function (msg, advanced) {
		switch (msg.$) {
			case 5:
				var distributorKey = msg.a;
				var response = msg.b;
				var _v1 = advanced.B;
				if (_v1.$ === 2) {
					return $author$project$PriceListForm$noEffect(
						_Utils_update(
							advanced,
							{
								B: A2($author$project$PriceListForm$DistributorForm, distributorKey, response)
							}));
				} else {
					return $author$project$PriceListForm$noEffect(advanced);
				}
			case 6:
				return A2(
					$author$project$PriceListForm$closeDialog,
					$author$project$PriceListForm$advancedComponentDialogId,
					_Utils_update(
						advanced,
						{aY: $author$project$PriceListForm$AdvancedClosed}));
			case 7:
				var option = msg.a;
				switch (option.$) {
					case 0:
						return $author$project$PriceListForm$noEffect(
							_Utils_update(
								advanced,
								{B: $author$project$PriceListForm$NoneForm}));
					case 1:
						return $author$project$PriceListForm$noEffect(
							_Utils_update(
								advanced,
								{
									B: $author$project$PriceListForm$FixedMonthlyForm(0)
								}));
					default:
						var dk = option.a;
						var maybeYear = function () {
							var _v3 = advanced.B;
							if ((_v3.$ === 2) && (_v3.b.$ === 3)) {
								var _v4 = _v3.b.a;
								var years = _v4.a;
								return $elm$core$Maybe$Just(
									$turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$current(years));
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}();
						return _Utils_Tuple2(
							_Utils_update(
								advanced,
								{
									B: A2($author$project$PriceListForm$DistributorForm, dk, $krisajenkins$remotedata$RemoteData$Loading)
								}),
							A4($author$project$PriceListForm$LoadDistributorData, dk, maybeYear, $author$project$PriceListForm$noSelections, $author$project$PriceListForm$noValues));
				}
			case 8:
				var year = msg.a;
				var _v5 = advanced.B;
				if ((_v5.$ === 2) && (_v5.b.$ === 3)) {
					var dk = _v5.a;
					var _v6 = _v5.b.a;
					var lineItems = _v6.b;
					return _Utils_Tuple2(
						_Utils_update(
							advanced,
							{
								B: A2($author$project$PriceListForm$DistributorForm, dk, $krisajenkins$remotedata$RemoteData$Loading)
							}),
						A4(
							$author$project$PriceListForm$LoadDistributorData,
							dk,
							$elm$core$Maybe$Just(year),
							$author$project$PriceListForm$currentSelections(lineItems),
							$author$project$PriceListForm$currentValues(lineItems)));
				} else {
					return $author$project$PriceListForm$noEffect(advanced);
				}
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						advanced,
						{aY: $author$project$PriceListForm$AdvancedClosed}),
					function () {
						var _v7 = _Utils_Tuple2(advanced.aY, advanced.B);
						_v7$3:
						while (true) {
							if (_v7.a.$ === 1) {
								switch (_v7.b.$) {
									case 0:
										var _v8 = _v7.a;
										var tp = _v8.a;
										var costId = _v8.b;
										var _v9 = _v7.b;
										return $author$project$PriceListForm$multipleEffects(
											_List_fromArray(
												[
													A3($author$project$PriceListForm$SaveAdvancedComponent, tp, costId, $author$project$PriceListForm$None),
													$author$project$PriceListForm$CloseDialog($author$project$PriceListForm$advancedComponentDialogId)
												]));
									case 1:
										var _v10 = _v7.a;
										var tp = _v10.a;
										var costId = _v10.b;
										var p = _v7.b.a;
										return $author$project$PriceListForm$multipleEffects(
											_List_fromArray(
												[
													A3(
													$author$project$PriceListForm$SaveAdvancedComponent,
													tp,
													costId,
													$author$project$PriceListForm$FixedMonthly(p)),
													$author$project$PriceListForm$CloseDialog($author$project$PriceListForm$advancedComponentDialogId)
												]));
									default:
										if (_v7.b.b.$ === 3) {
											var _v11 = _v7.a;
											var tp = _v11.a;
											var costId = _v11.b;
											var _v12 = _v7.b;
											var key = _v12.a;
											var _v13 = _v12.b.a;
											var lineItems = _v13.b;
											var values = $author$project$PriceListForm$currentValues(lineItems);
											var selections = $author$project$PriceListForm$currentSelections(lineItems);
											return $author$project$PriceListForm$multipleEffects(
												_List_fromArray(
													[
														A3(
														$author$project$PriceListForm$SaveAdvancedComponent,
														tp,
														costId,
														A3($author$project$PriceListForm$Distributor, key, selections, values)),
														$author$project$PriceListForm$CloseDialog($author$project$PriceListForm$advancedComponentDialogId)
													]));
										} else {
											break _v7$3;
										}
								}
							} else {
								break _v7$3;
							}
						}
						return $author$project$PriceListForm$NoEffect;
					}());
			case 1:
				var str = msg.a;
				return _Utils_Tuple2(
					advanced,
					A2($author$project$PriceListForm$ParseNumber, $author$project$PriceListForm$MonthlyFixedPrice, str));
			case 10:
				var price = msg.a;
				return $author$project$PriceListForm$noEffect(
					_Utils_update(
						advanced,
						{
							B: function () {
								var _v14 = advanced.B;
								if (_v14.$ === 1) {
									return $author$project$PriceListForm$FixedMonthlyForm(price);
								} else {
									return advanced.B;
								}
							}()
						}));
			case 0:
				var id = msg.a;
				var value = msg.b;
				return $author$project$PriceListForm$noEffect(
					A2(
						$author$project$PriceListForm$mapSuccessfulDistributorForm,
						function (_v15) {
							var years = _v15.a;
							var lineItems = _v15.b;
							var breakdown = _v15.c;
							var selectOption = function (liwc) {
								return A2(
									$elm$core$Maybe$withDefault,
									liwc.bl,
									A2(
										$turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$focus,
										A2(
											$elm$core$Basics$composeR,
											$elm$core$Tuple$first,
											$elm$core$Basics$eq(value)),
										liwc.bl));
							};
							var updatedLineItems = A2(
								$elm$core$List$map,
								function (li) {
									var _v16 = li.aV;
									if (_v16.$ === 1) {
										var liwc = _v16.a;
										return _Utils_eq(liwc.cZ, id) ? _Utils_update(
											li,
											{
												aV: $author$project$PriceListForm$LIWC(
													_Utils_update(
														liwc,
														{
															bl: selectOption(liwc)
														}))
											}) : li;
									} else {
										return li;
									}
								},
								lineItems);
							return _Utils_Tuple3(years, updatedLineItems, breakdown);
						},
						advanced));
			case 3:
				return A2(
					$author$project$PriceListForm$openDialog,
					$author$project$PriceListForm$elPowerDialogId,
					A2(
						$author$project$PriceListForm$mapSuccessfulDistributorForm,
						function (_v17) {
							var years = _v17.a;
							var lineItems = _v17.b;
							return _Utils_Tuple3(years, lineItems, 0);
						},
						advanced));
			case 4:
				return A2(
					$author$project$PriceListForm$closeDialog,
					$author$project$PriceListForm$elPowerDialogId,
					$author$project$PriceListForm$closeElPowerBreakdownDialog(advanced));
			case 2:
				var id = msg.a;
				var str = msg.b;
				return _Utils_Tuple2(
					advanced,
					A2(
						$author$project$PriceListForm$ParseNumber,
						$author$project$PriceListForm$LineItemValue(id),
						str));
			default:
				var id = msg.a;
				var val = msg.b;
				return $author$project$PriceListForm$noEffect(
					A2(
						$author$project$PriceListForm$mapSuccessfulDistributorForm,
						function (_v18) {
							var years = _v18.a;
							var lineItems = _v18.b;
							var breakdown = _v18.c;
							var updatedLineItems = A2(
								$elm$core$List$map,
								function (li) {
									var _v19 = li.aV;
									if (_v19.$ === 2) {
										var liwi = _v19.a;
										return _Utils_eq(liwi.f5, id) ? _Utils_update(
											li,
											{
												aV: $author$project$PriceListForm$LIWI(
													_Utils_update(
														liwi,
														{aA: val}))
											}) : li;
									} else {
										return li;
									}
								},
								lineItems);
							return _Utils_Tuple3(years, updatedLineItems, breakdown);
						},
						advanced));
		}
	});
var $author$project$PriceListForm$mapEditablePeriodByIndex = F2(
	function (fn, _v0) {
		var index = _v0;
		return $turboMaCk$non_empty_list_alias$List$NonEmpty$indexedMap(
			F2(
				function (i, p) {
					return _Utils_eq(i, index) ? fn(p) : p;
				}));
	});
var $author$project$PriceListForm$mapPeriodInTariffByIndexes = F3(
	function (fn, tariffIndex, periodIndex) {
		return A2(
			$author$project$PriceListForm$mapEditableTariffByIndex,
			function (t) {
				return _Utils_update(
					t,
					{
						s: A3($author$project$PriceListForm$mapEditablePeriodByIndex, fn, periodIndex, t.s)
					});
			},
			tariffIndex);
	});
var $author$project$PriceListForm$newEditablePeriod = {Q: $elm$core$Maybe$Nothing, q: $elm$core$Maybe$Nothing};
var $author$project$BareTime$clean = function (input) {
	var _v0 = $elm$regex$Regex$fromString('\\D');
	if (!_v0.$) {
		var regex = _v0.a;
		return A3(
			$elm$regex$Regex$replace,
			regex,
			function (_v1) {
				return '';
			},
			input);
	} else {
		return '';
	}
};
var $author$project$BareTime$fromComponents = F2(
	function (hours, minutes) {
		return (hours * 100) + minutes;
	});
var $author$project$BareTime$toComponents = function (time) {
	return _Utils_Tuple2(
		(time / 100) | 0,
		A2($elm$core$Basics$modBy, 100, time));
};
var $author$project$BareTime$normalize = function (time) {
	var _v0 = $author$project$BareTime$toComponents(time);
	var hours = _v0.a;
	var minutes = _v0.b;
	var extraHours = (minutes / 60) | 0;
	var normalizedHours = A2($elm$core$Basics$modBy, 24, hours + extraHours);
	var normalizedMinutes = A2($elm$core$Basics$modBy, 60, minutes);
	return A2($author$project$BareTime$fromComponents, normalizedHours, normalizedMinutes);
};
var $author$project$BareTime$parse = function (input) {
	var _v0 = $author$project$BareTime$clean(input);
	if (_v0 === '') {
		return $elm$core$Result$Err('empty input');
	} else {
		var cleaned = _v0;
		var n = A2(
			$elm$core$Maybe$withDefault,
			0,
			$elm$core$String$toInt(cleaned));
		return (n <= 24) ? $elm$core$Result$Ok(n * 100) : $elm$core$Result$Ok(
			$author$project$BareTime$normalize(n));
	}
};
var $author$project$BareTime$roundTo = F2(
	function (rounding, time) {
		var _v0 = $author$project$BareTime$toComponents(time);
		var hours = _v0.a;
		var minutes = _v0.b;
		var roundedMinutes = ((minutes / rounding) | 0) * rounding;
		return A2($author$project$BareTime$fromComponents, hours, roundedMinutes);
	});
var $author$project$PriceListForm$parseTime = function (str) {
	return A2(
		$author$project$BareTime$roundTo,
		5,
		A2(
			$elm$core$Result$withDefault,
			0,
			$author$project$BareTime$parse(str)));
};
var $elm$core$List$sortBy = _List_sortBy;
var $turboMaCk$non_empty_list_alias$List$NonEmpty$sortHelper = F2(
	function (f, ne) {
		var _v0 = f(
			$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(ne));
		if (_v0.b) {
			var h = _v0.a;
			var t = _v0.b;
			return _Utils_Tuple2(h, t);
		} else {
			return ne;
		}
	});
var $turboMaCk$non_empty_list_alias$List$NonEmpty$sortBy = function (f) {
	return $turboMaCk$non_empty_list_alias$List$NonEmpty$sortHelper(
		$elm$core$List$sortBy(f));
};
var $author$project$PriceListForm$sortPeriods = function (tariffs) {
	return A2(
		$turboMaCk$non_empty_list_alias$List$NonEmpty$map,
		function (t) {
			return _Utils_update(
				t,
				{
					s: A2(
						$turboMaCk$non_empty_list_alias$List$NonEmpty$sortBy,
						function (p) {
							var _v0 = p.q;
							if (!_v0.$) {
								var f = _v0.a;
								return f;
							} else {
								return 2400;
							}
						},
						t.s)
				});
		},
		tariffs);
};
var $author$project$PriceListForm$updateEditedCost = F2(
	function (msg, cost) {
		switch (msg.$) {
			case 2:
				var tariffIndex = msg.a;
				var name = msg.b;
				return $author$project$PriceListForm$noEffect(
					_Utils_update(
						cost,
						{
							f: A3(
								$author$project$PriceListForm$mapEditableTariffByIndex,
								function (t) {
									return _Utils_update(
										t,
										{gu: name});
								},
								tariffIndex,
								cost.f)
						}));
			case 3:
				var tariffIndex = msg.a;
				var str = msg.b;
				return _Utils_Tuple2(
					cost,
					A2(
						$author$project$PriceListForm$ParseNumber,
						$author$project$PriceListForm$TariffPrice(tariffIndex),
						str));
			case 0:
				return $author$project$PriceListForm$noEffect(
					_Utils_update(
						cost,
						{
							f: A2(
								$turboMaCk$non_empty_list_alias$List$NonEmpty$append,
								cost.f,
								$turboMaCk$non_empty_list_alias$List$NonEmpty$singleton(
									{
										gu: 'T' + $elm$core$String$fromInt(
											1 + $turboMaCk$non_empty_list_alias$List$NonEmpty$length(cost.f)),
										s: $turboMaCk$non_empty_list_alias$List$NonEmpty$singleton($author$project$PriceListForm$newEditablePeriod),
										_: 1
									}))
						}));
			case 1:
				var index = msg.a;
				return $author$project$PriceListForm$noEffect(
					_Utils_update(
						cost,
						{
							f: A2($author$project$PriceListForm$removeFromNonEmpty, index, cost.f)
						}));
			case 4:
				var tariffIndex = msg.a;
				return $author$project$PriceListForm$noEffect(
					_Utils_update(
						cost,
						{
							f: A3(
								$author$project$PriceListForm$mapEditableTariffByIndex,
								function (t) {
									return _Utils_update(
										t,
										{
											s: A2(
												$turboMaCk$non_empty_list_alias$List$NonEmpty$append,
												t.s,
												$turboMaCk$non_empty_list_alias$List$NonEmpty$singleton($author$project$PriceListForm$newEditablePeriod))
										});
								},
								tariffIndex,
								cost.f)
						}));
			case 5:
				var tariffIndex = msg.a;
				var index = msg.b;
				return $author$project$PriceListForm$noEffect(
					_Utils_update(
						cost,
						{
							f: A3(
								$author$project$PriceListForm$mapEditableTariffByIndex,
								function (t) {
									return _Utils_update(
										t,
										{
											s: A2($author$project$PriceListForm$removeFromNonEmpty, index, t.s)
										});
								},
								tariffIndex,
								cost.f)
						}));
			default:
				if (msg.c === '') {
					var tariffIndex = msg.a;
					var periodIndex = msg.b;
					return $author$project$PriceListForm$noEffect(
						_Utils_update(
							cost,
							{
								f: $author$project$PriceListForm$sortPeriods(
									A4(
										$author$project$PriceListForm$mapPeriodInTariffByIndexes,
										function (p) {
											return _Utils_update(
												p,
												{q: $elm$core$Maybe$Nothing});
										},
										tariffIndex,
										periodIndex,
										cost.f))
							}));
				} else {
					var tariffIndex = msg.a;
					var periodIndex = msg.b;
					var str = msg.c;
					return $author$project$PriceListForm$noEffect(
						_Utils_update(
							cost,
							{
								f: $author$project$PriceListForm$sortPeriods(
									A4(
										$author$project$PriceListForm$mapPeriodInTariffByIndexes,
										function (p) {
											return _Utils_update(
												p,
												{
													q: $elm$core$Maybe$Just(
														$author$project$PriceListForm$parseTime(str))
												});
										},
										tariffIndex,
										periodIndex,
										cost.f))
							}));
				}
		}
	});
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$List$sort = function (xs) {
	return A2($elm$core$List$sortBy, $elm$core$Basics$identity, xs);
};
var $author$project$PriceListForm$periodStarts = function (cost) {
	return $elm$core$List$sort(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			$elm$core$List$concat(
				$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(
					A2(
						$turboMaCk$non_empty_list_alias$List$NonEmpty$map,
						function (t) {
							return $turboMaCk$non_empty_list_alias$List$NonEmpty$toList(
								A2(
									$turboMaCk$non_empty_list_alias$List$NonEmpty$map,
									function (p) {
										return p.q;
									},
									t.s));
						},
						cost.f)))));
};
var $author$project$PriceListForm$NoBeginning = {$: 1};
var $author$project$PriceListForm$validatePeriodStartsAtMidnight = F2(
	function (start, cost) {
		if ((!start.$) && (!start.a)) {
			return _Utils_update(
				cost,
				{Q: $elm$core$Maybe$Nothing});
		} else {
			return _Utils_update(
				cost,
				{
					Q: $elm$core$Maybe$Just($author$project$PriceListForm$NoBeginning)
				});
		}
	});
var $author$project$PriceListForm$DuplicateStart = {$: 0};
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $author$project$PriceListForm$validateUniquePeriodStarts = F2(
	function (starts, cost) {
		var frequencies = A3(
			$elm$core$List$foldl,
			F2(
				function (f, dict) {
					return A2($elm$core$Dict$member, f, dict) ? A3(
						$elm$core$Dict$update,
						f,
						$elm$core$Maybe$map(
							function (cnt) {
								return cnt + 1;
							}),
						dict) : A3($elm$core$Dict$insert, f, 1, dict);
				}),
			$elm$core$Dict$empty,
			starts);
		return _Utils_update(
			cost,
			{
				f: A2(
					$turboMaCk$non_empty_list_alias$List$NonEmpty$map,
					function (t) {
						return _Utils_update(
							t,
							{
								s: A2(
									$turboMaCk$non_empty_list_alias$List$NonEmpty$map,
									function (p) {
										var _v0 = p.q;
										if (!_v0.$) {
											var from = _v0.a;
											var _v1 = A2($elm$core$Dict$get, from, frequencies);
											if (!_v1.$) {
												var count = _v1.a;
												return (count > 1) ? _Utils_update(
													p,
													{
														Q: $elm$core$Maybe$Just($author$project$PriceListForm$DuplicateStart)
													}) : _Utils_update(
													p,
													{Q: $elm$core$Maybe$Nothing});
											} else {
												return _Utils_update(
													p,
													{Q: $elm$core$Maybe$Nothing});
											}
										} else {
											return _Utils_update(
												p,
												{Q: $elm$core$Maybe$Nothing});
										}
									},
									t.s)
							});
					},
					cost.f)
			});
	});
var $author$project$PriceListForm$validateEditableCost = function (cost) {
	var starts = $author$project$PriceListForm$periodStarts(cost);
	return A2(
		$author$project$PriceListForm$validateUniquePeriodStarts,
		starts,
		A2(
			$author$project$PriceListForm$validatePeriodStartsAtMidnight,
			$elm$core$List$head(starts),
			cost));
};
var $author$project$PriceListForm$updateEffect = F2(
	function (msg, model) {
		updateEffect:
		while (true) {
			var translations = model.Z;
			switch (msg.$) {
				case 0:
					return $author$project$PriceListForm$noEffect(model);
				case 1:
					if (!msg.a) {
						var _v1 = msg.a;
						var name = msg.b;
						return $author$project$PriceListForm$noEffect(
							_Utils_update(
								model,
								{gu: name}));
					} else {
						var _v2 = msg.a;
						var supplier = msg.b;
						return $author$project$PriceListForm$noEffect(
							_Utils_update(
								model,
								{ch: supplier}));
					}
				case 2:
					if (!msg.a) {
						var _v3 = msg.a;
						return $author$project$PriceListForm$noEffect(
							_Utils_update(
								model,
								{
									n: A2(
										$turboMaCk$non_empty_list_alias$List$NonEmpty$append,
										model.n,
										$turboMaCk$non_empty_list_alias$List$NonEmpty$singleton(
											$author$project$PriceListForm$newCostData(
												$author$project$PriceListForm$lastDayOfValidity(model.n))))
								}));
					} else {
						var _v4 = msg.a;
						var _v5 = model.v;
						if (_v5.$ === 1) {
							return $author$project$PriceListForm$noEffect(model);
						} else {
							var costs = _v5.a;
							return $author$project$PriceListForm$noEffect(
								_Utils_update(
									model,
									{
										v: $elm$core$Maybe$Just(
											A2(
												$turboMaCk$non_empty_list_alias$List$NonEmpty$append,
												costs,
												$turboMaCk$non_empty_list_alias$List$NonEmpty$singleton(
													$author$project$PriceListForm$newCostData(
														$author$project$PriceListForm$lastDayOfValidity(costs)))))
									}));
						}
					}
				case 5:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{cX: $krisajenkins$remotedata$RemoteData$Loading}),
						$author$project$PriceListForm$Save);
				case 4:
					if (msg.a.$ === 3) {
						var url = '/' + ($author$project$Enectiva$I18n$locale(translations) + ('/price_lists?energy=' + $author$project$Types$energyToString(model.bY)));
						return _Utils_Tuple2(
							model,
							$author$project$PriceListForm$RedirectTo(url));
					} else {
						var response = msg.a;
						return $author$project$PriceListForm$noEffect(
							_Utils_update(
								model,
								{cX: response}));
					}
				case 8:
					switch (msg.a.$) {
						case 1:
							var tariffId = msg.a.a;
							var price = msg.b;
							var _v6 = model.ah;
							if (_v6.$ === 1) {
								return $author$project$PriceListForm$noEffect(model);
							} else {
								var cost = _v6.a;
								var tariffs = A3(
									$author$project$PriceListForm$mapEditableTariffByIndex,
									function (t) {
										return _Utils_update(
											t,
											{_: price});
									},
									tariffId,
									cost.f);
								return $author$project$PriceListForm$noEffect(
									_Utils_update(
										model,
										{
											ah: $elm$core$Maybe$Just(
												_Utils_update(
													cost,
													{f: tariffs}))
										}));
							}
						case 0:
							var _v7 = msg.a;
							var price = msg.b;
							var $temp$msg = $author$project$PriceListForm$AdvancedComponentMsg(
								$author$project$PriceListForm$MonthlyFixedPriceChanged(price)),
								$temp$model = model;
							msg = $temp$msg;
							model = $temp$model;
							continue updateEffect;
						default:
							var id = msg.a.a;
							var value = msg.b;
							var $temp$msg = $author$project$PriceListForm$AdvancedComponentMsg(
								A2($author$project$PriceListForm$LineItemValueChanged, id, value)),
								$temp$model = model;
							msg = $temp$msg;
							model = $temp$model;
							continue updateEffect;
					}
				case 9:
					if (!msg.a.a) {
						if (!msg.a.c) {
							var _v8 = msg.a;
							var _v9 = _v8.a;
							var costIndex = _v8.b;
							var _v10 = _v8.c;
							var date = msg.b;
							return (A3($author$project$PriceListForm$previousCostStartsAfterOrAt, costIndex, date, model.n) || A3($author$project$PriceListForm$currentCostEndsBefore, costIndex, date, model.n)) ? $author$project$PriceListForm$noEffect(model) : $author$project$PriceListForm$noEffect(
								_Utils_update(
									model,
									{
										n: A3(
											$author$project$PriceListForm$mapCostByIndex,
											function (c) {
												return _Utils_update(
													c,
													{
														I: A3($justinmimbs$date$Date$add, 3, -1, date)
													});
											},
											$author$project$PriceListForm$previousCost(costIndex),
											A3(
												$author$project$PriceListForm$mapCostByIndex,
												function (c) {
													return _Utils_update(
														c,
														{S: date});
												},
												costIndex,
												model.n))
									}));
						} else {
							var _v15 = msg.a;
							var _v16 = _v15.a;
							var costIndex = _v15.b;
							var _v17 = _v15.c;
							var date = msg.b;
							return (A3($author$project$PriceListForm$followingCostEndsBeforeOrAt, costIndex, date, model.n) || A3($author$project$PriceListForm$currentCostStartsAfter, costIndex, date, model.n)) ? $author$project$PriceListForm$noEffect(model) : $author$project$PriceListForm$noEffect(
								_Utils_update(
									model,
									{
										n: A3(
											$author$project$PriceListForm$mapCostByIndex,
											function (c) {
												return _Utils_update(
													c,
													{
														S: A3($justinmimbs$date$Date$add, 3, 1, date)
													});
											},
											$author$project$PriceListForm$nextCost(costIndex),
											A3(
												$author$project$PriceListForm$mapCostByIndex,
												function (c) {
													return _Utils_update(
														c,
														{I: date});
												},
												costIndex,
												model.n))
									}));
						}
					} else {
						if (!msg.a.c) {
							var _v11 = msg.a;
							var _v12 = _v11.a;
							var costIndex = _v11.b;
							var _v13 = _v11.c;
							var date = msg.b;
							var _v14 = model.v;
							if (_v14.$ === 1) {
								return $author$project$PriceListForm$noEffect(model);
							} else {
								var costs = _v14.a;
								return (A3($author$project$PriceListForm$previousCostStartsAfterOrAt, costIndex, date, costs) || A3($author$project$PriceListForm$currentCostEndsBefore, costIndex, date, costs)) ? $author$project$PriceListForm$noEffect(model) : $author$project$PriceListForm$noEffect(
									_Utils_update(
										model,
										{
											v: $elm$core$Maybe$Just(
												A3(
													$author$project$PriceListForm$mapCostByIndex,
													function (c) {
														return _Utils_update(
															c,
															{
																I: A3($justinmimbs$date$Date$add, 3, -1, date)
															});
													},
													$author$project$PriceListForm$previousCost(costIndex),
													A3(
														$author$project$PriceListForm$mapCostByIndex,
														function (c) {
															return _Utils_update(
																c,
																{S: date});
														},
														costIndex,
														costs)))
										}));
							}
						} else {
							var _v18 = msg.a;
							var _v19 = _v18.a;
							var costIndex = _v18.b;
							var _v20 = _v18.c;
							var date = msg.b;
							var _v21 = model.v;
							if (_v21.$ === 1) {
								return $author$project$PriceListForm$noEffect(model);
							} else {
								var costs = _v21.a;
								return (A3($author$project$PriceListForm$followingCostEndsBeforeOrAt, costIndex, date, costs) || A3($author$project$PriceListForm$currentCostStartsAfter, costIndex, date, costs)) ? $author$project$PriceListForm$noEffect(model) : $author$project$PriceListForm$noEffect(
									_Utils_update(
										model,
										{
											v: $elm$core$Maybe$Just(
												A3(
													$author$project$PriceListForm$mapCostByIndex,
													function (c) {
														return _Utils_update(
															c,
															{
																S: A3($justinmimbs$date$Date$add, 3, 1, date)
															});
													},
													$author$project$PriceListForm$nextCost(costIndex),
													A3(
														$author$project$PriceListForm$mapCostByIndex,
														function (c) {
															return _Utils_update(
																c,
																{I: date});
														},
														costIndex,
														costs)))
										}));
							}
						}
					}
				case 3:
					if (!msg.a) {
						var _v22 = msg.a;
						var costIndex = msg.b;
						return $author$project$PriceListForm$noEffect(
							_Utils_update(
								model,
								{
									n: $author$project$PriceListForm$fillInCostGaps(
										A2($author$project$PriceListForm$removeFromNonEmpty, costIndex, model.n))
								}));
					} else {
						var _v23 = msg.a;
						var costIndex = msg.b;
						return $author$project$PriceListForm$noEffect(
							_Utils_update(
								model,
								{
									v: A2(
										$elm$core$Maybe$map,
										A2(
											$elm$core$Basics$composeR,
											$author$project$PriceListForm$removeFromNonEmpty(costIndex),
											$author$project$PriceListForm$fillInCostGaps),
										model.v)
								}));
					}
				case 6:
					if (!msg.a) {
						var _v24 = msg.a;
						var costIndex = msg.b;
						var _v25 = A2($author$project$PriceListForm$findCost, model.n, costIndex);
						if (_v25.$ === 1) {
							return $author$project$PriceListForm$noEffect(model);
						} else {
							var cost = _v25.a;
							return A4($author$project$PriceListForm$openAdvancedComponentDialog, 0, costIndex, cost, model);
						}
					} else {
						var _v26 = msg.a;
						var costIndex = msg.b;
						var _v27 = model.v;
						if (_v27.$ === 1) {
							return $author$project$PriceListForm$noEffect(model);
						} else {
							var costs = _v27.a;
							var _v28 = A2($author$project$PriceListForm$findCost, costs, costIndex);
							if (_v28.$ === 1) {
								return $author$project$PriceListForm$noEffect(model);
							} else {
								var cost = _v28.a;
								return A4($author$project$PriceListForm$openAdvancedComponentDialog, 1, costIndex, cost, model);
							}
						}
					}
				case 7:
					var m = msg.a;
					var _v29 = A2($author$project$PriceListForm$updateAdvancedForm, m, model.z);
					var _new = _v29.a;
					var effect = _v29.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{z: _new}),
						effect);
				case 10:
					if (!msg.a) {
						var _v30 = msg.a;
						var costIndex = msg.b;
						var _v31 = A2($author$project$PriceListForm$findCost, model.n, costIndex);
						if (_v31.$ === 1) {
							return $author$project$PriceListForm$noEffect(model);
						} else {
							var cost = _v31.a;
							return A2(
								$author$project$PriceListForm$openDialog,
								$author$project$PriceListForm$costDialogId,
								_Utils_update(
									model,
									{
										ah: $elm$core$Maybe$Just(
											A3($author$project$PriceListForm$costToEditable, 0, costIndex, cost))
									}));
						}
					} else {
						var _v32 = msg.a;
						var costIndex = msg.b;
						var _v33 = model.v;
						if (_v33.$ === 1) {
							return $author$project$PriceListForm$noEffect(model);
						} else {
							var costs = _v33.a;
							var _v34 = A2($author$project$PriceListForm$findCost, costs, costIndex);
							if (_v34.$ === 1) {
								return $author$project$PriceListForm$noEffect(model);
							} else {
								var cost = _v34.a;
								return A2(
									$author$project$PriceListForm$openDialog,
									$author$project$PriceListForm$costDialogId,
									_Utils_update(
										model,
										{
											ah: $elm$core$Maybe$Just(
												A3($author$project$PriceListForm$costToEditable, 1, costIndex, cost))
										}));
							}
						}
					}
				case 11:
					var m = msg.a;
					var _v35 = model.ah;
					if (_v35.$ === 1) {
						return $author$project$PriceListForm$noEffect(model);
					} else {
						var cost = _v35.a;
						var _v36 = A2($author$project$PriceListForm$updateEditedCost, m, cost);
						var c = _v36.a;
						var effect = _v36.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									ah: $elm$core$Maybe$Just(
										$author$project$PriceListForm$validateEditableCost(c))
								}),
							effect);
					}
				case 12:
					return $author$project$PriceListForm$cancelCostEdit(model);
				case 13:
					var _v37 = model.ah;
					if (_v37.$ === 1) {
						return $author$project$PriceListForm$noEffect(model);
					} else {
						var editable = _v37.a;
						var _v38 = $author$project$PriceListForm$editableToTariffs(editable);
						if (!_v38.$) {
							if (!_v38.a.a) {
								var _v39 = _v38.a;
								var _v40 = _v39.a;
								var costIndex = _v39.b;
								var tariffs = _v39.c;
								return A2(
									$author$project$PriceListForm$closeDialog,
									$author$project$PriceListForm$costDialogId,
									_Utils_update(
										model,
										{
											ah: $elm$core$Maybe$Nothing,
											n: A3(
												$author$project$PriceListForm$mapCostByIndex,
												function (c) {
													return _Utils_update(
														c,
														{f: tariffs});
												},
												costIndex,
												model.n)
										}));
							} else {
								var _v41 = _v38.a;
								var _v42 = _v41.a;
								var costIndex = _v41.b;
								var tariffs = _v41.c;
								var _v43 = model.v;
								if (_v43.$ === 1) {
									return $author$project$PriceListForm$noEffect(model);
								} else {
									var costs = _v43.a;
									return A2(
										$author$project$PriceListForm$closeDialog,
										$author$project$PriceListForm$costDialogId,
										_Utils_update(
											model,
											{
												ah: $elm$core$Maybe$Nothing,
												v: $elm$core$Maybe$Just(
													A3(
														$author$project$PriceListForm$mapCostByIndex,
														function (c) {
															return _Utils_update(
																c,
																{f: tariffs});
														},
														costIndex,
														costs))
											}));
								}
							}
						} else {
							return A2($author$project$PriceListForm$closeDialog, $author$project$PriceListForm$costDialogId, model);
						}
					}
				case 14:
					switch (msg.a) {
						case 0:
							var _v44 = msg.a;
							return $author$project$PriceListForm$cancelCostEdit(model);
						case 1:
							var _v45 = msg.a;
							var advanced = model.z;
							return $author$project$PriceListForm$noEffect(
								_Utils_update(
									model,
									{
										z: _Utils_update(
											advanced,
											{aY: $author$project$PriceListForm$AdvancedClosed})
									}));
						default:
							var _v46 = msg.a;
							return $author$project$PriceListForm$noEffect(
								_Utils_update(
									model,
									{
										z: $author$project$PriceListForm$closeElPowerBreakdownDialog(model.z)
									}));
					}
				default:
					if (!msg.a) {
						return $author$project$PriceListForm$noEffect(
							_Utils_update(
								model,
								{v: $elm$core$Maybe$Nothing}));
					} else {
						return $author$project$PriceListForm$noEffect(
							_Utils_update(
								model,
								{
									v: $elm$core$Maybe$Just(
										$author$project$PriceListForm$initExceptionalCosts(model.n))
								}));
					}
			}
		}
	});
var $author$project$PriceListForm$update = F2(
	function (msg, model) {
		return $author$project$PriceListForm$applyEffect(
			A2($author$project$PriceListForm$updateEffect, msg, model));
	});
var $author$project$PriceListForm$CloseAdvancedComponentDialogButtonClicked = {$: 6};
var $author$project$PriceListForm$SaveAdvancedComponentButtonClicked = {$: 9};
var $author$project$PriceListForm$MonthlyFixedPriceEntered = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $author$project$Spinner$container = $elm$html$Html$Attributes$class('relative');
var $elm$html$Html$div = _VirtualDom_node('div');
var $author$project$Enectiva$I18n$AsFloat = function (a) {
	return {$: 1, a: a};
};
var $author$project$Enectiva$I18n$escapeDelimiter = function (delimiter) {
	if (delimiter === '.') {
		return '\\.';
	} else {
		return delimiter;
	}
};
var $elm$core$String$fromList = _String_fromList;
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $elm_community$list_extra$List$Extra$greedyGroupsOfWithStep = F3(
	function (size, step, list) {
		if ((size <= 0) || (step <= 0)) {
			return _List_Nil;
		} else {
			var go = F2(
				function (xs, acc) {
					go:
					while (true) {
						if ($elm$core$List$isEmpty(xs)) {
							return $elm$core$List$reverse(acc);
						} else {
							var $temp$xs = A2($elm$core$List$drop, step, xs),
								$temp$acc = A2(
								$elm$core$List$cons,
								A2($elm$core$List$take, size, xs),
								acc);
							xs = $temp$xs;
							acc = $temp$acc;
							continue go;
						}
					}
				});
			return A2(go, list, _List_Nil);
		}
	});
var $elm_community$list_extra$List$Extra$greedyGroupsOf = F2(
	function (size, xs) {
		return A3($elm_community$list_extra$List$Extra$greedyGroupsOfWithStep, size, size, xs);
	});
var $elm$regex$Regex$never = _Regex_never;
var $elm$core$String$reverse = _String_reverse;
var $author$project$Enectiva$I18n$formatIntegerPartOfNumber = F2(
	function (delimiter, number) {
		var escapedDelimiter = $author$project$Enectiva$I18n$escapeDelimiter(delimiter);
		return A3(
			$elm$regex$Regex$replace,
			A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('^' + (escapedDelimiter + ('?(.+?)' + (escapedDelimiter + '?$'))))),
			function (_v0) {
				var submatches = _v0.he;
				return A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Maybe$Nothing,
						$elm$core$List$head(submatches)));
			},
			A3(
				$elm$core$List$foldl,
				F2(
					function (group, acc) {
						var segment = $elm$core$String$fromList(
							$elm$core$List$reverse(group));
						return _Utils_ap(
							segment,
							_Utils_ap(delimiter, acc));
					}),
				'',
				A2(
					$elm_community$list_extra$List$Extra$greedyGroupsOf,
					3,
					$elm$core$String$toList(
						$elm$core$String$reverse(
							$elm$core$String$fromInt(
								$elm$core$Basics$abs(number) | 0))))));
	});
var $elm$core$String$padRight = F3(
	function (n, _char, string) {
		return _Utils_ap(
			string,
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)));
	});
var $elm$core$Basics$pow = _Basics_pow;
var $author$project$Enectiva$I18n$keyToKeyPath = $elm$core$String$split('.');
var $author$project$Enectiva$I18n$tHelp = F2(
	function (_v0, keyPath) {
		var translations = _v0.b;
		return A2(
			$elm$json$Json$Decode$decodeValue,
			A2($elm$json$Json$Decode$at, keyPath, $elm$json$Json$Decode$string),
			translations);
	});
var $author$project$Enectiva$I18n$t = F2(
	function (translations, key) {
		return A2(
			$elm$core$Result$withDefault,
			key,
			A2(
				$author$project$Enectiva$I18n$tHelp,
				translations,
				$author$project$Enectiva$I18n$keyToKeyPath(key)));
	});
var $author$project$Enectiva$I18n$formatNumberWithPrecision = F3(
	function (translations, precision, number) {
		var sign = (number < 0) ? '-' : '';
		var delimiter = A2($author$project$Enectiva$I18n$t, translations, 'number.format.delimiter');
		if (!precision.$) {
			return _Utils_ap(
				sign,
				A2($author$project$Enectiva$I18n$formatIntegerPartOfNumber, delimiter, number));
		} else {
			var decimalPlaces = precision.a;
			var shift = A2($elm$core$Basics$pow, 10, decimalPlaces);
			var shiftedNumber = $elm$core$Basics$round(
				$elm$core$Basics$abs(number * shift));
			var decimalPart = A3(
				$elm$core$String$padRight,
				decimalPlaces,
				'0',
				A3(
					$elm$core$String$padLeft,
					decimalPlaces,
					'0',
					$elm$core$String$fromInt(
						function (n) {
							return A2($elm$core$Basics$modBy, shift, n);
						}(shiftedNumber))));
			return _Utils_ap(
				sign,
				_Utils_ap(
					A2($author$project$Enectiva$I18n$formatIntegerPartOfNumber, delimiter, (shiftedNumber / shift) | 0),
					_Utils_ap(
						A2($author$project$Enectiva$I18n$t, translations, 'number.format.separator'),
						decimalPart)));
		}
	});
var $author$project$Enectiva$I18n$formatNumber = function (translations) {
	return A2(
		$author$project$Enectiva$I18n$formatNumberWithPrecision,
		translations,
		$author$project$Enectiva$I18n$AsFloat(2));
};
var $elm$html$Html$input = _VirtualDom_node('input');
var $elm$html$Html$label = _VirtualDom_node('label');
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $author$project$PriceListForm$extractRepresentativeSingleComponent = function (c) {
	var _v0 = c.aV;
	switch (_v0.$) {
		case 0:
			var sm = _v0.a;
			return sm;
		case 1:
			return {
				aH: _List_Nil,
				aA: $author$project$PriceListForm$BasicPrice(0)
			};
		default:
			return {
				aH: _List_Nil,
				aA: $author$project$PriceListForm$BasicPrice(0)
			};
	}
};
var $turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$absoluteIndexedMap = F2(
	function (f, _v0) {
		var p = _v0.a;
		var focus_ = _v0.b;
		var n = _v0.c;
		var prevLength = $elm$core$List$length(p);
		return A3(
			$turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$Zipper,
			A2(
				$elm$core$List$indexedMap,
				function (i) {
					return f((prevLength - 1) - i);
				},
				p),
			A2(f, prevLength, focus_),
			A2(
				$elm$core$List$indexedMap,
				function (i) {
					return f((prevLength + 1) + i);
				},
				n));
	});
var $elm$html$Html$Attributes$colspan = function (n) {
	return A2(
		_VirtualDom_attribute,
		'colspan',
		$elm$core$String$fromInt(n));
};
var $turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$length = function (_v0) {
	var p = _v0.a;
	var n = _v0.c;
	return ($elm$core$List$length(p) + $elm$core$List$length(n)) + 1;
};
var $author$project$PriceListForm$LineItemValueEntered = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$core$Char$fromCode = _Char_fromCode;
var $author$project$View$nbsp = $elm$core$String$fromChar(
	$elm$core$Char$fromCode(160));
var $author$project$View$spaceRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString(' '));
var $author$project$View$replaceSpacesByNbsp = function (str) {
	return A3(
		$elm$regex$Regex$replace,
		$author$project$View$spaceRegex,
		function (_v0) {
			return $author$project$View$nbsp;
		},
		str);
};
var $author$project$View$formatNumberWithNbsp = function (translations) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Enectiva$I18n$formatNumber(translations),
		$author$project$View$replaceSpacesByNbsp);
};
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $author$project$View$onChange = function (tagger) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue));
};
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $author$project$PriceListForm$lineItemInput = F2(
	function (translations, _v0) {
		var price = _v0.aA;
		var id = _v0.f5;
		return A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_('text'),
					$elm$html$Html$Attributes$placeholder(
					A2($author$project$View$formatNumberWithNbsp, translations, 0)),
					$author$project$View$onChange(
					$author$project$PriceListForm$LineItemValueEntered(id)),
					$elm$html$Html$Attributes$value(
					A2($author$project$View$formatNumberWithNbsp, translations, price)),
					$elm$html$Html$Attributes$class('textfield w-24 text-right')
				]),
			_List_Nil);
	});
var $author$project$PriceListForm$OpenElPowerByCurrentAndBreakerPhasesDialogButtonClicked = {$: 3};
var $elm$html$Html$button = _VirtualDom_node('button');
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Enectiva$View$nothing = $elm$html$Html$text('');
var $author$project$PriceListForm$priceForMonth = function (translations) {
	return $elm$html$Html$text(
		$author$project$View$replaceSpacesByNbsp(
			A2($author$project$Enectiva$I18n$t, translations, 'price_js_list_mesic')));
};
var $author$project$PriceListForm$priceFor = F3(
	function (translations, selectedEnergy, d) {
		return A2($elm$core$List$member, 0, d.aH) ? $author$project$PriceListForm$priceForMonth(translations) : ((A2($elm$core$List$member, 2, d.aH) && (selectedEnergy === 1)) ? $elm$html$Html$text(
			$author$project$View$replaceSpacesByNbsp('1 MWh')) : (A2($elm$core$List$member, 5, d.aH) ? $elm$html$Html$text(
			$author$project$View$replaceSpacesByNbsp('1 MW')) : $author$project$Enectiva$View$nothing));
	});
var $author$project$PriceListForm$roundPrice = F3(
	function (translations, deps, price) {
		return A2($elm$core$List$member, 2, deps) ? A2($author$project$View$formatNumberWithNbsp, translations, price * 1000) : A2($author$project$View$formatNumberWithNbsp, translations, price);
	});
var $elm$html$Html$td = _VirtualDom_node('td');
var $author$project$View$tt = F2(
	function (translations, path) {
		return $elm$html$Html$text(
			A2($author$project$Enectiva$I18n$t, translations, path));
	});
var $author$project$PriceListForm$lineItemRow = F5(
	function (translations, selectedEnergy, wrapper, distributionRateCount, data) {
		var round = A2($author$project$PriceListForm$roundPrice, translations, data.aH);
		var divisorCell = A2(
			$elm$html$Html$td,
			_List_Nil,
			_List_fromArray(
				[
					A3($author$project$PriceListForm$priceFor, translations, selectedEnergy, data)
				]));
		var _v0 = data.aA;
		switch (_v0.$) {
			case 0:
				var price = _v0.a;
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$colspan(distributionRateCount),
								$elm$html$Html$Attributes$class('text-right')
							]),
						wrapper(
							$elm$html$Html$text(
								round(price)))),
						divisorCell
					]);
			case 1:
				var dict = _v0.a;
				return _Utils_ap(
					A2(
						$elm$core$List$map,
						function (_v1) {
							var dp = _v1.b;
							return A2(
								$elm$html$Html$td,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-right')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$View$replaceSpacesByNbsp(
											round(dp)))
									]));
						},
						$elm$core$Dict$toList(dict)),
					_List_fromArray(
						[divisorCell]));
			default:
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$colspan(distributionRateCount),
								$elm$html$Html$Attributes$class('text-center')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('button'),
										$elm$html$Html$Events$onClick($author$project$PriceListForm$OpenElPowerByCurrentAndBreakerPhasesDialogButtonClicked),
										$elm$html$Html$Attributes$class('submit-button bg-grey-600')
									]),
								_List_fromArray(
									[
										A2($author$project$View$tt, translations, 'price_js_by_jistic')
									]))
							])),
						divisorCell
					]);
		}
	});
var $elm$html$Html$Attributes$rowspan = function (n) {
	return A2(
		_VirtualDom_attribute,
		'rowspan',
		$elm$core$String$fromInt(n));
};
var $author$project$PriceListForm$LineItemOptionSelected = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$checked = $elm$html$Html$Attributes$boolProperty('checked');
var $author$project$PriceListForm$selectionRadioWrapper = F4(
	function (id, val, checked, h) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex gap-4 items-center justify-end')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('radio'),
								$elm$html$Html$Attributes$value(val),
								$elm$html$Html$Attributes$checked(checked),
								$elm$html$Html$Events$onClick(
								A2($author$project$PriceListForm$LineItemOptionSelected, id, val))
							]),
						_List_Nil),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('w-24')
							]),
						_List_fromArray(
							[h]))
					]))
			]);
	});
var $turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$toNonEmpty = function (_v0) {
	var p = _v0.a;
	var f = _v0.b;
	var n = _v0.c;
	var _v1 = $elm$core$List$reverse(p);
	if (!_v1.b) {
		return _Utils_Tuple2(f, n);
	} else {
		var h = _v1.a;
		var t = _v1.b;
		return _Utils_Tuple2(
			h,
			_Utils_ap(
				t,
				A2($elm$core$List$cons, f, n)));
	}
};
var $turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$toList = A2($elm$core$Basics$composeL, $turboMaCk$non_empty_list_alias$List$NonEmpty$toList, $turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$toNonEmpty);
var $elm$html$Html$tr = _VirtualDom_node('tr');
var $author$project$PriceListForm$lineItemView = F4(
	function (translations, selectedEnergy, distributionRateCount, _v0) {
		var name = _v0.gu;
		var component = _v0.aV;
		switch (component.$) {
			case 2:
				var li = component.a;
				return $elm$core$List$singleton(
					A2(
						$elm$html$Html$tr,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$td,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('max-w-64')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(name)
									])),
								A2(
								$elm$html$Html$td,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$colspan(distributionRateCount),
										$elm$html$Html$Attributes$class('text-right')
									]),
								_List_fromArray(
									[
										A2($author$project$PriceListForm$lineItemInput, translations, li)
									])),
								A2(
								$elm$html$Html$td,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$PriceListForm$priceForMonth(translations)
									]))
							])));
			case 0:
				var li = component.a;
				return $elm$core$List$singleton(
					A2(
						$elm$html$Html$tr,
						_List_Nil,
						A2(
							$elm$core$List$cons,
							A2(
								$elm$html$Html$td,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('max-w-64')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(name)
									])),
							A5($author$project$PriceListForm$lineItemRow, translations, selectedEnergy, $elm$core$List$singleton, distributionRateCount, li))));
			default:
				var li = component.a;
				var currentKey = $turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$current(li.bl).a;
				return $turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$toList(
					A2(
						$turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$absoluteIndexedMap,
						F2(
							function (idx, _v2) {
								var key = _v2.a;
								var item = _v2.b;
								return (!idx) ? A2(
									$elm$html$Html$tr,
									_List_Nil,
									A2(
										$elm$core$List$cons,
										A2(
											$elm$html$Html$td,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$rowspan(
													$turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$length(li.bl)),
													$elm$html$Html$Attributes$class('max-w-64')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(name)
												])),
										A5(
											$author$project$PriceListForm$lineItemRow,
											translations,
											selectedEnergy,
											A3(
												$author$project$PriceListForm$selectionRadioWrapper,
												li.cZ,
												key,
												_Utils_eq(key, currentKey)),
											distributionRateCount,
											item))) : A2(
									$elm$html$Html$tr,
									_List_Nil,
									A5(
										$author$project$PriceListForm$lineItemRow,
										translations,
										selectedEnergy,
										A3(
											$author$project$PriceListForm$selectionRadioWrapper,
											li.cZ,
											key,
											_Utils_eq(key, currentKey)),
										distributionRateCount,
										item));
							}),
						li.bl));
		}
	});
var $elm$core$List$maximum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$max, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$html$Html$th = _VirtualDom_node('th');
var $author$project$PriceListForm$distributionRateHeader = F3(
	function (translations, prices, currency) {
		distributionRateHeader:
		while (true) {
			var _v0 = $elm$core$List$head(prices);
			if (!_v0.$) {
				var price = _v0.a;
				var formatHeader = function (dict) {
					return A2(
						$elm$core$List$map,
						function (_v2) {
							var d = _v2.a;
							return A2(
								$elm$html$Html$th,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('bg-grey-300')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2($author$project$Enectiva$I18n$t, translations, 'price_js_list_entry_price') + (' ' + (d + (' (' + (currency + ')')))))
									]));
						},
						$elm$core$Dict$toList(dict));
				};
				switch (price.$) {
					case 1:
						var dict = price.a;
						return formatHeader(dict);
					case 2:
						var dict = price.a;
						return formatHeader(dict);
					default:
						var $temp$translations = translations,
							$temp$prices = A2($elm$core$List$drop, 1, prices),
							$temp$currency = currency;
						translations = $temp$translations;
						prices = $temp$prices;
						currency = $temp$currency;
						continue distributionRateHeader;
				}
			} else {
				return _List_Nil;
			}
		}
	});
var $author$project$PriceListForm$pricesHeaderView = F3(
	function (translations, currency, data) {
		return A2(
			$elm$core$List$member,
			4,
			$elm$core$List$concat(
				A2(
					$elm$core$List$map,
					function ($) {
						return $.aH;
					},
					data))) ? A3(
			$author$project$PriceListForm$distributionRateHeader,
			translations,
			A2(
				$elm$core$List$map,
				function ($) {
					return $.aA;
				},
				data),
			currency) : _List_fromArray(
			[
				A2(
				$elm$html$Html$th,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bg-grey-300')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-right')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($author$project$Enectiva$I18n$t, translations, 'price_js_list_entry_price') + (' (' + (currency + ')')))
							]))
					]))
			]);
	});
var $elm$core$Dict$sizeHelp = F2(
	function (n, dict) {
		sizeHelp:
		while (true) {
			if (dict.$ === -2) {
				return n;
			} else {
				var left = dict.d;
				var right = dict.e;
				var $temp$n = A2($elm$core$Dict$sizeHelp, n + 1, right),
					$temp$dict = left;
				n = $temp$n;
				dict = $temp$dict;
				continue sizeHelp;
			}
		}
	});
var $elm$core$Dict$size = function (dict) {
	return A2($elm$core$Dict$sizeHelp, 0, dict);
};
var $elm$html$Html$table = _VirtualDom_node('table');
var $elm$html$Html$tbody = _VirtualDom_node('tbody');
var $elm$html$Html$thead = _VirtualDom_node('thead');
var $author$project$PriceListForm$lineItemsTable = F4(
	function (translations, lineItems, selectedEnergy, currency) {
		var headerComponents = A2($elm$core$List$map, $author$project$PriceListForm$extractRepresentativeSingleComponent, lineItems);
		var distributionRateCount = A2(
			$elm$core$Maybe$withDefault,
			1,
			$elm$core$List$maximum(
				A2(
					$elm$core$List$map,
					function (p) {
						if (p.$ === 2) {
							var combinations = p.a;
							return $elm$core$Dict$size(combinations);
						} else {
							return 1;
						}
					},
					A2(
						$elm$core$List$filterMap,
						function (d) {
							return A2($elm$core$List$member, 4, d.aH) ? $elm$core$Maybe$Just(d.aA) : $elm$core$Maybe$Nothing;
						},
						headerComponents))));
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('list')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$thead,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tr,
							_List_Nil,
							A2(
								$elm$core$List$cons,
								A2(
									$elm$html$Html$th,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('bg-grey-300')
										]),
									_List_fromArray(
										[
											A2($author$project$View$tt, translations, 'price_js_list_entry_name')
										])),
								_Utils_ap(
									A3($author$project$PriceListForm$pricesHeaderView, translations, currency, headerComponents),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$th,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('bg-grey-300')
												]),
											_List_fromArray(
												[
													A2($author$project$View$tt, translations, 'price_js_list_entry_for')
												]))
										]))))
						])),
					A2(
					$elm$html$Html$tbody,
					_List_Nil,
					A2(
						$elm$core$List$concatMap,
						A3($author$project$PriceListForm$lineItemView, translations, selectedEnergy, distributionRateCount),
						lineItems))
				]));
	});
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $avh4$elm_color$Color$RgbaSpace = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $avh4$elm_color$Color$scaleFrom255 = function (c) {
	return c / 255;
};
var $avh4$elm_color$Color$rgb255 = F3(
	function (r, g, b) {
		return A4(
			$avh4$elm_color$Color$RgbaSpace,
			$avh4$elm_color$Color$scaleFrom255(r),
			$avh4$elm_color$Color$scaleFrom255(g),
			$avh4$elm_color$Color$scaleFrom255(b),
			1.0);
	});
var $author$project$Enectiva$Spinner$colours = {
	d4: 2100,
	dC: A3($avh4$elm_color$Color$rgb255, 0, 90, 171),
	dI: A3($avh4$elm_color$Color$rgb255, 244, 122, 55),
	ft: A2(
		$elm$core$Basics$composeR,
		$elm$core$List$singleton,
		$elm$html$Html$div(_List_Nil))
};
var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var $author$project$Enectiva$Spinner$cssColorString = F2(
	function (kind, values) {
		return kind + ('(' + (A2($elm$core$String$join, ', ', values) + ')'));
	});
var $elm$core$String$fromFloat = _String_fromNumber;
var $avh4$elm_color$Color$toRgba = function (_v0) {
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	var a = _v0.d;
	return {hH: a, hN: b, ii: g, iU: r};
};
var $author$project$Enectiva$Spinner$colorToCssRgba = function (color) {
	var _v0 = $avh4$elm_color$Color$toRgba(color);
	var red = _v0.iU;
	var green = _v0.ii;
	var blue = _v0.hN;
	var alpha = _v0.hH;
	return A2(
		$author$project$Enectiva$Spinner$cssColorString,
		'rgba',
		_List_fromArray(
			[
				$elm$core$String$fromFloat(red * 255),
				$elm$core$String$fromFloat(green * 255),
				$elm$core$String$fromFloat(blue * 255),
				$elm$core$String$fromFloat(alpha)
			]));
};
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$style = $elm$svg$Svg$trustedNode('style');
var $elm$svg$Svg$text = $elm$virtual_dom$VirtualDom$text;
var $author$project$Enectiva$Spinner$style = function (settings) {
	return A2(
		$elm$svg$Svg$style,
		_List_Nil,
		_List_fromArray(
			[
				$elm$svg$Svg$text(
				'path.spinner-punk{fill:' + ($author$project$Enectiva$Spinner$colorToCssRgba(settings.dI) + ';opacity:0}'))
			]));
};
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
var $elm$svg$Svg$Attributes$fillRule = _VirtualDom_attribute('fill-rule');
var $elm$svg$Svg$path = $elm$svg$Svg$trustedNode('path');
var $author$project$Enectiva$Spinner$letterE = function (settings) {
	return A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$d('m19.315,27.286194c0,-7.673 -4.763,-10.848 -9.525,-10.848 -5.557,0 -9.79,4.233 -9.79,9.525 0,6.879 5.027,10.054 9.79,10.054 5.027,0 8.995,-4.498 8.995,-6.615H16.14c0,1.323 -2.911,4.234 -6.35,4.234 -2.911,0 -7.144,-1.588 -7.144,-6.35h16.669m-2.646,-2.382c0,-3.175 -2.646,-6.085 -6.879,-6.085 -3.44,0 -7.144,2.646 -7.144,6.085h14.023'),
				$elm$svg$Svg$Attributes$fillRule('evenodd'),
				$elm$svg$Svg$Attributes$fill(
				$author$project$Enectiva$Spinner$colorToCssRgba(settings.dC)),
				$elm$svg$Svg$Attributes$class('e')
			]),
		_List_Nil);
};
var $elm$svg$Svg$animate = $elm$svg$Svg$trustedNode('animate');
var $elm$svg$Svg$Attributes$attributeName = _VirtualDom_attribute('attributeName');
var $elm$svg$Svg$Attributes$begin = _VirtualDom_attribute('begin');
var $elm$svg$Svg$Attributes$dur = _VirtualDom_attribute('dur');
var $elm$svg$Svg$Attributes$keyTimes = _VirtualDom_attribute('keyTimes');
var $elm$svg$Svg$Attributes$repeatCount = _VirtualDom_attribute('repeatCount');
var $elm$svg$Svg$Attributes$values = function (value) {
	return A2(
		_VirtualDom_attribute,
		'values',
		_VirtualDom_noJavaScriptUri(value));
};
var $author$project$Enectiva$Spinner$punk = F4(
	function (settings, index, path, begin) {
		return A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d(path),
					$elm$svg$Svg$Attributes$class('spinner-punk')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$animate,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$attributeName('opacity'),
							$elm$svg$Svg$Attributes$values('0;1;0;0'),
							$elm$svg$Svg$Attributes$keyTimes('0;0.2;0.4;1'),
							$elm$svg$Svg$Attributes$dur(
							$elm$core$String$fromFloat(settings.d4) + 'ms'),
							$elm$svg$Svg$Attributes$repeatCount('indefinite'),
							$elm$svg$Svg$Attributes$begin(begin)
						]),
					_List_Nil)
				]));
	});
var $author$project$Enectiva$Spinner$svgElements = function (settings) {
	return _List_fromArray(
		[
			$author$project$Enectiva$Spinner$letterE(settings),
			A4($author$project$Enectiva$Spinner$punk, settings, 0, 'm2.5 8.6c0 2.4 0 4.9 0 7.3 0.3-0.3 2.2-1.3 2.8-1.3 0-2 0-4 0-6z', '0s'),
			A4($author$project$Enectiva$Spinner$punk, settings, 1, 'm8.5 4.5c0 3.2 0 6.4 0 9.5 1.3-0.1 1.6-0.1 2.8 0 0-3.2 0-6.4 0-9.5z', '0.35s'),
			A4($author$project$Enectiva$Spinner$punk, settings, 2, 'm14.5 0c0 4.9 0 9.7 0 14.6 0.6 0 2.5 1 2.8 1.3 0-5.3 0-10.6 0-15.9z', '0.7s'),
			A4($author$project$Enectiva$Spinner$punk, settings, 5, 'm2.9 36.4c0 2.1 0 4.3 0 6.4h2.7v-5.1c-0.3 0-2.4-1.1-2.7-1.3z', '1.75s'),
			A4($author$project$Enectiva$Spinner$punk, settings, 4, 'm8.6 38.2c0 1.6 0 3 0 4.5h2.7c0-1.6 0-3.1 0-4.5-0.9 0.2-1.8 0.2-2.7 0z', '1.4s'),
			A4($author$project$Enectiva$Spinner$punk, settings, 3, 'm16.9 36.4c-0.3 0.3-2.4 1.3-2.7 1.3 0 1.8 0 3.5 0 5.1h2.7c0-2.2 0-4.4 0-6.4z', '1.05s')
		]);
};
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $author$project$Enectiva$Spinner$full = F2(
	function (settings, show) {
		return show ? settings.ft(
			A2(
				$elm$svg$Svg$svg,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$height('100%'),
						$elm$svg$Svg$Attributes$viewBox('0 0 20 43')
					]),
				A2(
					$elm$core$List$cons,
					$author$project$Enectiva$Spinner$style(settings),
					$author$project$Enectiva$Spinner$svgElements(settings)))) : $elm$svg$Svg$text('');
	});
var $author$project$Enectiva$View$viewIf = F2(
	function (view, condition) {
		return condition ? view(0) : $elm$html$Html$text('');
	});
var $author$project$Spinner$overlay = $author$project$Enectiva$View$viewIf(
	function (_v0) {
		var _default = $author$project$Enectiva$Spinner$colours;
		var opts = _Utils_update(
			_default,
			{
				ft: function (svg) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('bg-white opacity-70 absolute top-0 left-0 w-full h-full z-50'),
								A2($elm$html$Html$Attributes$attribute, 'data-spinner-target', 'overlay')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('absolute left-1/2 top-1/10 h-8/10 max-h-12')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('h-full relative -left-1/2')
											]),
										_List_fromArray(
											[svg]))
									]))
							]));
				}
			});
		return A2($author$project$Enectiva$Spinner$full, opts, true);
	});
var $author$project$PriceListForm$AdvancedComponentOptionSelected = function (a) {
	return {$: 7, a: a};
};
var $author$project$PriceListForm$DistributorOption = function (a) {
	return {$: 2, a: a};
};
var $author$project$PriceListForm$FixedMonthlyOption = {$: 1};
var $author$project$PriceListForm$NoneOption = {$: 0};
var $author$project$PriceListForm$advancedComponentOptionFromString = function (str) {
	switch (str) {
		case 'none':
			return $author$project$PriceListForm$NoneOption;
		case 'fixed':
			return $author$project$PriceListForm$FixedMonthlyOption;
		default:
			var key = str;
			return $author$project$PriceListForm$DistributorOption(key);
	}
};
var $pzp1997$assoc_list$AssocList$keys = function (_v0) {
	var alist = _v0;
	return A2($elm$core$List$map, $elm$core$Tuple$first, alist);
};
var $author$project$PriceListForm$advancedComponentOptions = function (distributors) {
	return _Utils_ap(
		_List_fromArray(
			[$author$project$PriceListForm$NoneOption]),
		_Utils_ap(
			A2(
				$elm$core$List$map,
				$author$project$PriceListForm$DistributorOption,
				$pzp1997$assoc_list$AssocList$keys(distributors)),
			_List_fromArray(
				[$author$project$PriceListForm$FixedMonthlyOption])));
};
var $author$project$PriceListForm$distributorName = F2(
	function (dict, key) {
		var nameFromKey = function () {
			var kk = key;
			return kk;
		}();
		return A2(
			$elm$core$Maybe$withDefault,
			nameFromKey,
			A2($pzp1997$assoc_list$AssocList$get, key, dict));
	});
var $author$project$PriceListForm$advancedComponentOptionToLocalizedString = F3(
	function (translations, distributors, option) {
		switch (option.$) {
			case 0:
				return A2($author$project$Enectiva$I18n$t, translations, 'price_js_list_adv_none');
			case 1:
				return A2($author$project$Enectiva$I18n$t, translations, 'pgetadv_fixed_price_cost');
			default:
				var key = option.a;
				return A2($author$project$PriceListForm$distributorName, distributors, key);
		}
	});
var $author$project$PriceListForm$advancedComponentOptionToString = function (option) {
	switch (option.$) {
		case 0:
			return 'none';
		case 1:
			return 'fixed';
		default:
			var key = option.a;
			return key;
	}
};
var $elm$html$Html$option = _VirtualDom_node('option');
var $elm$html$Html$Attributes$selected = $elm$html$Html$Attributes$boolProperty('selected');
var $author$project$PriceListForm$advancedCostComponentOption = F4(
	function (translations, distributors, form, option) {
		var selected = function () {
			var _v0 = _Utils_Tuple2(form, option);
			_v0$3:
			while (true) {
				switch (_v0.a.$) {
					case 0:
						if (!_v0.b.$) {
							var _v1 = _v0.a;
							var _v2 = _v0.b;
							return true;
						} else {
							break _v0$3;
						}
					case 1:
						if (_v0.b.$ === 1) {
							var _v3 = _v0.b;
							return true;
						} else {
							break _v0$3;
						}
					default:
						if (_v0.b.$ === 2) {
							var _v4 = _v0.a;
							var key1 = _v4.a;
							var key2 = _v0.b.a;
							return _Utils_eq(key1, key2);
						} else {
							break _v0$3;
						}
				}
			}
			return false;
		}();
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(
					$author$project$PriceListForm$advancedComponentOptionToString(option)),
					$elm$html$Html$Attributes$selected(selected)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A3($author$project$PriceListForm$advancedComponentOptionToLocalizedString, translations, distributors, option))
				]));
	});
var $elm$html$Html$select = _VirtualDom_node('select');
var $author$project$PriceListForm$priceComponentsSelect = F3(
	function (translations, distributors, form) {
		return A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex gap-2 items-center')
				]),
			_List_fromArray(
				[
					A2($author$project$View$tt, translations, 'price_js_list_adv_head'),
					A2(
					$elm$html$Html$select,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$Events$on,
							'change',
							A2(
								$elm$json$Json$Decode$map,
								$author$project$PriceListForm$AdvancedComponentOptionSelected,
								A2(
									$elm$json$Json$Decode$andThen,
									A2($elm$core$Basics$composeR, $author$project$PriceListForm$advancedComponentOptionFromString, $elm$json$Json$Decode$succeed),
									$elm$html$Html$Events$targetValue))),
							$elm$html$Html$Attributes$class('textfield')
						]),
					A2(
						$elm$core$List$map,
						A3($author$project$PriceListForm$advancedCostComponentOption, translations, distributors, form),
						$author$project$PriceListForm$advancedComponentOptions(distributors)))
				]));
	});
var $author$project$PriceListForm$YearClicked = function (a) {
	return {$: 8, a: a};
};
var $elm$html$Html$li = _VirtualDom_node('li');
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $author$project$PriceListForm$yearSelection = function (years) {
	var activeDependentClasses = function (y) {
		return _Utils_eq(
			y,
			$turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$current(years)) ? 'bg-blue-500 text-white' : 'bg-grey-200';
	};
	return A2(
		$elm$html$Html$ul,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex gap-4')
			]),
		A2(
			$elm$core$List$map,
			function (y) {
				return A2(
					$elm$html$Html$li,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('rounded py-1 px-4'),
									$elm$html$Html$Attributes$class('hover:bg-grey-700 hover:text-white'),
									$elm$html$Html$Attributes$class('focus:bg-grey-700 focus:text-white'),
									$elm$html$Html$Attributes$class(
									activeDependentClasses(y)),
									$elm$html$Html$Events$onClick(
									$author$project$PriceListForm$YearClicked(y))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(y))
								]))
						]));
			},
			$turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$toList(years)));
};
var $author$project$PriceListForm$advancedComponentDialogContent = function (_v0) {
	var translations = _v0.Z;
	var advanced = _v0.z;
	var distributors = _v0.bV;
	var currency = _v0.bC;
	var energy = _v0.bY;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$author$project$Spinner$container,
				$elm$html$Html$Attributes$class('min-w-256 min-h-96 flex flex-col gap-8')
			]),
		_List_fromArray(
			[
				A3($author$project$PriceListForm$priceComponentsSelect, translations, distributors, advanced.B),
				function () {
				var _v1 = advanced.B;
				switch (_v1.$) {
					case 0:
						return $author$project$Enectiva$View$nothing;
					case 1:
						var rate = _v1.a;
						return A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex items-center gap-2')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($author$project$Enectiva$I18n$t, translations, 'pgetadv_fixed_price_cost')),
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$value(
											A2($author$project$Enectiva$I18n$formatNumber, translations, rate)),
											$author$project$View$onChange($author$project$PriceListForm$MonthlyFixedPriceEntered),
											$elm$html$Html$Attributes$class('textfield w-32 text-right')
										]),
									_List_Nil),
									$elm$html$Html$text(currency)
								]));
					default:
						var data = _v1.b;
						switch (data.$) {
							case 3:
								var _v3 = data.a;
								var years = _v3.a;
								var lineItems = _v3.b;
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('flex flex-col gap-4')
										]),
									_List_fromArray(
										[
											$author$project$PriceListForm$yearSelection(years),
											A4($author$project$PriceListForm$lineItemsTable, translations, lineItems, energy, currency)
										]));
							case 1:
								return $author$project$Spinner$overlay(true);
							case 2:
								var err = data.a;
								return $elm$html$Html$text(
									$author$project$Enectiva$HttpExtra$errorToString(err));
							default:
								return $author$project$Enectiva$View$nothing;
						}
				}
			}()
			]));
};
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $author$project$Dialog$options = {bR: $elm$core$Maybe$Nothing, b8: $elm$core$Maybe$Nothing, b9: $elm$core$Maybe$Nothing, cl: $elm$core$Maybe$Nothing};
var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var $elm$svg$Svg$Attributes$x = _VirtualDom_attribute('x');
var $elm$svg$Svg$Attributes$y = _VirtualDom_attribute('y');
var $author$project$SvgIcons$close = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$x('0px'),
			$elm$svg$Svg$Attributes$y('0px'),
			$elm$svg$Svg$Attributes$width('12.729px'),
			$elm$svg$Svg$Attributes$height('12.729px'),
			$elm$svg$Svg$Attributes$viewBox('0 0 12.729 12.729'),
			$elm$svg$Svg$Attributes$fill('currentColor')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M 12.729,2.122 10.606,0 6.364,4.243 2.122,0 0,2.122 4.243,6.364 0,10.607 2.121,12.729 6.364,8.485 10.606,12.729 12.729,10.606 8.486,6.364 Z')
				]),
			_List_Nil)
		]));
var $elm$html$Html$Attributes$title = $elm$html$Html$Attributes$stringProperty('title');
var $author$project$Dialog$cancelButton = F2(
	function (translations, onCancel) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_('button'),
					$elm$html$Html$Attributes$title(
					A2($author$project$Enectiva$I18n$t, translations, 'cancel')),
					$elm$html$Html$Events$onClick(onCancel),
					$elm$html$Html$Attributes$class('w-6 h-6'),
					$elm$html$Html$Attributes$class('text-white flex items-center justify-center'),
					$elm$html$Html$Attributes$class('bg-grey-500 rounded transition-colors duration-75'),
					$elm$html$Html$Attributes$class('hover:bg-grey-800 focus:bg-grey-800')
				]),
			_List_fromArray(
				[$author$project$SvgIcons$close]));
	});
var $author$project$Dialog$placeholder = A2($elm$html$Html$div, _List_Nil, _List_Nil);
var $author$project$Enectiva$View$viewJust = F2(
	function (view, maybe) {
		if (!maybe.$) {
			var whatever = maybe.a;
			return view(whatever);
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Enectiva$View$viewMaybe = F3(
	function (viewValue, viewError, maybe) {
		if (!maybe.$) {
			var whatever = maybe.a;
			return viewValue(whatever);
		} else {
			return viewError(0);
		}
	});
var $author$project$Dialog$dialogHeading = F2(
	function (translations, _v0) {
		var onCancel = _v0.b8;
		var title = _v0.cl;
		return _Utils_eq(
			_Utils_Tuple2(onCancel, title),
			_Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing)) ? _List_Nil : $elm$core$List$singleton(
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex justify-between items-center gap-8')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Enectiva$View$viewMaybe,
						$elm$core$Basics$identity,
						$elm$core$Basics$always($author$project$Dialog$placeholder),
						title),
						A2(
						$author$project$Enectiva$View$viewJust,
						$author$project$Dialog$cancelButton(translations),
						onCancel)
					])));
	});
var $author$project$Dialog$doneButton = function (_v0) {
	var tagger = _v0.a;
	var txt = _v0.b;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mt-4 flex flex-right justify-end')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('submit-button'),
						$elm$html$Html$Events$onClick(tagger),
						$elm$html$Html$Attributes$type_('button')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(txt)
					]))
			]));
};
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
var $author$project$Dialog$view = F5(
	function (translations, elementId, opts, attr, content) {
		return A3(
			$elm$html$Html$node,
			'dialog',
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id(elementId),
						$elm$html$Html$Attributes$class('space-y-4 min-w-64 shadow-md rounded'),
						$elm$html$Html$Attributes$class(
						A2($elm$core$Maybe$withDefault, '', opts.bR))
					]),
				attr),
			_Utils_ap(
				A2($author$project$Dialog$dialogHeading, translations, opts),
				_Utils_ap(
					content,
					_List_fromArray(
						[
							A2($author$project$Enectiva$View$viewJust, $author$project$Dialog$doneButton, opts.b9)
						]))));
	});
var $author$project$Dialog$withCancelButton = F2(
	function (onCancel, opts) {
		return _Utils_update(
			opts,
			{
				b8: $elm$core$Maybe$Just(onCancel)
			});
	});
var $author$project$Dialog$withDone = F3(
	function (tagger, str, opts) {
		return _Utils_update(
			opts,
			{
				b9: $elm$core$Maybe$Just(
					_Utils_Tuple2(tagger, str))
			});
	});
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $author$project$Dialog$withTitle = F2(
	function (title, opts) {
		return _Utils_update(
			opts,
			{
				cl: $elm$core$Maybe$Just(title)
			});
	});
var $author$project$Dialog$withTextTitle = function (title) {
	return $author$project$Dialog$withTitle(
		A2(
			$elm$html$Html$h1,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-lg font-bold text-grey-800')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(title)
				])));
};
var $author$project$PriceListForm$advancedComponentsDialog = function (model) {
	var translations = model.Z;
	var _v0 = function () {
		var _v1 = model.z.aY;
		if (_v1.$ === 1) {
			return _Utils_Tuple2(
				A2(
					$author$project$Dialog$withTextTitle,
					A2($author$project$Enectiva$I18n$t, translations, 'price_js_price_dialog_title'),
					A2(
						$author$project$Dialog$withCancelButton,
						$author$project$PriceListForm$AdvancedComponentMsg($author$project$PriceListForm$CloseAdvancedComponentDialogButtonClicked),
						A3(
							$author$project$Dialog$withDone,
							$author$project$PriceListForm$AdvancedComponentMsg($author$project$PriceListForm$SaveAdvancedComponentButtonClicked),
							A2($author$project$Enectiva$I18n$t, translations, 'datepicker.done'),
							$author$project$Dialog$options))),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$PriceListForm$AdvancedComponentMsg,
						$author$project$PriceListForm$advancedComponentDialogContent(model))
					]));
		} else {
			return _Utils_Tuple2($author$project$Dialog$options, _List_Nil);
		}
	}();
	var opts = _v0.a;
	var children = _v0.b;
	return A5($author$project$Dialog$view, translations, $author$project$PriceListForm$advancedComponentDialogId, opts, _List_Nil, children);
};
var $author$project$PriceListForm$CancelCostEditButtonClicked = {$: 12};
var $author$project$PriceListForm$SaveCostEditButtonClicked = {$: 13};
var $author$project$PriceListForm$EditCostMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$PriceListForm$NewTariffButtonClicked = {$: 0};
var $author$project$PriceListForm$addNewButton = F2(
	function (title, msg) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(msg),
					$elm$html$Html$Attributes$class('rounded-full inline-block w-8 h-8'),
					$elm$html$Html$Attributes$class('text-center text-lg font-bold text-white bg-blue-500'),
					$elm$html$Html$Attributes$class('hover:bg-blue-800 focus:bg-blue-800'),
					$elm$html$Html$Attributes$type_('button'),
					$elm$html$Html$Attributes$title(title)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('+')
				]));
	});
var $author$project$PriceListForm$fieldName = F2(
	function (translations, k) {
		return (k === 'base') ? '' : A2($author$project$Enectiva$I18n$t, translations, 'activerecord.attributes.price_list.' + k);
	});
var $author$project$ServerErrors$viewAllFields = F2(
	function (fn, errors) {
		if ((!errors.$) && (errors.a.$ === 1)) {
			var dict = errors.a.a;
			return A2(
				$elm$core$List$concatMap,
				function (_v1) {
					var f = _v1.a;
					var errs = _v1.b;
					return A2(fn, f, errs);
				},
				$elm$core$Dict$toList(dict));
		} else {
			return _List_Nil;
		}
	});
var $author$project$ServerErrors$viewGeneral = F2(
	function (fn, errors) {
		if ((!errors.$) && (!errors.a.$)) {
			var reason = errors.a.a;
			return $elm$core$Maybe$Just(
				fn(reason));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$PriceListForm$errorToLocalizedString = F2(
	function (translations, error) {
		switch (error.$) {
			case 0:
				return $elm$core$List$singleton(
					A2($author$project$Enectiva$I18n$t, translations, 'price_list.tariff.error.duplicate_start'));
			case 1:
				return $elm$core$List$singleton(
					A2($author$project$Enectiva$I18n$t, translations, 'price_list.tariff.error.no_beginning'));
			case 2:
				return $elm$core$List$singleton(
					A2($author$project$Enectiva$I18n$t, translations, 'price_list.exceptional_costs.range_does_not_match_regular'));
			case 3:
				var serverErrors = error.a;
				var perFields = A2(
					$author$project$ServerErrors$viewAllFields,
					F2(
						function (f, errs) {
							return A2(
								$elm$core$List$map,
								function (e) {
									return (f === '') ? e : (A2($author$project$PriceListForm$fieldName, translations, f) + (' ' + e));
								},
								errs);
						}),
					$elm$core$Maybe$Just(serverErrors));
				var _v1 = A2(
					$author$project$ServerErrors$viewGeneral,
					$elm$core$Basics$identity,
					$elm$core$Maybe$Just(serverErrors));
				if (!_v1.$) {
					var general = _v1.a;
					return A2($elm$core$List$cons, general, perFields);
				} else {
					return perFields;
				}
			default:
				return $elm$core$List$singleton('The entered values are invalid');
		}
	});
var $author$project$Palette$fallback = 'lightgrey';
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{L: nodeList, D: nodeListSize, G: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $avh4$elm_color$Color$hsla = F4(
	function (hue, sat, light, alpha) {
		var _v0 = _Utils_Tuple3(hue, sat, light);
		var h = _v0.a;
		var s = _v0.b;
		var l = _v0.c;
		var m2 = (l <= 0.5) ? (l * (s + 1)) : ((l + s) - (l * s));
		var m1 = (l * 2) - m2;
		var hueToRgb = function (h__) {
			var h_ = (h__ < 0) ? (h__ + 1) : ((h__ > 1) ? (h__ - 1) : h__);
			return ((h_ * 6) < 1) ? (m1 + (((m2 - m1) * h_) * 6)) : (((h_ * 2) < 1) ? m2 : (((h_ * 3) < 2) ? (m1 + (((m2 - m1) * ((2 / 3) - h_)) * 6)) : m1));
		};
		var b = hueToRgb(h - (1 / 3));
		var g = hueToRgb(h);
		var r = hueToRgb(h + (1 / 3));
		return A4($avh4$elm_color$Color$RgbaSpace, r, g, b, alpha);
	});
var $avh4$elm_color$Color$hsl = F3(
	function (h, s, l) {
		return A4($avh4$elm_color$Color$hsla, h, s, l, 1.0);
	});
var $elm$core$Elm$JsArray$map = _JsArray_map;
var $elm$core$Array$map = F2(
	function (func, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = function (node) {
			if (!node.$) {
				var subTree = node.a;
				return $elm$core$Array$SubTree(
					A2($elm$core$Elm$JsArray$map, helper, subTree));
			} else {
				var values = node.a;
				return $elm$core$Array$Leaf(
					A2($elm$core$Elm$JsArray$map, func, values));
			}
		};
		return A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			A2($elm$core$Elm$JsArray$map, helper, tree),
			A2($elm$core$Elm$JsArray$map, func, tail));
	});
var $avh4$elm_color$Color$toCssString = function (_v0) {
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	var a = _v0.d;
	var roundTo = function (x) {
		return $elm$core$Basics$round(x * 1000) / 1000;
	};
	var pct = function (x) {
		return $elm$core$Basics$round(x * 10000) / 100;
	};
	return $elm$core$String$concat(
		_List_fromArray(
			[
				'rgba(',
				$elm$core$String$fromFloat(
				pct(r)),
				'%,',
				$elm$core$String$fromFloat(
				pct(g)),
				'%,',
				$elm$core$String$fromFloat(
				pct(b)),
				'%,',
				$elm$core$String$fromFloat(
				roundTo(a)),
				')'
			]));
};
var $author$project$Palette$gradual = A2(
	$elm$core$Array$map,
	$avh4$elm_color$Color$toCssString,
	$elm$core$Array$fromList(
		_List_fromArray(
			[
				A3($avh4$elm_color$Color$hsl, 206.0 / 360, 1, 0.97),
				A3($avh4$elm_color$Color$hsl, 207.0 / 360, 0.97, 0.93),
				A3($avh4$elm_color$Color$hsl, 207.0 / 360, 0.93, 0.9),
				A3($avh4$elm_color$Color$hsl, 207.0 / 360, 0.89, 0.88),
				A3($avh4$elm_color$Color$hsl, 207.0 / 360, 0.86, 0.86),
				A3($avh4$elm_color$Color$hsl, 207.0 / 360, 0.84, 0.82),
				A3($avh4$elm_color$Color$hsl, 207.0 / 360, 0.82, 0.77),
				A3($avh4$elm_color$Color$hsl, 207.0 / 360, 0.8, 0.73),
				A3($avh4$elm_color$Color$hsl, 207.0 / 360, 0.78, 0.7),
				A3($avh4$elm_color$Color$hsl, 207.0 / 360, 0.76, 0.67),
				A3($avh4$elm_color$Color$hsl, 207.0 / 360, 0.74, 0.62),
				A3($avh4$elm_color$Color$hsl, 207.0 / 360, 0.72, 0.58),
				A3($avh4$elm_color$Color$hsl, 207.0 / 360, 0.71, 0.53),
				A3($avh4$elm_color$Color$hsl, 207.0 / 360, 0.69, 0.5),
				A3($avh4$elm_color$Color$hsl, 207.0 / 360, 0.67, 0.47),
				A3($avh4$elm_color$Color$hsl, 207.0 / 360, 0.66, 0.45),
				A3($avh4$elm_color$Color$hsl, 207.0 / 360, 0.64, 0.45),
				A3($avh4$elm_color$Color$hsl, 207.0 / 360, 0.62, 0.4),
				A3($avh4$elm_color$Color$hsl, 207.0 / 360, 0.6, 0.35),
				A3($avh4$elm_color$Color$hsl, 207.0 / 360, 0.58, 0.31),
				A3($avh4$elm_color$Color$hsl, 207.0 / 360, 0.56, 0.27),
				A3($avh4$elm_color$Color$hsl, 208.0 / 360, 0.53, 0.23),
				A3($avh4$elm_color$Color$hsl, 208.0 / 360, 0.53, 0.2),
				A3($avh4$elm_color$Color$hsl, 207.0 / 360, 0.53, 0.15)
			])));
var $elm$core$Array$length = function (_v0) {
	var len = _v0.a;
	return len;
};
var $author$project$Palette$length = $elm$core$Array$length($author$project$Palette$gradual);
var $author$project$Palette$at = function (i) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Palette$fallback,
		A2(
			$elm$core$Array$get,
			A2($elm$core$Basics$modBy, $author$project$Palette$length, i),
			$author$project$Palette$gradual));
};
var $elm$core$Bitwise$xor = _Bitwise_xor;
var $author$project$Palette$fromString = function (identifier) {
	return $author$project$Palette$at(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_char, hash) {
					return (hash ^ $elm$core$Char$toCode(_char)) * 7;
				}),
			0,
			$elm$core$String$toList(identifier)));
};
var $turboMaCk$non_empty_list_alias$List$NonEmpty$isSingleton = function (_v0) {
	var t = _v0.b;
	return $elm$core$List$isEmpty(t);
};
var $elm_community$list_extra$List$Extra$zip = $elm$core$List$map2($elm$core$Tuple$pair);
var $author$project$PriceListForm$periodRanges = function (cost) {
	var starts = $author$project$PriceListForm$periodStarts(cost);
	var shifted = _Utils_ap(
		A2($elm$core$List$drop, 1, starts),
		_List_fromArray(
			[2400]));
	return $elm$core$Dict$fromList(
		A2($elm_community$list_extra$List$Extra$zip, starts, shifted));
};
var $author$project$PriceListForm$renderTickLabel = F2(
	function (count, i) {
		return (count === 1) ? ((!i) || (i === 24)) : ((count === 2) ? (!A2($elm$core$Basics$modBy, 4, i)) : ((count === 3) ? (!A2($elm$core$Basics$modBy, 3, i)) : ((count === 4) ? (!A2($elm$core$Basics$modBy, 2, i)) : true)));
	});
var $author$project$BareTime$toString = function (time) {
	var _v0 = $author$project$BareTime$toComponents(time);
	var hours = _v0.a;
	var minutes = _v0.b;
	var hoursString = A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(hours));
	var minutesString = A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(minutes));
	return hoursString + (':' + minutesString);
};
var $author$project$PriceListForm$axis = function (segmentCount) {
	return A2(
		$elm$html$Html$ul,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('text-grey-700 text-right text-xs tabular-nums h-full')
			]),
		A2(
			$elm$core$List$map,
			$elm$html$Html$li(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('chart-tick-vertical')
					])),
			A2(
				$elm$core$List$map,
				function (_v0) {
					var i = _v0.a;
					var val = _v0.b;
					return A2($author$project$PriceListForm$renderTickLabel, segmentCount, i) ? $elm$core$List$singleton(
						A2(
							$elm$html$Html$div,
							_List_Nil,
							$elm$core$List$singleton(
								$elm$html$Html$text(
									$author$project$BareTime$toString(val))))) : $elm$core$List$singleton($author$project$Enectiva$View$nothing);
				},
				A2(
					$elm$core$List$indexedMap,
					F2(
						function (i, val) {
							return _Utils_Tuple2(i, val * 100);
						}),
					A2($elm$core$List$range, 0, 24)))));
};
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $author$project$Enectiva$Conversion$toPercentString = function (val) {
	return function (a) {
		return a + '%';
	}(
		$elm$core$String$fromFloat(100 * val));
};
var $author$project$PriceListForm$barChartSegment = F2(
	function (maxMagnitude, _v0) {
		var length = _v0.bf;
		var magnitude = _v0.cM;
		var color = _v0.de;
		var tariffName = _v0.dL;
		var width = $author$project$Enectiva$Conversion$toPercentString(magnitude / maxMagnitude);
		var height = $author$project$Enectiva$Conversion$toPercentString(length / 2400);
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'width', width),
					A2($elm$html$Html$Attributes$style, 'height', height),
					A2($elm$html$Html$Attributes$style, 'background', color),
					$elm$html$Html$Attributes$title(tariffName)
				]),
			_List_Nil);
	});
var $author$project$PriceListForm$bars = function (segments) {
	var maxMagnitude = A2(
		$elm$core$Maybe$withDefault,
		0,
		$elm$core$List$maximum(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.cM;
				},
				segments)));
	return A2(
		$elm$html$Html$ul,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('w-32 h-full relative'),
				A2($elm$html$Html$Attributes$style, 'top', 'calc(100%/24/2)')
			]),
		A2(
			$elm$core$List$map,
			$author$project$PriceListForm$barChartSegment(maxMagnitude),
			segments));
};
var $author$project$PriceListForm$chartView = function (segments) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('min-h-64 max-h-128 flex items-center')
			]),
		_List_fromArray(
			[
				$author$project$PriceListForm$axis(
				$elm$core$List$length(segments)),
				$author$project$PriceListForm$bars(segments)
			]));
};
var $author$project$PriceListForm$emptySegment = {de: $author$project$Palette$fallback, bf: 0, cM: 0, dK: 2400, dL: ''};
var $author$project$PriceListForm$periodToChartSegment = F5(
	function (color, tariffName, price, ranges, _v0) {
		var from = _v0.q;
		var error = _v0.Q;
		var _v1 = _Utils_Tuple2(error, from);
		if ((_v1.a.$ === 1) && (!_v1.b.$)) {
			var _v2 = _v1.a;
			var editableFrom = _v1.b.a;
			var to = A2(
				$elm$core$Maybe$withDefault,
				2400,
				A2($elm$core$Dict$get, editableFrom, ranges));
			var start = editableFrom;
			return {de: color, bf: to - start, cM: price, dK: start, dL: tariffName};
		} else {
			return $author$project$PriceListForm$emptySegment;
		}
	});
var $author$project$PriceListForm$segmentsFromTariffs = F2(
	function (ranges, tariffs) {
		return A2(
			$elm$core$List$sortBy,
			function ($) {
				return $.dK;
			},
			$elm$core$List$concat(
				A2(
					$elm$core$List$indexedMap,
					F2(
						function (i, tariff) {
							var name = tariff.gu;
							var color = $author$project$Palette$fromString(tariff.gu);
							return A2(
								$elm$core$List$map,
								A4($author$project$PriceListForm$periodToChartSegment, color, name, tariff._, ranges),
								$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(tariff.s));
						}),
					tariffs)));
	});
var $author$project$PriceListForm$render = function (cost) {
	return $author$project$PriceListForm$chartView(
		A2(
			$author$project$PriceListForm$segmentsFromTariffs,
			$author$project$PriceListForm$periodRanges(cost),
			$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(cost.f)));
};
var $author$project$PriceListForm$NewPeriodButtonClicked = function (a) {
	return {$: 4, a: a};
};
var $author$project$PriceListForm$PI = $elm$core$Basics$identity;
var $author$project$PriceListForm$RemoveTariffButtonClicked = function (a) {
	return {$: 1, a: a};
};
var $author$project$PriceListForm$TariffNameEntered = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$PriceListForm$TariffPriceEntered = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$SvgIcons$trash = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$x('0px'),
			$elm$svg$Svg$Attributes$y('0px'),
			$elm$svg$Svg$Attributes$width('17.98px'),
			$elm$svg$Svg$Attributes$height('21px'),
			$elm$svg$Svg$Attributes$viewBox('0 0 17.98 21'),
			$elm$svg$Svg$Attributes$fill('currentColor')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M6.622,0.5h4.532c0.49,0,0.889,0.398,0.889,0.889v0.89h4.444c0.491,0,0.89,0.397,0.89,0.889v0.889 c0,0.491-0.396,0.889-0.89,0.889H1.289c-0.491,0-0.89-0.397-0.89-0.889v-0.89c0-0.491,0.396-0.889,0.89-0.889h4.444v-0.89 C5.734,0.898,6.131,0.5,6.622,0.5z M2.11,18.029C2.213,19.423,3.409,20.5,4.806,20.5h8.164c1.396,0,2.594-1.077,2.695-2.471V6.721 H2.11V18.029z')
				]),
			_List_Nil)
		]));
var $author$project$PriceListForm$deleteButton = F2(
	function (translations, msg) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_('button'),
					$elm$html$Html$Events$onClick(msg),
					$elm$html$Html$Attributes$class('icon area-icon delete-icon'),
					$elm$html$Html$Attributes$title(
					A2($author$project$Enectiva$I18n$t, translations, 'remove'))
				]),
			_List_fromArray(
				[$author$project$SvgIcons$trash]));
	});
var $author$project$Enectiva$I18n$asFloat = function (prec) {
	return (prec < 1) ? $author$project$Enectiva$I18n$AsFloat(1) : $author$project$Enectiva$I18n$AsFloat(prec);
};
var $author$project$View$formatNumberWithPrecisionAndNbsp = F2(
	function (translations, precision) {
		return A2(
			$elm$core$Basics$composeR,
			A2(
				$author$project$Enectiva$I18n$formatNumberWithPrecision,
				translations,
				$author$project$Enectiva$I18n$asFloat(precision)),
			$author$project$View$replaceSpacesByNbsp);
	});
var $author$project$PriceListForm$formatUnitPrice = F2(
	function (translations, _v0) {
		var unitPrice = _v0._;
		return A3($author$project$View$formatNumberWithPrecisionAndNbsp, translations, 6, unitPrice);
	});
var $author$project$PriceListForm$PeriodFromEntered = F3(
	function (a, b, c) {
		return {$: 6, a: a, b: b, c: c};
	});
var $author$project$PriceListForm$RemovePeriodButtonClicked = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $elm$html$Html$span = _VirtualDom_node('span');
var $author$project$PriceListForm$periodView = F6(
	function (translations, ranges, allowDelete, tariffIndex, periodIndex, period) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col gap-2')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Enectiva$View$viewJust,
					function (err) {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-red-600 error')
								]),
							A2(
								$elm$core$List$map,
								$elm$html$Html$text,
								A2($author$project$PriceListForm$errorToLocalizedString, translations, err)));
					},
					period.Q),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex justify-between items-center')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex gap-2 items-center')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$author$project$View$onChange(
											A2($author$project$PriceListForm$PeriodFromEntered, tariffIndex, periodIndex)),
											$elm$html$Html$Attributes$value(
											function () {
												var _v0 = period.q;
												if (!_v0.$) {
													var f = _v0.a;
													return $author$project$BareTime$toString(f);
												} else {
													return '';
												}
											}()),
											$elm$html$Html$Attributes$class('textfield w-20')
										]),
									_List_Nil),
									$elm$html$Html$text(' – '),
									A2(
									$author$project$Enectiva$View$viewJust,
									function (f) {
										return A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$BareTime$toString(
														A2(
															$elm$core$Maybe$withDefault,
															2400,
															A2($elm$core$Dict$get, f, ranges))))
												]));
									},
									period.q)
								])),
							A2(
							$author$project$Enectiva$View$viewIf,
							$elm$core$Basics$always(
								A2(
									$author$project$PriceListForm$deleteButton,
									translations,
									A2($author$project$PriceListForm$RemovePeriodButtonClicked, tariffIndex, periodIndex))),
							allowDelete)
						]))
				]));
	});
var $author$project$PriceListForm$tariffTextField = F3(
	function (placeholder, msg, value) {
		return A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex items-center gap-2')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-48 text-grey-700')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(placeholder)
						])),
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$placeholder(placeholder),
							$author$project$View$onChange(msg),
							$elm$html$Html$Attributes$value(value),
							$elm$html$Html$Attributes$class('textfield w-48')
						]),
					_List_Nil)
				]));
	});
var $author$project$PriceListForm$tariffView = F6(
	function (translations, ranges, tariffIndex, tariff, allowDelete, color) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('border-l-8 border-r-8 py-2 px-4'),
					A2($elm$html$Html$Attributes$style, 'border-color', color),
					$elm$html$Html$Attributes$class('flex flex-col gap-2 rounded')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$PriceListForm$tariffTextField,
					A2($author$project$Enectiva$I18n$t, translations, 'price_list.tariff.name'),
					$author$project$PriceListForm$TariffNameEntered(tariffIndex),
					tariff.gu),
					A3(
					$author$project$PriceListForm$tariffTextField,
					A2($author$project$Enectiva$I18n$t, translations, 'price_list.tariff.price_per_unit'),
					$author$project$PriceListForm$TariffPriceEntered(tariffIndex),
					A2($author$project$PriceListForm$formatUnitPrice, translations, tariff)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex gap-2')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('w-48')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Enectiva$View$viewIf,
									$elm$core$Basics$always(
										A2(
											$author$project$PriceListForm$deleteButton,
											translations,
											$author$project$PriceListForm$RemoveTariffButtonClicked(tariffIndex))),
									allowDelete)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-col gap-2 grow')
								]),
							_Utils_ap(
								A2(
									$elm$core$List$indexedMap,
									F2(
										function (i, p) {
											return A6(
												$author$project$PriceListForm$periodView,
												translations,
												ranges,
												!$turboMaCk$non_empty_list_alias$List$NonEmpty$isSingleton(tariff.s),
												tariffIndex,
												i,
												p);
										}),
									$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(tariff.s)),
								_List_fromArray(
									[
										A2(
										$author$project$PriceListForm$addNewButton,
										A2($author$project$Enectiva$I18n$t, translations, 'price_list.tariffs.dialog.add_period'),
										$author$project$PriceListForm$NewPeriodButtonClicked(tariffIndex))
									])))
						]))
				]));
	});
var $author$project$PriceListForm$costEditingDialogContent = F2(
	function (translations, cost) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex gap-8 pb-8')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col gap-4')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Enectiva$View$viewJust,
							A2(
								$elm$core$Basics$composeR,
								$author$project$PriceListForm$errorToLocalizedString(translations),
								A2(
									$elm$core$Basics$composeR,
									$elm$core$List$map($elm$html$Html$text),
									$elm$html$Html$div(
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-red-600 error')
											])))),
							cost.Q),
							A2(
							$elm$html$Html$map,
							$author$project$PriceListForm$EditCostMsg,
							A2(
								$elm$html$Html$ul,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex flex-col gap-2')
									]),
								A2(
									$elm$core$List$indexedMap,
									F2(
										function (i, t) {
											return A6(
												$author$project$PriceListForm$tariffView,
												translations,
												$author$project$PriceListForm$periodRanges(cost),
												i,
												t,
												!$turboMaCk$non_empty_list_alias$List$NonEmpty$isSingleton(cost.f),
												$author$project$Palette$fromString(t.gu));
										}),
									$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(cost.f)))),
							A2(
							$elm$html$Html$map,
							$author$project$PriceListForm$EditCostMsg,
							A2(
								$author$project$PriceListForm$addNewButton,
								A2($author$project$Enectiva$I18n$t, translations, 'price_list.tariffs.dialog.add_tariff'),
								$author$project$PriceListForm$NewTariffButtonClicked))
						])),
					$author$project$PriceListForm$render(cost)
				]));
	});
var $author$project$PriceListForm$costEditingDialog = function (_v0) {
	var translations = _v0.Z;
	var editedCost = _v0.ah;
	var _v1 = function () {
		if (!editedCost.$) {
			var c = editedCost.a;
			return _Utils_Tuple2(
				A2(
					$author$project$Dialog$withTextTitle,
					A2($author$project$Enectiva$I18n$t, translations, 'price_list.tariffs.dialog.title'),
					A2(
						$author$project$Dialog$withCancelButton,
						$author$project$PriceListForm$CancelCostEditButtonClicked,
						A3(
							$author$project$Dialog$withDone,
							$author$project$PriceListForm$SaveCostEditButtonClicked,
							A2($author$project$Enectiva$I18n$t, translations, 'datepicker.done'),
							$author$project$Dialog$options))),
				_List_fromArray(
					[
						A2($author$project$PriceListForm$costEditingDialogContent, translations, c)
					]));
		} else {
			return _Utils_Tuple2($author$project$Dialog$options, _List_Nil);
		}
	}();
	var opts = _v1.a;
	var children = _v1.b;
	return A5($author$project$Dialog$view, translations, $author$project$PriceListForm$costDialogId, opts, _List_Nil, children);
};
var $author$project$PriceListForm$CloseElPowerByCurrentAndBreakerDialogButtonClicked = {$: 4};
var $author$project$PriceListForm$dataForSinglePhase = function (prices) {
	return A2(
		$elm$core$List$map,
		function (price) {
			if (price.$ === 2) {
				var dict = price.a;
				return $elm$core$List$concat(
					A2(
						$elm$core$List$map,
						function (_v1) {
							var phase = _v1.b;
							return phase.gJ;
						},
						$elm$core$Dict$toList(dict)));
			} else {
				return _List_Nil;
			}
		},
		prices);
};
var $author$project$PriceListForm$dataForThreePhase = function (prices) {
	return A2(
		$elm$core$List$map,
		function (price) {
			if (price.$ === 2) {
				var dict = price.a;
				return $elm$core$List$concat(
					A2(
						$elm$core$List$map,
						function (_v1) {
							var phase = _v1.b;
							return phase.gK;
						},
						$elm$core$Dict$toList(dict)));
			} else {
				return _List_Nil;
			}
		},
		prices);
};
var $author$project$PriceListForm$extractRepresentativeSingleComponentPrice = function (c) {
	return $author$project$PriceListForm$extractRepresentativeSingleComponent(c).aA;
};
var $author$project$PriceListForm$phaseTableColspan = 8;
var $author$project$Enectiva$I18n$Placeholder = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm_community$list_extra$List$Extra$uniqueHelp = F4(
	function (f, existing, remaining, accumulator) {
		uniqueHelp:
		while (true) {
			if (!remaining.b) {
				return $elm$core$List$reverse(accumulator);
			} else {
				var first = remaining.a;
				var rest = remaining.b;
				var computedFirst = f(first);
				if (A2($elm$core$List$member, computedFirst, existing)) {
					var $temp$f = f,
						$temp$existing = existing,
						$temp$remaining = rest,
						$temp$accumulator = accumulator;
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				} else {
					var $temp$f = f,
						$temp$existing = A2($elm$core$List$cons, computedFirst, existing),
						$temp$remaining = rest,
						$temp$accumulator = A2($elm$core$List$cons, first, accumulator);
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$unique = function (list) {
	return A4($elm_community$list_extra$List$Extra$uniqueHelp, $elm$core$Basics$identity, _List_Nil, list, _List_Nil);
};
var $author$project$PriceListForm$priceEveryAfterValues = function (data) {
	return $elm$core$List$sort(
		$elm_community$list_extra$List$Extra$unique(
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				A2(
					$elm$core$List$filter,
					function (v) {
						return !_Utils_eq(v, $elm$core$Maybe$Nothing);
					},
					$elm$core$List$concat(
						A2(
							$elm$core$List$map,
							function (d) {
								return A2(
									$elm$core$List$map,
									function ($) {
										return $.d7;
									},
									d);
							},
							data))))));
};
var $author$project$Enectiva$I18n$applyOption = function (option) {
	if (!option.$) {
		var placeholder = option.a;
		var value = option.b;
		return A2(
			$elm$regex$Regex$replace,
			A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('%{' + (placeholder + '}'))),
			$elm$core$Basics$always(value));
	} else {
		return $elm$core$Basics$identity;
	}
};
var $author$project$Enectiva$I18n$one = 'one';
var $author$project$Enectiva$I18n$other = 'other';
var $author$project$Enectiva$I18n$fallbackPluralizationFn = function (cnt) {
	if (cnt === 1) {
		return $author$project$Enectiva$I18n$one;
	} else {
		return $author$project$Enectiva$I18n$other;
	}
};
var $author$project$Enectiva$I18n$few = 'few';
var $author$project$Enectiva$I18n$czechPluralizationFn = function (cnt) {
	switch (cnt) {
		case 1:
			return $author$project$Enectiva$I18n$one;
		case 2:
			return $author$project$Enectiva$I18n$few;
		case 3:
			return $author$project$Enectiva$I18n$few;
		case 4:
			return $author$project$Enectiva$I18n$few;
		default:
			return $author$project$Enectiva$I18n$other;
	}
};
var $author$project$Enectiva$I18n$frenchPluralizationFn = function (cnt) {
	switch (cnt) {
		case 0:
			return $author$project$Enectiva$I18n$one;
		case 1:
			return $author$project$Enectiva$I18n$one;
		default:
			return $author$project$Enectiva$I18n$other;
	}
};
var $author$project$Enectiva$I18n$slovakPluralizationFn = $author$project$Enectiva$I18n$czechPluralizationFn;
var $author$project$Enectiva$I18n$pluralizationFns = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('cs', $author$project$Enectiva$I18n$czechPluralizationFn),
			_Utils_Tuple2('sk', $author$project$Enectiva$I18n$slovakPluralizationFn),
			_Utils_Tuple2('fr', $author$project$Enectiva$I18n$frenchPluralizationFn),
			_Utils_Tuple2(
			'hu',
			$elm$core$Basics$always($author$project$Enectiva$I18n$other))
		]));
var $author$project$Enectiva$I18n$countToKeyPathSegment = F2(
	function (_v0, cnt) {
		var l = _v0.a;
		return A3(
			$elm$core$Basics$apR,
			A2($elm$core$Dict$get, l, $author$project$Enectiva$I18n$pluralizationFns),
			$elm$core$Maybe$withDefault($author$project$Enectiva$I18n$fallbackPluralizationFn),
			$elm$core$Basics$abs(cnt));
	});
var $author$project$Enectiva$I18n$providedCount = function (options) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Maybe$Nothing,
		$elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				function (o) {
					if (o.$ === 1) {
						var cnt = o.a;
						return $elm$core$Maybe$Just(
							$elm$core$Maybe$Just(cnt));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				options)));
};
var $author$project$Enectiva$I18n$tt = F3(
	function (translations, key, options) {
		var _v0 = $author$project$Enectiva$I18n$providedCount(options);
		if (!_v0.$) {
			var cnt = _v0.a;
			var _v1 = A2(
				$author$project$Enectiva$I18n$tHelp,
				translations,
				_Utils_ap(
					$author$project$Enectiva$I18n$keyToKeyPath(key),
					_List_fromArray(
						[
							A2($author$project$Enectiva$I18n$countToKeyPathSegment, translations, cnt)
						])));
			if (_v1.$ === 1) {
				var _v2 = A2(
					$author$project$Enectiva$I18n$tHelp,
					translations,
					_Utils_ap(
						$author$project$Enectiva$I18n$keyToKeyPath(key),
						_List_fromArray(
							[
								A2($author$project$Enectiva$I18n$countToKeyPathSegment, translations, 1)
							])));
				if (_v2.$ === 1) {
					return A2($author$project$Enectiva$I18n$t, translations, key);
				} else {
					var localized = _v2.a;
					return localized;
				}
			} else {
				var localized = _v1.a;
				return A2(
					$author$project$Enectiva$I18n$applyOption,
					A2(
						$author$project$Enectiva$I18n$Placeholder,
						'count',
						$elm$core$String$fromInt(cnt)),
					localized);
			}
		} else {
			return A3(
				$elm$core$List$foldl,
				$author$project$Enectiva$I18n$applyOption,
				A2($author$project$Enectiva$I18n$t, translations, key),
				options);
		}
	});
var $author$project$PriceListForm$priceEveryAfterRows = F2(
	function (translations, data) {
		return A2(
			$elm$core$List$map,
			function (ea) {
				return A2(
					$elm$html$Html$tr,
					_List_Nil,
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$th,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-semibold')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A3(
										$author$project$Enectiva$I18n$tt,
										translations,
										'price_js_every_amp_above',
										_List_fromArray(
											[
												A2(
												$author$project$Enectiva$I18n$Placeholder,
												'amps',
												A2($author$project$View$formatNumberWithNbsp, translations, ea))
											])))
								])),
						A2(
							$elm$core$List$map,
							function (phase) {
								var _v0 = phase.d7;
								if (!_v0.$) {
									var e = _v0.a;
									return _Utils_eq(e, ea) ? A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2($author$project$View$formatNumberWithNbsp, translations, phase.d0))
											])) : $author$project$Enectiva$View$nothing;
								} else {
									return $author$project$Enectiva$View$nothing;
								}
							},
							$elm$core$List$concat(data))));
			},
			$author$project$PriceListForm$priceEveryAfterValues(data));
	});
var $author$project$PriceListForm$priceToValues = function (data) {
	return $elm$core$List$sort(
		$elm_community$list_extra$List$Extra$unique(
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				A2(
					$elm$core$List$filter,
					function (v) {
						return !_Utils_eq(v, $elm$core$Maybe$Nothing);
					},
					$elm$core$List$concat(
						A2(
							$elm$core$List$map,
							function (d) {
								return A2(
									$elm$core$List$map,
									function ($) {
										return $.fi;
									},
									d);
							},
							data))))));
};
var $author$project$PriceListForm$priceToRows = F2(
	function (translations, data) {
		return A2(
			$elm$core$List$map,
			function (t) {
				return A2(
					$elm$html$Html$tr,
					_List_Nil,
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$th,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-semibold')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A3(
										$author$project$Enectiva$I18n$tt,
										translations,
										'price_js_until_amps',
										_List_fromArray(
											[
												A2(
												$author$project$Enectiva$I18n$Placeholder,
												'amps',
												A2($author$project$View$formatNumberWithNbsp, translations, t))
											])))
								])),
						A2(
							$elm$core$List$map,
							function (phase) {
								var _v0 = phase.fi;
								if (!_v0.$) {
									var to = _v0.a;
									return _Utils_eq(to, t) ? A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2($author$project$View$formatNumberWithNbsp, translations, phase.d0))
											])) : $author$project$Enectiva$View$nothing;
								} else {
									return $author$project$Enectiva$View$nothing;
								}
							},
							$elm$core$List$concat(data))));
			},
			$author$project$PriceListForm$priceToValues(data));
	});
var $author$project$PriceListForm$singlePhaseView = F2(
	function (translations, data) {
		return A2(
			$elm$core$List$cons,
			A2(
				$elm$html$Html$tr,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$th,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$colspan($author$project$PriceListForm$phaseTableColspan),
								$elm$html$Html$Attributes$class('bg-grey-200')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center')
									]),
								_List_fromArray(
									[
										A2($author$project$View$tt, translations, 'faze_faze1_group')
									]))
							]))
					])),
			_Utils_ap(
				A2($author$project$PriceListForm$priceToRows, translations, data),
				A2($author$project$PriceListForm$priceEveryAfterRows, translations, data)));
	});
var $author$project$PriceListForm$threePhaseView = F2(
	function (translations, data) {
		return A2(
			$elm$core$List$cons,
			A2(
				$elm$html$Html$tr,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$th,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$colspan($author$project$PriceListForm$phaseTableColspan),
								$elm$html$Html$Attributes$class('bg-grey-200')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center')
									]),
								_List_fromArray(
									[
										A2($author$project$View$tt, translations, 'faze_faze3_group')
									]))
							]))
					])),
			_Utils_ap(
				A2($author$project$PriceListForm$priceToRows, translations, data),
				A2($author$project$PriceListForm$priceEveryAfterRows, translations, data)));
	});
var $author$project$PriceListForm$elPowerByCurrentAndBreakerPhasesDialog = function (_v0) {
	var translations = _v0.Z;
	var currency = _v0.bC;
	var advanced = _v0.z;
	var _v1 = function () {
		var _v2 = advanced.B;
		if (((_v2.$ === 2) && (_v2.b.$ === 3)) && (!_v2.b.a.c)) {
			var _v3 = _v2.b.a;
			var lineItems = _v3.b;
			var _v4 = _v3.c;
			var prices = A2($elm$core$List$map, $author$project$PriceListForm$extractRepresentativeSingleComponentPrice, lineItems);
			var header = A2(
				$elm$html$Html$tr,
				_List_Nil,
				A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$th,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('bg-grey-300')
							]),
						_List_fromArray(
							[
								A2($author$project$View$tt, translations, 'price_js_jistic_value')
							])),
					A3($author$project$PriceListForm$distributionRateHeader, translations, prices, currency)));
			var content = A2(
				$elm$html$Html$table,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('list')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$thead,
						_List_Nil,
						_List_fromArray(
							[header])),
						A2(
						$elm$html$Html$tbody,
						_List_Nil,
						A2(
							$elm$core$List$append,
							A2(
								$author$project$PriceListForm$singlePhaseView,
								translations,
								$author$project$PriceListForm$dataForSinglePhase(prices)),
							A2(
								$author$project$PriceListForm$threePhaseView,
								translations,
								$author$project$PriceListForm$dataForThreePhase(prices))))
					]));
			return _Utils_Tuple2(
				A2(
					$author$project$Dialog$withTextTitle,
					A2($author$project$Enectiva$I18n$t, translations, 'price_js_dialog_detail_head'),
					A2(
						$author$project$Dialog$withCancelButton,
						$author$project$PriceListForm$AdvancedComponentMsg($author$project$PriceListForm$CloseElPowerByCurrentAndBreakerDialogButtonClicked),
						$author$project$Dialog$options)),
				_List_fromArray(
					[
						A2($elm$html$Html$map, $author$project$PriceListForm$AdvancedComponentMsg, content)
					]));
		} else {
			return _Utils_Tuple2($author$project$Dialog$options, _List_Nil);
		}
	}();
	var opts = _v1.a;
	var children = _v1.b;
	return A5($author$project$Dialog$view, translations, $author$project$PriceListForm$elPowerDialogId, opts, _List_Nil, children);
};
var $author$project$PriceListForm$FormSubmitted = {$: 5};
var $author$project$PriceListForm$Name = 0;
var $author$project$PriceListForm$Supplier = 1;
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $author$project$PriceListForm$AddNewCostButtonClicked = function (a) {
	return {$: 2, a: a};
};
var $author$project$PriceListForm$RemoveCostButtonClicked = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Enectiva$DateRange$ValidFrom = 0;
var $author$project$Enectiva$DateRange$ValidTo = 1;
var $author$project$PriceListForm$OpenAdvancedComponentDialogButtonClicked = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$SvgIcons$activeClass = function (active) {
	return active ? $elm$svg$Svg$Attributes$class('') : $elm$svg$Svg$Attributes$class('inactive');
};
var $author$project$SvgIcons$listMoney = function (active) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$class('line-icon'),
				$author$project$SvgIcons$activeClass(active),
				$elm$svg$Svg$Attributes$x('0px'),
				$elm$svg$Svg$Attributes$y('0px'),
				$elm$svg$Svg$Attributes$width('17px'),
				$elm$svg$Svg$Attributes$height('22.4px'),
				$elm$svg$Svg$Attributes$viewBox('0 0 17 22.4'),
				$elm$svg$Svg$Attributes$fill('currentColor')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M16.5,19.901c0,1.104-0.896,2-2,2H2.5c-1.104,0-2-0.896-2-2V2.5c0-1.104,0.896-2,2-2H14.5c1.104,0,2,0.896,2,2V19.901z M8.532,5.334c0-0.166-0.135-0.3-0.301-0.3H3.832c-0.166,0-0.3,0.134-0.3,0.3v1.4c0,0.166,0.134,0.3,0.3,0.3h4.399 c0.166,0,0.301-0.134,0.301-0.3V5.334z M12.732,9.334c0-0.166-0.135-0.3-0.301-0.3H3.832c-0.166,0-0.3,0.134-0.3,0.3v1.4 c0,0.166,0.134,0.301,0.3,0.301h8.599c0.166,0,0.301-0.135,0.301-0.301V9.334z M11.958,13.309c-1.656,0-3,1.344-3,3 c0,1.657,1.344,3,3,3c1.657,0,3-1.343,3-3C14.958,14.653,13.616,13.309,11.958,13.309z M9.205,13.035H3.832 c-0.166,0-0.3,0.134-0.3,0.299v1.4c0,0.166,0.134,0.301,0.3,0.301h4.042C8.121,14.244,8.585,13.556,9.205,13.035z')
					]),
				_List_Nil)
			]));
};
var $author$project$PriceListForm$advancedComponentSummaryHelp = F5(
	function (translations, tp, index, active, title) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-grey-700 underline text-sm'),
					$elm$html$Html$Attributes$class('hover:text-black focus:text-black'),
					$elm$html$Html$Attributes$type_('button'),
					$elm$html$Html$Events$onClick(
					A2($author$project$PriceListForm$OpenAdvancedComponentDialogButtonClicked, tp, index)),
					$elm$html$Html$Attributes$title(
					title + (' - ' + A2($author$project$Enectiva$I18n$t, translations, 'change_adv_price')))
				]),
			_List_fromArray(
				[
					$author$project$SvgIcons$listMoney(active)
				]));
	});
var $author$project$PriceListForm$advancedComponentSummary = F6(
	function (translations, distributors, currency, tp, index, component) {
		switch (component.$) {
			case 0:
				return A5(
					$author$project$PriceListForm$advancedComponentSummaryHelp,
					translations,
					tp,
					index,
					false,
					A2($author$project$Enectiva$I18n$t, translations, 'price_list.advanced_component.not_set'));
			case 1:
				var rate = component.a;
				return A5(
					$author$project$PriceListForm$advancedComponentSummaryHelp,
					translations,
					tp,
					index,
					true,
					A3(
						$author$project$Enectiva$I18n$tt,
						translations,
						'price_js_list_adv_fixed',
						_List_fromArray(
							[
								A2(
								$author$project$Enectiva$I18n$Placeholder,
								'value',
								A2($author$project$View$formatNumberWithNbsp, translations, rate) + (' ' + currency))
							])));
			default:
				var key = component.a;
				return A5(
					$author$project$PriceListForm$advancedComponentSummaryHelp,
					translations,
					tp,
					index,
					true,
					A2($author$project$PriceListForm$distributorName, distributors, key));
		}
	});
var $author$project$PriceListForm$DatePicked = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$PriceListForm$DateRangeField = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$SvgIcons$calendar = function (svgClasses) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$x('0px'),
				$elm$svg$Svg$Attributes$y('0px'),
				$elm$svg$Svg$Attributes$width('21px'),
				$elm$svg$Svg$Attributes$height('21.6px'),
				$elm$svg$Svg$Attributes$viewBox('-1.5 1.498 21 21.6'),
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$class('line-icon -mt-px')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M13.111,17.52c-0.199,0-0.361,0.163-0.361,0.363v1.715c0,0.199,0.162,0.361,0.361,0.361H15.3c0.2,0,0.362-0.162,0.362-0.361 v-1.715c0-0.2-0.162-0.363-0.362-0.363H13.111z M7.906,17.52c-0.2,0-0.363,0.163-0.363,0.363v1.715c0,0.199,0.163,0.361,0.363,0.361 h2.188c0.2,0,0.363-0.162,0.363-0.361v-1.715c0-0.2-0.163-0.363-0.363-0.363H7.906z M2.641,17.52c-0.2,0-0.363,0.163-0.363,0.363 v1.715c0,0.199,0.163,0.361,0.363,0.361h2.188c0.2,0,0.363-0.162,0.363-0.361v-1.715c0-0.2-0.163-0.363-0.363-0.363H2.641z M13.111,13.795c-0.199,0-0.361,0.162-0.361,0.361v1.715c0,0.2,0.162,0.363,0.361,0.363H15.3c0.2,0,0.362-0.163,0.362-0.363v-1.715 c0-0.199-0.162-0.361-0.362-0.361H13.111z M7.906,13.795c-0.2,0-0.363,0.162-0.363,0.361v1.715c0,0.2,0.163,0.363,0.363,0.363h2.188 c0.2,0,0.363-0.163,0.363-0.363v-1.715c0-0.199-0.163-0.361-0.363-0.361H7.906z M2.641,13.795c-0.2,0-0.363,0.162-0.363,0.361v1.715 c0,0.2,0.163,0.363,0.363,0.363h2.188c0.2,0,0.363-0.163,0.363-0.363v-1.715c0-0.199-0.163-0.361-0.363-0.361H2.641z M13.111,9.924 c-0.199,0-0.361,0.163-0.361,0.363v1.715c0,0.2,0.162,0.363,0.361,0.363H15.3c0.2,0,0.362-0.163,0.362-0.363v-1.715 c0-0.2-0.162-0.363-0.362-0.363H13.111z M7.906,9.924c-0.2,0-0.363,0.163-0.363,0.363v1.715c0,0.2,0.163,0.363,0.363,0.363h2.188 c0.197,0,0.363-0.166,0.363-0.363v-1.715c0-0.2-0.163-0.363-0.363-0.363H7.906z M2.641,9.924c-0.2,0-0.363,0.163-0.363,0.363v1.715 c0,0.2,0.163,0.363,0.363,0.363h2.188c0.197,0,0.363-0.166,0.363-0.363v-1.715c0-0.2-0.163-0.363-0.363-0.363H2.641z M13.249,2.146 c-0.226,0-0.408,0.183-0.408,0.408v3.016c0,0.224,0.183,0.407,0.408,0.407h1.158c0.225,0,0.407-0.183,0.407-0.407V2.554 c0-0.225-0.183-0.408-0.407-0.408H13.249z M3.597,2.146c-0.225,0-0.408,0.183-0.408,0.408v3.016c0,0.224,0.183,0.407,0.408,0.407 h1.159c0.224,0,0.407-0.183,0.407-0.407V2.554c0-0.225-0.183-0.408-0.407-0.408H3.597z M18.462,4.424h-2.188 c-0.114,0-0.114,0.007-0.114,0.064v0.954c0,1.111-0.69,1.801-1.802,1.801h-1.068c-1.077,0-1.801-0.724-1.801-1.801V4.538 c0-0.099-0.069-0.114-0.111-0.114H6.665c-0.128,0-0.153,0.01-0.153,0.122v0.896c0,1.145-0.656,1.801-1.801,1.801H3.643 c-1.212,0-1.802-0.589-1.802-1.801V4.581c0-0.149-0.156-0.157-0.187-0.157h-2.116c-0.321,0-0.389,0.428-0.389,0.788V22.32 c0.016,0.008,0.032,0.016,0.05,0.024c0.09,0.044,0.212,0.104,0.338,0.104h18.923c0.126,0,0.248-0.06,0.338-0.104 c0.018-0.009,0.034-0.017,0.05-0.024V5.212C18.85,4.853,18.782,4.424,18.462,4.424z M17.654,20.865c0,0.211-0.178,0.389-0.388,0.389 H0.734c-0.214,0-0.388-0.174-0.388-0.389V8.71c0-0.214,0.174-0.388,0.388-0.388h16.532c0.21,0,0.388,0.178,0.388,0.388V20.865z')
					]),
				_List_Nil)
			]));
};
var $author$project$View$dateDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		var _v0 = $justinmimbs$date$Date$fromIsoString(s);
		if (_v0.$ === 1) {
			var err = _v0.a;
			return $elm$json$Json$Decode$fail(err);
		} else {
			var d = _v0.a;
			return $elm$json$Json$Decode$succeed(d);
		}
	},
	$elm$json$Json$Decode$string);
var $justinmimbs$time_extra$Time$Extra$Parts = F7(
	function (year, month, day, hour, minute, second, millisecond) {
		return {fJ: day, ed: hour, ez: millisecond, eB: minute, gr: month, e5: second, hB: year};
	});
var $justinmimbs$date$Date$toRataDie = function (_v0) {
	var rd = _v0;
	return rd;
};
var $justinmimbs$time_extra$Time$Extra$dateToMillis = function (date) {
	var daysSinceEpoch = $justinmimbs$date$Date$toRataDie(date) - 719163;
	return daysSinceEpoch * 86400000;
};
var $justinmimbs$time_extra$Time$Extra$timeFromClock = F4(
	function (hour, minute, second, millisecond) {
		return (((hour * 3600000) + (minute * 60000)) + (second * 1000)) + millisecond;
	});
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $elm$time$Time$toMillis = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			1000,
			$elm$time$Time$posixToMillis(time));
	});
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $elm$time$Time$toSecond = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				1000));
	});
var $justinmimbs$time_extra$Time$Extra$timeFromPosix = F2(
	function (zone, posix) {
		return A4(
			$justinmimbs$time_extra$Time$Extra$timeFromClock,
			A2($elm$time$Time$toHour, zone, posix),
			A2($elm$time$Time$toMinute, zone, posix),
			A2($elm$time$Time$toSecond, zone, posix),
			A2($elm$time$Time$toMillis, zone, posix));
	});
var $justinmimbs$time_extra$Time$Extra$toOffset = F2(
	function (zone, posix) {
		var millis = $elm$time$Time$posixToMillis(posix);
		var localMillis = $justinmimbs$time_extra$Time$Extra$dateToMillis(
			A2($justinmimbs$date$Date$fromPosix, zone, posix)) + A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix);
		return ((localMillis - millis) / 60000) | 0;
	});
var $justinmimbs$time_extra$Time$Extra$posixFromDateTime = F3(
	function (zone, date, time) {
		var millis = $justinmimbs$time_extra$Time$Extra$dateToMillis(date) + time;
		var offset0 = A2(
			$justinmimbs$time_extra$Time$Extra$toOffset,
			zone,
			$elm$time$Time$millisToPosix(millis));
		var posix1 = $elm$time$Time$millisToPosix(millis - (offset0 * 60000));
		var offset1 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, posix1);
		if (_Utils_eq(offset0, offset1)) {
			return posix1;
		} else {
			var posix2 = $elm$time$Time$millisToPosix(millis - (offset1 * 60000));
			var offset2 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, posix2);
			return _Utils_eq(offset1, offset2) ? posix2 : posix1;
		}
	});
var $justinmimbs$time_extra$Time$Extra$partsToPosix = F2(
	function (zone, _v0) {
		var year = _v0.hB;
		var month = _v0.gr;
		var day = _v0.fJ;
		var hour = _v0.ed;
		var minute = _v0.eB;
		var second = _v0.e5;
		var millisecond = _v0.ez;
		return A3(
			$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
			zone,
			A3($justinmimbs$date$Date$fromCalendarDate, year, month, day),
			A4(
				$justinmimbs$time_extra$Time$Extra$timeFromClock,
				A3($elm$core$Basics$clamp, 0, 23, hour),
				A3($elm$core$Basics$clamp, 0, 59, minute),
				A3($elm$core$Basics$clamp, 0, 59, second),
				A3($elm$core$Basics$clamp, 0, 999, millisecond)));
	});
var $author$project$Enectiva$I18n$dateToMidnight = function (date) {
	return A2(
		$justinmimbs$time_extra$Time$Extra$partsToPosix,
		$elm$time$Time$utc,
		A7(
			$justinmimbs$time_extra$Time$Extra$Parts,
			$justinmimbs$date$Date$year(date),
			$justinmimbs$date$Date$month(date),
			$justinmimbs$date$Date$day(date),
			0,
			0,
			0,
			0));
};
var $author$project$Enectiva$I18n$defaultDateFormatName = 'date.formats.date_js';
var $author$project$Enectiva$I18n$fourDigitYear = function (zone) {
	return A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$fromPosix(zone),
		A2($elm$core$Basics$composeR, $justinmimbs$date$Date$year, $elm$core$String$fromInt));
};
var $author$project$Enectiva$I18n$oneDigitMonth = function (zone) {
	return A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$fromPosix(zone),
		A2($elm$core$Basics$composeR, $justinmimbs$date$Date$monthNumber, $elm$core$String$fromInt));
};
var $author$project$Enectiva$I18n$monthAbbr = F2(
	function (translations, zone) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Enectiva$I18n$oneDigitMonth(zone),
			function (number) {
				return A2($author$project$Enectiva$I18n$t, translations, 'date.abbr_month_names.' + number);
			});
	});
var $author$project$Enectiva$I18n$oneDigit24Hour = function (zone) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$time$Time$toHour(zone),
		$elm$core$String$fromInt);
};
var $author$project$Enectiva$I18n$oneDigitDay = function (zone) {
	return A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$fromPosix(zone),
		A2($elm$core$Basics$composeR, $justinmimbs$date$Date$day, $elm$core$String$fromInt));
};
var $author$project$Enectiva$I18n$twoDigits = A2($elm$core$String$padLeft, 2, '0');
var $author$project$Enectiva$I18n$twoDigit24Hour = function (zone) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$time$Time$toHour(zone),
		A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $author$project$Enectiva$I18n$twoDigits));
};
var $author$project$Enectiva$I18n$twoDigitDay = function (zone) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Enectiva$I18n$oneDigitDay(zone),
		$author$project$Enectiva$I18n$twoDigits);
};
var $author$project$Enectiva$I18n$twoDigitMinute = function (zone) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$time$Time$toMinute(zone),
		A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $author$project$Enectiva$I18n$twoDigits));
};
var $author$project$Enectiva$I18n$twoDigitMonth = function (zone) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Enectiva$I18n$oneDigitMonth(zone),
		$author$project$Enectiva$I18n$twoDigits);
};
var $author$project$Enectiva$I18n$twoDigitSecond = function (zone) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$time$Time$toSecond(zone),
		A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $author$project$Enectiva$I18n$twoDigits));
};
var $author$project$Enectiva$I18n$twoDigitYear = function (zone) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Enectiva$I18n$fourDigitYear(zone),
		$elm$core$String$right(2));
};
var $author$project$Enectiva$I18n$dateReplacers = F2(
	function (translations, zone) {
		return _List_fromArray(
			[
				_Utils_Tuple2(
				'yyyy',
				$author$project$Enectiva$I18n$fourDigitYear(zone)),
				_Utils_Tuple2(
				'yy',
				$author$project$Enectiva$I18n$twoDigitYear(zone)),
				_Utils_Tuple2(
				'MMM',
				A2($author$project$Enectiva$I18n$monthAbbr, translations, zone)),
				_Utils_Tuple2(
				'MM',
				$author$project$Enectiva$I18n$twoDigitMonth(zone)),
				_Utils_Tuple2(
				'M',
				$author$project$Enectiva$I18n$oneDigitMonth(zone)),
				_Utils_Tuple2(
				'dd',
				$author$project$Enectiva$I18n$twoDigitDay(zone)),
				_Utils_Tuple2(
				'd',
				$author$project$Enectiva$I18n$oneDigitDay(zone)),
				_Utils_Tuple2(
				'HH',
				$author$project$Enectiva$I18n$twoDigit24Hour(zone)),
				_Utils_Tuple2(
				'H',
				$author$project$Enectiva$I18n$oneDigit24Hour(zone)),
				_Utils_Tuple2(
				'mm',
				$author$project$Enectiva$I18n$twoDigitMinute(zone)),
				_Utils_Tuple2(
				'ss',
				$author$project$Enectiva$I18n$twoDigitSecond(zone))
			]);
	});
var $elm$regex$Regex$find = _Regex_findAtMost(_Regex_infinity);
var $elm_community$list_extra$List$Extra$findMap = F2(
	function (f, list) {
		findMap:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var a = list.a;
				var tail = list.b;
				var _v1 = f(a);
				if (!_v1.$) {
					var b = _v1.a;
					return $elm$core$Maybe$Just(b);
				} else {
					var $temp$f = f,
						$temp$list = tail;
					f = $temp$f;
					list = $temp$list;
					continue findMap;
				}
			}
		}
	});
var $author$project$Enectiva$I18n$replacePlaceholders = F3(
	function (replacers, time, placeholder) {
		return function (replacer) {
			if (!replacer.$) {
				var r = replacer.a;
				return r(time);
			} else {
				return '';
			}
		}(
			A2(
				$elm_community$list_extra$List$Extra$findMap,
				function (_v0) {
					var p = _v0.a;
					var dr = _v0.b;
					return _Utils_eq(p, placeholder) ? $elm$core$Maybe$Just(dr) : $elm$core$Maybe$Nothing;
				},
				replacers));
	});
var $author$project$Enectiva$I18n$formatDateTimeCustomPattern = F4(
	function (pattern, translations, zone, time) {
		var replacers = A2($author$project$Enectiva$I18n$dateReplacers, translations, zone);
		var placeholdersRegex = function (s) {
			return '(' + (s + ')');
		}(
			A2(
				$elm$core$String$join,
				'|',
				A2($elm$core$List$map, $elm$core$Tuple$first, replacers)));
		var primaryRegex = A2(
			$elm$core$Maybe$withDefault,
			$elm$regex$Regex$never,
			$elm$regex$Regex$fromString('(.*?)' + placeholdersRegex));
		return A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (i, matches) {
						var _v0 = matches.he;
						_v0$2:
						while (true) {
							if (_v0.b) {
								if (_v0.a.$ === 1) {
									if ((_v0.b.b && (!_v0.b.a.$)) && (!_v0.b.b.b)) {
										var _v1 = _v0.a;
										var _v2 = _v0.b;
										var placeholder = _v2.a.a;
										return A3($author$project$Enectiva$I18n$replacePlaceholders, replacers, time, placeholder);
									} else {
										break _v0$2;
									}
								} else {
									if ((_v0.b.b && (!_v0.b.a.$)) && (!_v0.b.b.b)) {
										var literal = _v0.a.a;
										var _v3 = _v0.b;
										var placeholder = _v3.a.a;
										return _Utils_ap(
											literal,
											A3($author$project$Enectiva$I18n$replacePlaceholders, replacers, time, placeholder));
									} else {
										break _v0$2;
									}
								}
							} else {
								break _v0$2;
							}
						}
						return matches.it;
					}),
				A2($elm$regex$Regex$find, primaryRegex, pattern)));
	});
var $author$project$Enectiva$I18n$formatDateTimePreDefinedTemplate = F2(
	function (formatKey, translations) {
		return A2(
			$author$project$Enectiva$I18n$formatDateTimeCustomPattern,
			A2($author$project$Enectiva$I18n$t, translations, formatKey),
			translations);
	});
var $author$project$Enectiva$I18n$formatDate = F2(
	function (translations, date) {
		return A4(
			$author$project$Enectiva$I18n$formatDateTimePreDefinedTemplate,
			$author$project$Enectiva$I18n$defaultDateFormatName,
			translations,
			$elm$time$Time$utc,
			$author$project$Enectiva$I18n$dateToMidnight(date));
	});
var $author$project$View$datePickerInput = F4(
	function (translations, opts, msg, date) {
		var attrs = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$justinmimbs$date$Date$toIsoString,
						$elm$html$Html$Attributes$attribute('data-datepicker-min-value')),
					opts.b5),
					A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$justinmimbs$date$Date$toIsoString,
						$elm$html$Html$Attributes$attribute('data-datepicker-max-value')),
					opts.b4)
				]));
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				attrs,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('inline-flex items-center justify-between w-40 bg-white'),
						$elm$html$Html$Attributes$class('textfield p-0 pr-1 focus-within:border-grey-800'),
						$elm$html$Html$Attributes$class('relative'),
						$elm$html$Html$Attributes$class(opts.bS),
						A2($elm$html$Html$Attributes$attribute, 'data-controller', 'datepicker'),
						A2($elm$html$Html$Attributes$attribute, 'data-datepicker-current-class', 'current'),
						A2(
						$elm$html$Html$Attributes$attribute,
						'data-datepicker-date-format-value',
						A2($author$project$Enectiva$I18n$t, translations, 'date.formats.picker_js')),
						A2(
						$elm$html$Html$Attributes$attribute,
						'data-datepicker-locale-value',
						$author$project$Enectiva$I18n$locale(translations)),
						$elm$html$Html$Attributes$title(
						A2($author$project$Enectiva$I18n$formatDate, translations, date)),
						A2(
						$elm$html$Html$Events$on,
						'datepicker:date-picked',
						A2(
							$elm$json$Json$Decode$map,
							msg,
							A2(
								$elm$json$Json$Decode$field,
								'detail',
								A2($elm$json$Json$Decode$field, 'date', $author$project$View$dateDecoder))))
					])),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('text'),
							$elm$html$Html$Attributes$class('textfield border-none outline-none min-w-0 flex-1 box-content m-0'),
							$elm$html$Html$Attributes$value(
							A2($author$project$Enectiva$I18n$formatDate, translations, date)),
							A2($elm$html$Html$Attributes$attribute, 'data-datepicker-target', 'input')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('button'),
							A2($elm$html$Html$Attributes$attribute, 'data-datepicker-target', 'toggle'),
							$elm$html$Html$Attributes$class('shrink-0 box-content')
						]),
					_List_fromArray(
						[
							$author$project$SvgIcons$calendar('line-icon')
						]))
				]));
	});
var $author$project$PriceListForm$datePickerInput = F6(
	function (translations, tp, costIndex, date, opts, field) {
		return A4(
			$author$project$View$datePickerInput,
			translations,
			opts,
			$author$project$PriceListForm$DatePicked(
				A3($author$project$PriceListForm$DateRangeField, tp, costIndex, field)),
			date);
	});
var $author$project$View$datePickerMax = F2(
	function (max, opts) {
		return _Utils_update(
			opts,
			{
				b4: $elm$core$Maybe$Just(max)
			});
	});
var $author$project$View$datePickerMin = F2(
	function (min, opts) {
		return _Utils_update(
			opts,
			{
				b5: $elm$core$Maybe$Just(min)
			});
	});
var $author$project$View$datePickerOpts = {bS: '', b4: $elm$core$Maybe$Nothing, b5: $elm$core$Maybe$Nothing};
var $author$project$BareTime$asMinutes = A2(
	$elm$core$Basics$composeR,
	$author$project$BareTime$toComponents,
	function (_v0) {
		var hours = _v0.a;
		var minutes = _v0.b;
		return (hours * 60) + minutes;
	});
var $author$project$BareTime$diff = F3(
	function (stepInMinutes, from, to) {
		return (($author$project$BareTime$asMinutes(to) - $author$project$BareTime$asMinutes(from)) / stepInMinutes) | 0;
	});
var $author$project$PriceListForm$EditCostButtonClicked = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$PriceListForm$periodCell = F6(
	function (translations, currency, unit, tp, costIndex, segment) {
		var name = segment.gu;
		var from = segment.q;
		var length = segment.bf;
		var unitPrice = A2($author$project$PriceListForm$formatUnitPrice, translations, segment) + (' ' + (currency + ('/' + unit)));
		return A2(
			$elm$html$Html$td,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$colspan(length),
					A2(
					$elm$html$Html$Attributes$style,
					'background-color',
					$author$project$Palette$fromString(name)),
					$elm$html$Html$Attributes$class('text-center'),
					$elm$html$Html$Attributes$title(unitPrice)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('button'),
							$elm$html$Html$Attributes$class('bg-white rounded px-2 py-1 shadow'),
							$elm$html$Html$Attributes$class('hover:shadow-md focus:shadow-md'),
							$elm$html$Html$Events$onClick(
							A2($author$project$PriceListForm$EditCostButtonClicked, tp, costIndex)),
							$elm$html$Html$Attributes$title(
							unitPrice + (' - ' + A2($author$project$Enectiva$I18n$t, translations, 'edit')))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(name)
						]))
				]));
	});
var $author$project$PriceListForm$tariffAndPeriodCells = F6(
	function (translations, currency, unit, tp, costIndex, c) {
		return A2(
			$elm$core$List$map,
			A5($author$project$PriceListForm$periodCell, translations, currency, unit, tp, costIndex),
			function (segments) {
				return A3(
					$elm$core$List$map2,
					F2(
						function (segment, end) {
							return _Utils_update(
								segment,
								{
									bf: A3($author$project$BareTime$diff, 5, segment.q, end)
								});
						}),
					segments,
					A2(
						$elm$core$List$drop,
						1,
						function (ends) {
							return _Utils_ap(
								ends,
								_List_fromArray(
									[2400]));
						}(
							A2(
								$elm$core$List$map,
								function ($) {
									return $.q;
								},
								segments))));
			}(
				A2(
					$elm$core$List$sortBy,
					function ($) {
						return $.q;
					},
					$elm$core$List$concat(
						A2(
							$elm$core$List$indexedMap,
							F2(
								function (i, t) {
									return A2(
										$elm$core$List$map,
										function (p) {
											return {q: p.q, bf: 0, gu: t.gu, _: t._};
										},
										$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(t.s));
								}),
							$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(c.f))))));
	});
var $author$project$PriceListForm$costRow = F8(
	function (translations, distributors, currency, unit, allowDelete, tp, index, _v0) {
		var c = _v0.a;
		var fromModifier = _v0.b;
		var toModifier = _v0.c;
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-right')
							]),
						_List_fromArray(
							[
								A6(
								$author$project$PriceListForm$datePickerInput,
								translations,
								tp,
								index,
								c.S,
								fromModifier(
									A2($author$project$View$datePickerMax, c.I, $author$project$View$datePickerOpts)),
								0)
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-grey-600 text-center')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(' – ')
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								A6(
								$author$project$PriceListForm$datePickerInput,
								translations,
								tp,
								index,
								c.I,
								toModifier(
									A2($author$project$View$datePickerMin, c.S, $author$project$View$datePickerOpts)),
								1)
							]))
					]),
				_Utils_ap(
					A6($author$project$PriceListForm$tariffAndPeriodCells, translations, currency, unit, tp, index, c),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-right')
								]),
							_List_fromArray(
								[
									A6($author$project$PriceListForm$advancedComponentSummary, translations, distributors, currency, tp, index, c.z)
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-right')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Enectiva$View$viewIf,
									$elm$core$Basics$always(
										A2(
											$author$project$PriceListForm$deleteButton,
											translations,
											A2($author$project$PriceListForm$RemoveCostButtonClicked, tp, index))),
									allowDelete)
								]))
						]))));
	});
var $author$project$PriceListForm$tariffBreakdownHeaderCells = A2(
	$elm$core$List$map,
	function (h) {
		return A2(
			$elm$html$Html$th,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$colspan(12),
					$elm$html$Html$Attributes$class('bg-grey-300 text-center')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$elm$core$String$fromInt(h))
				]));
	},
	A2($elm$core$List$range, 0, 23));
var $author$project$PriceListForm$next = F2(
	function (i, list) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Basics$identity,
			$elm$core$List$head(
				A2(
					$elm$core$List$filterMap,
					function (_v0) {
						var index = _v0.a;
						var c = _v0.b;
						return _Utils_eq(index, i + 1) ? $elm$core$Maybe$Just(
							$author$project$View$datePickerMax(
								A3($justinmimbs$date$Date$add, 3, -1, c.I))) : $elm$core$Maybe$Nothing;
					},
					list)));
	});
var $author$project$PriceListForm$prev = F2(
	function (i, list) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Basics$identity,
			$elm$core$List$head(
				A2(
					$elm$core$List$filterMap,
					function (_v0) {
						var index = _v0.a;
						var c = _v0.b;
						return _Utils_eq(index, i - 1) ? $elm$core$Maybe$Just(
							$author$project$View$datePickerMin(
								A3($justinmimbs$date$Date$add, 3, 1, c.S))) : $elm$core$Maybe$Nothing;
					},
					list)));
	});
var $author$project$PriceListForm$withNeighborRanges = function (list) {
	var indexedList = A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, list);
	return A2(
		$elm$core$List$map,
		function (_v0) {
			var i = _v0.a;
			var x = _v0.b;
			return _Utils_Tuple3(
				x,
				A2($author$project$PriceListForm$prev, i, indexedList),
				A2($author$project$PriceListForm$next, i, indexedList));
		},
		indexedList);
};
var $author$project$PriceListForm$costsTable = F6(
	function (translations, distributors, currency, unit, tp, costs) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$table,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('list w-full')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$thead,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									A2(
										$elm$core$List$cons,
										A2(
											$elm$html$Html$th,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('bg-grey-300'),
													$elm$html$Html$Attributes$colspan(3)
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('text-center')
														]),
													_List_fromArray(
														[
															A2($author$project$View$tt, translations, 'price_list.validity')
														]))
												])),
										_Utils_ap(
											$author$project$PriceListForm$tariffBreakdownHeaderCells,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$th,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('bg-grey-300')
														]),
													_List_Nil),
													A2(
													$elm$html$Html$th,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('bg-grey-300')
														]),
													_List_Nil)
												]))))
								])),
							A2(
							$elm$html$Html$tbody,
							_List_Nil,
							A2(
								$elm$core$List$indexedMap,
								A6(
									$author$project$PriceListForm$costRow,
									translations,
									distributors,
									currency,
									unit,
									!$turboMaCk$non_empty_list_alias$List$NonEmpty$isSingleton(costs),
									tp),
								$author$project$PriceListForm$withNeighborRanges(
									$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(costs))))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('self-end')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$PriceListForm$addNewButton,
							A2($author$project$Enectiva$I18n$t, translations, 'cost_add'),
							$author$project$PriceListForm$AddNewCostButtonClicked(tp))
						]))
				]));
	});
var $author$project$PriceListForm$ExceptionalCostUseToggleChecked = function (a) {
	return {$: 15, a: a};
};
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $elm$html$Html$Events$targetChecked = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'checked']),
	$elm$json$Json$Decode$bool);
var $elm$html$Html$Events$onCheck = function (tagger) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetChecked));
};
var $author$project$View$toggleInnerHelp = F4(
	function (translations, msg, texts, checked) {
		var attrs = texts ? _List_fromArray(
			[
				A2(
				$elm$html$Html$Attributes$attribute,
				'data-yes',
				A2($author$project$Enectiva$I18n$t, translations, 'text.yes')),
				A2(
				$elm$html$Html$Attributes$attribute,
				'data-no',
				A2($author$project$Enectiva$I18n$t, translations, 'text.no'))
			]) : _List_fromArray(
			[
				$elm$html$Html$Attributes$class('bg-blue-600')
			]);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('checkbox'),
						$elm$html$Html$Attributes$checked(checked),
						$elm$html$Html$Events$onCheck(msg)
					]),
				_List_Nil),
				A2(
				$elm$html$Html$div,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('boolean-toggle__handle outline-none hover:bg-grey-800 focus:bg-grey-800'),
					attrs),
				_List_Nil)
			]);
	});
var $author$project$View$toggleHelp = F3(
	function (translations, msg, checked) {
		return A4($author$project$View$toggleInnerHelp, translations, msg, true, checked);
	});
var $author$project$View$toggleWithClass = F5(
	function (translations, cls, txt, msg, checked) {
		return A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex items-center gap-2'),
					$elm$html$Html$Attributes$class(cls)
				]),
			_List_fromArray(
				[
					txt,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('boolean-toggle')
						]),
					A3($author$project$View$toggleHelp, translations, msg, checked))
				]));
	});
var $author$project$View$toggle = F4(
	function (translations, txt, msg, checked) {
		return A5($author$project$View$toggleWithClass, translations, '', txt, msg, checked);
	});
var $author$project$PriceListForm$exceptionalCostsToggle = F2(
	function (translations, checked) {
		return A4(
			$author$project$View$toggle,
			translations,
			A2($author$project$View$tt, translations, 'price_list.exceptional_costs.use'),
			$author$project$PriceListForm$ExceptionalCostUseToggleChecked,
			checked);
	});
var $elm$html$Html$h2 = _VirtualDom_node('h2');
var $author$project$PriceListForm$tableHeading = function (content) {
	return A2(
		$elm$html$Html$h2,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('text-xl font-bold')
			]),
		_List_fromArray(
			[content]));
};
var $author$project$PriceListForm$exceptionalCosts = function (model) {
	var translations = model.Z;
	var distributors = model.bV;
	var currency = model.bC;
	var unit = model.da;
	var _v0 = model.v;
	if (_v0.$ === 1) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex justify-end')
				]),
			_List_fromArray(
				[
					A2($author$project$PriceListForm$exceptionalCostsToggle, translations, false)
				]));
	} else {
		var costs = _v0.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('space-y-2')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex justify-between')
						]),
					_List_fromArray(
						[
							$author$project$PriceListForm$tableHeading(
							A2($author$project$View$tt, translations, 'price_list.exceptional_costs.heading')),
							A2($author$project$PriceListForm$exceptionalCostsToggle, translations, true)
						])),
					A6($author$project$PriceListForm$costsTable, translations, distributors, currency, unit, 1, costs)
				]));
	}
};
var $elm$html$Html$form = _VirtualDom_node('form');
var $author$project$PriceListForm$ServerError = function (a) {
	return {$: 3, a: a};
};
var $author$project$PriceListForm$ExceptionalCostsRangeDoesNotMatchRegular = {$: 2};
var $author$project$PriceListForm$costsValidityRange = function (costs) {
	return _Utils_Tuple2(
		$turboMaCk$non_empty_list_alias$List$NonEmpty$head(costs).S,
		$turboMaCk$non_empty_list_alias$List$NonEmpty$last(costs).I);
};
var $author$project$PriceListForm$costValidityRangeMismatch = F2(
	function (regular, exceptional) {
		return _Utils_eq(
			$author$project$PriceListForm$costsValidityRange(regular),
			$author$project$PriceListForm$costsValidityRange(exceptional)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just($author$project$PriceListForm$ExceptionalCostsRangeDoesNotMatchRegular);
	});
var $author$project$PriceListForm$globalErrors = function (model) {
	var translations = model.Z;
	var saveRequest = model.cX;
	var validityError = $elm_community$maybe_extra$Maybe$Extra$join(
		A2(
			$elm$core$Maybe$map,
			$author$project$PriceListForm$costValidityRangeMismatch(model.n),
			model.v));
	var serverError = function () {
		if (saveRequest.$ === 2) {
			var serverErrors = saveRequest.a;
			return $elm$core$Maybe$Just(
				$author$project$PriceListForm$ServerError(serverErrors));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}();
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[serverError, validityError]));
};
var $author$project$PriceListForm$globalErrorsView = F2(
	function (translations, errors) {
		if (!errors.b) {
			return $author$project$Enectiva$View$nothing;
		} else {
			var list = errors;
			return A2(
				$elm$html$Html$ul,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-red-600 error')
					]),
				A2(
					$elm$core$List$map,
					A2(
						$elm$core$Basics$composeR,
						$elm$html$Html$text,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$singleton,
							$elm$html$Html$li(_List_Nil))),
					A2(
						$elm$core$List$concatMap,
						$author$project$PriceListForm$errorToLocalizedString(translations),
						list)));
		}
	});
var $krisajenkins$remotedata$RemoteData$isLoading = function (data) {
	if (data.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $elm$html$Html$Attributes$name = $elm$html$Html$Attributes$stringProperty('name');
var $elm$html$Html$Events$alwaysPreventDefault = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $elm$html$Html$Events$onSubmit = function (msg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'submit',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysPreventDefault,
			$elm$json$Json$Decode$succeed(msg)));
};
var $author$project$PriceListForm$regularCosts = function (model) {
	var translations = model.Z;
	var distributors = model.bV;
	var currency = model.bC;
	var unit = model.da;
	var table = A6($author$project$PriceListForm$costsTable, translations, distributors, currency, unit, 0, model.n);
	var _v0 = model.v;
	if (_v0.$ === 1) {
		return table;
	} else {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('space-y-2')
				]),
			_List_fromArray(
				[
					$author$project$PriceListForm$tableHeading(
					A2($author$project$View$tt, translations, 'price_list.regular_costs.heading')),
					table
				]));
	}
};
var $author$project$PriceListForm$StringFieldEntered = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$PriceListForm$stringFieldToString = function (field) {
	if (!field) {
		return 'name';
	} else {
		return 'supplier';
	}
};
var $author$project$PriceListForm$stringField = F3(
	function (translations, field, value) {
		var placeholder = A2(
			$author$project$Enectiva$I18n$t,
			translations,
			'activerecord.attributes.price_list.' + $author$project$PriceListForm$stringFieldToString(field));
		return A2(
			$elm$html$Html$label,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lbl text-grey-700')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(placeholder)
						])),
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('textfield'),
							$elm$html$Html$Attributes$placeholder(placeholder),
							$author$project$View$onChange(
							$author$project$PriceListForm$StringFieldEntered(field)),
							$elm$html$Html$Attributes$value(value)
						]),
					_List_Nil)
				]));
	});
var $author$project$PriceListForm$formView = function (model) {
	var translations = model.Z;
	var errors = $author$project$PriceListForm$globalErrors(model);
	var submittable = A3(
		$elm$core$List$foldl,
		F2(
			function (e, s) {
				if (e.$ === 3) {
					return s;
				} else {
					return false;
				}
			}),
		true,
		errors);
	return A2(
		$elm$html$Html$form,
		_List_fromArray(
			[
				$elm$html$Html$Events$onSubmit($author$project$PriceListForm$FormSubmitted),
				$author$project$Spinner$container,
				$elm$html$Html$Attributes$class('gap-4 flex flex-col')
			]),
		_List_fromArray(
			[
				A2($author$project$PriceListForm$globalErrorsView, translations, errors),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex gap-4')
					]),
				_List_fromArray(
					[
						A3($author$project$PriceListForm$stringField, translations, 0, model.gu),
						A3($author$project$PriceListForm$stringField, translations, 1, model.ch)
					])),
				$author$project$PriceListForm$regularCosts(model),
				$author$project$PriceListForm$exceptionalCosts(model),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$name('button'),
								$elm$html$Html$Attributes$type_('submit'),
								$elm$html$Html$Attributes$class('submit-button'),
								$elm$html$Html$Attributes$disabled(!submittable)
							]),
						_List_fromArray(
							[
								A2($author$project$View$tt, translations, 'save_price')
							]))
					])),
				$author$project$Spinner$overlay(
				$krisajenkins$remotedata$RemoteData$isLoading(model.cX))
			]));
};
var $author$project$PriceListForm$view = function (model) {
	var translations = model.Z;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$PriceListForm$formView(model),
				$author$project$PriceListForm$advancedComponentsDialog(model),
				$author$project$PriceListForm$elPowerByCurrentAndBreakerPhasesDialog(model),
				$author$project$PriceListForm$costEditingDialog(model)
			]));
};
var $author$project$PriceListForm$main = $elm$browser$Browser$element(
	{
		im: $author$project$PriceListForm$init,
		ja: function (m) {
			if (!m.$) {
				var model = m.a;
				return $author$project$PriceListForm$subscriptions(model);
			} else {
				return $elm$core$Platform$Sub$none;
			}
		},
		jl: F2(
			function (msg, m) {
				if (!m.$) {
					var model = m.a;
					return A2(
						$elm$core$Tuple$mapFirst,
						$author$project$PriceListForm$ValidModel,
						A2($author$project$PriceListForm$update, msg, model));
				} else {
					return $author$project$Enectiva$Util$noCmd(m);
				}
			}),
		jn: function (m) {
			if (!m.$) {
				var model = m.a;
				return $author$project$PriceListForm$view(model);
			} else {
				var err = m.a;
				return $elm$html$Html$text(err);
			}
		}
	});
/*
_Platform_export({'PriceListForm':{'init':$author$project$PriceListForm$main($elm$json$Json$Decode$value)(0)}});}(this));
*/
export const Elm = {'PriceListForm':{'init':$author$project$PriceListForm$main($elm$json$Json$Decode$value)(0)}};
  